import React, { useState, useEffect, useCallback, useRef } from 'react';



import { createPortal } from 'react-dom';



import { useNavigate } from 'react-router-dom';



import { useAuth } from '../context/AuthContext';



import api from '../services/api';



import toast from '../utils/toast';



import AnnouncementBar from '../components/AnnouncementBar';



import Footer from '../components/Footer';



import ScrollToTop from '../components/ScrollToTop';



import TornPaperWrapper from '../components/TornPaperWrapper';

import ManualDashboardScanPanel from '../components/ManualDashboardScanPanel';

import RotatingQrImg from '../components/RotatingQrImg';



import './Dashboard.css';



import ReactCrop, { makeAspectCrop, centerCrop } from 'react-image-crop';

import 'react-image-crop/dist/ReactCrop.css';

import { getCmsImagePath } from '../cms/cmsData';



const SOCIAL_TOOLKIT_LAYOUT_VERSION = '2026-03-14-social-toolkit-v20';

const VOIDED_TICKET_STATUSES = new Set(['REFUNDED', 'CANCELLED', 'VOIDED']);

const isVoidedTicket = (ticket) => VOIDED_TICKET_STATUSES.has(ticket?.status);

const isVendorCompTicket = (ticket) => {
  const metadata = ticket?.metadata || {};
  const ticketTypeName = String(ticket?.ticket_type_name || metadata?.ticket_name || '').trim().toLowerCase();
  return (
    metadata?.type === 'festival_access' &&
    metadata?.complimentary === true &&
    Boolean(metadata?.granted_by_vendor_booth)
  ) || (
      ticketTypeName.includes('vendor') &&
      ticketTypeName.includes('complimentary')
    );
};

const isVendorBoothTicket = (ticket) => {
  const metadata = ticket?.metadata || {};
  const ticketTypeName = String(ticket?.ticket_type_name || metadata?.ticket_name || '').trim().toLowerCase();
  const metadataType = String(metadata?.type || '').trim().toLowerCase();
  const businessType = String(metadata?.business_type || '').trim().toLowerCase();
  const passType = String(metadata?.pass_type || '').trim().toLowerCase();

  return (
    metadataType === 'vendor-booth' ||
    ['food', 'bazaar', 'food-truck', 'food-booth'].includes(businessType) ||
    ['vendor-booth', 'food-truck', 'food-booth', 'bazaar'].some((term) => passType.includes(term)) ||
    ['vendor booth', 'food truck', 'food booth', 'bazaar'].some((term) => ticketTypeName.includes(term))
  );
};

const isWristbandTicket = (ticket) => {
  const metadata = ticket?.metadata || {};
  const rideType = String(metadata?.ride_type || '').trim().toLowerCase();
  const fulfillmentType = String(metadata?.fulfillment_type || '').trim().toUpperCase();
  const ticketTypeSlug = String(ticket?.ticket_type?.slug || '').trim().toLowerCase();
  const ticketTypeName = String(ticket?.ticket_type_name || '').trim().toLowerCase();

  return (
    metadata?.qr_disabled === true ||
    metadata?.wristband_assignment === true ||
    rideType === 'wristband' ||
    fulfillmentType === 'WRISTBAND_ASSIGNMENT' ||
    ticketTypeSlug.startsWith('ride-wb-') ||
    ticketTypeName.includes('wristband')
  );
};

const isParkingPassTicket = (ticket) => {
  const metadata = ticket?.metadata || {};
  const metadataType = String(metadata?.type || '').trim().toLowerCase();
  const fulfillmentType = String(metadata?.fulfillment_type || '').trim().toUpperCase();
  const ticketTypeSlug = String(ticket?.ticket_type?.slug || '').trim().toLowerCase();
  const ticketTypeName = String(ticket?.ticket_type_name || metadata?.ticket_name || '').trim().toLowerCase();

  return (
    metadata?.parking_pass_assignment === true ||
    fulfillmentType === 'VIP_PARKING_PASS' ||
    metadataType === 'parking_pass' ||
    metadataType === 'parking-pass' ||
    ticketTypeSlug === 'vip-parking-pass' ||
    (ticketTypeSlug.includes('parking') && ticketTypeSlug.includes('vip')) ||
    (ticketTypeName.includes('parking pass') && ticketTypeName.includes('vip'))
  );
};

const getVoidedTicketNotice = (ticket) => {
  const voidReason = (ticket?.metadata?.void_reason || '').toLowerCase();
  if (voidReason.includes('disput')) return 'This ticket has been disputed & voided';
  return ticket?.status === 'VOIDED' ? 'This ticket has been voided' : 'This ticket has been refunded & voided';
};

const DASHBOARD_TICKETS_PAGE_SIZE = 8;



const SOCIAL_TOOLKIT_VENDOR_TEXT_LAYOUT = {

  discountFontSizePct: 0.057,

  discountX: 0.275,

  discountY: 0.785,

  discountMaxWidthPct: 0.29,

  codeFontSizePct: 0.057,

  codeX: 0.67,

  codeY: 0.785,

  codeMaxWidthPct: 0.34,

};





const SOCIAL_TOOLKIT_COUPON_LAYOUTS = {

  a: { fontSizePct: 0.296, discountX: 0.500, discountY: 0.300, codeFontSizePct: 0.098, codeX: 0.500, codeY: 0.460, codeColor: '#FFFFFF', codeMaxWidthPct: 0.84, discountMaxWidthPct: 0.86 },

  b: { fontSizePct: 0.320, discountX: 0.500, discountY: 0.370, codeFontSizePct: 0.108, codeX: 0.500, codeY: 0.570, codeColor: '#000000', codeMaxWidthPct: 0.84, discountMaxWidthPct: 0.86 },

};



const IM_ATTENDING_LAYOUT = {

  fontSizePct: 0.036,

  discountX: 0.495,

  discountY: 0.710,

  discountMaxWidthPct: 0.75,

  discountColor: '#000000',

  codeFontSizePct: 0.080,

  codeX: 0.500,

  codeY: 0.765,

  codeColor: '#000000',

  codeMaxWidthPct: 0.75,

};



const SOCIAL_TOOLKIT_VENDOR_LOGO_LAYOUT = {

  centerXPct: 0.5,

  centerYPct: 0.569,

  heightPct: 0.22,

};



const FLAG_POST_COUNTRIES = {

  'North Africa': ['Algeria', 'Egypt', 'Libya', 'Morocco', 'Tunisia', 'Sudan'],

  'Middle East': ['Bahrain', 'Iraq', 'Jordan', 'Kuwait', 'Lebanon', 'Oman', 'Qatar', 'Saudi Arabia', 'Palestine', 'Syria', 'United Arab Emirates', 'Yemen', 'Iran'],

};



const FLAG_FILE_MAP = {

  'Algeria': 'Algeria@2x.webp',

  'Egypt': 'Egypt@2x.webp',

  'Libya': 'Libya@2x.webp',

  'Morocco': 'Morocco@2x.webp',

  'Tunisia': 'Tunisia@2x.webp',

  'Sudan': 'Sudan@2x.webp',

  'Bahrain': 'Bahrain@2x.webp',

  'Iraq': 'Iraq@2x.webp',

  'Jordan': 'Jordan@2x.webp',

  'Kuwait': 'Kuwait@2x.webp',

  'Lebanon': 'Lebanon@2x.webp',

  'Oman': 'Oman@2x.webp',

  'Qatar': 'Qatar@2x.webp',

  'Saudi Arabia': 'Saudi Arabia@2x.webp',

  'Palestine': 'Palestine@2x.webp',

  'Syria': 'Syria@2x.webp',

  'United Arab Emirates': 'UAE@2x.webp',

  'Yemen': 'Yemen@2x.webp',

  'Iran': 'Iran@2x.webp',

};



// Country name text position (defaults — can be tweaked via debugger)

const _FLAG_POST_TEXT_DEFAULTS = { // eslint-disable-line no-unused-vars

  countryY: 0.690,

  countryFontPct: 0.085,

  flagY: 0.760,

  flagHeightPct: 0.070,

};



// New flag post theme configs (v2 themes)

const FLAG_POST_THEMES = {

  dark: {

    label: 'Dark Theme',

    exampleSrc: getCmsImagePath('flagPostExample', '/MENA Roots Exports/OCMENA-MENA-Roots-Post-Example.webp'),

    templateSrc: getCmsImagePath('flagPostTemplate', '/MENA Roots Exports/OCMENA-MENA-Roots-Post-Template.webp'),

  },

  light: {

    label: 'Light Theme',

    exampleSrc: getCmsImagePath('flagPostExample1', '/MENA Roots Exports/OCMENA-MENA-Roots-Post-Example-1.webp'),

    templateSrc: getCmsImagePath('flagPostTemplate1', '/MENA Roots Exports/OCMENA-MENA-Roots-Post-Template-1.webp'),

  },

};



// Default layout for new flag post (photo area, country text, flag positions as percentages of canvas)

const FLAG_POST_V2_DEFAULTS = {

  photoX: 0.250,

  photoY: 0.370,

  photoSize: 0.515,

  countryY: 0.205,

  countryFontPct: 0.097,

  countryColor: '#FFFFFF',

  flagX: 0.500,

  flagY: 0.300,

  flagHeightPct: 0.075,

};

const FLAG_POST_V2_LIGHT_DEFAULTS = {

  ...FLAG_POST_V2_DEFAULTS,

  countryColor: '#000000',

};



const MENA_ROOTS_HELPER_STORY_ASSET_KEY = 'mena-roots-helper-story-post';

const MENA_ROOTS_HELPER_STORY_INSTRUCTIONS_SRC = '/MENA Roots Helper Story Post/MENA Roots Helper Post - Instructions.jpg';

const MENA_ROOTS_HELPER_STORY_TEMPLATE_SRC = '/MENA Roots Helper Story Post/MENA Roots Helper Post - Template.jpg';

const MENA_ROOTS_HELPER_STORY_LAYOUT = {

  x: 0.148,

  y: 0.055,

  width: 0.72,

  height: 0.51,

};



const setFittedCanvasFont = (ctx, text, maxWidth, initialSize, color) => {

  // Deterministic sizing: use character-count math instead of ctx.measureText()

  // which returns different values on different browsers/OS, causing desktop vs mobile mismatch.

  // Average char width ratio for "Arial Black" weight 900 is ~0.64 of font size.

  const AVG_CHAR_WIDTH = 0.64;

  let size = initialSize;

  while (size > 12) {

    const estimatedWidth = text.length * size * AVG_CHAR_WIDTH;

    if (estimatedWidth <= maxWidth) break;

    size -= 1;

  }

  ctx.font = `900 ${size}px "Arial Black", "Impact", sans-serif`;

  ctx.fillStyle = color;

  ctx.textAlign = 'center';

  ctx.textBaseline = 'middle';

  return size;

};



const getCoverDrawDimensions = (imageWidth, imageHeight, canvasWidth, canvasHeight) => {

  const imageAspect = imageWidth / imageHeight;

  const canvasAspect = canvasWidth / canvasHeight;



  if (imageAspect > canvasAspect) {

    const drawH = canvasHeight;

    const drawW = canvasHeight * imageAspect;

    return { drawW, drawH, drawX: -(drawW - canvasWidth) / 2, drawY: 0 };

  }



  const drawW = canvasWidth;

  const drawH = canvasWidth / imageAspect;

  return { drawW, drawH, drawX: 0, drawY: -(drawH - canvasHeight) / 2 };

};



const getContainDrawDimensions = (imageWidth, imageHeight, canvasWidth, canvasHeight) => {

  const imageAspect = imageWidth / imageHeight;

  const canvasAspect = canvasWidth / canvasHeight;



  if (imageAspect > canvasAspect) {

    const drawW = canvasWidth;

    const drawH = canvasWidth / imageAspect;

    return { drawW, drawH, drawX: 0, drawY: (canvasHeight - drawH) / 2 };

  }



  const drawH = canvasHeight;

  const drawW = canvasHeight * imageAspect;

  return { drawW, drawH, drawX: (canvasWidth - drawW) / 2, drawY: 0 };

};



const _drawGrayscaleCoverImage = (ctx, img, canvas) => { // eslint-disable-line no-unused-vars

  const { drawW, drawH, drawX, drawY } = getCoverDrawDimensions(

    img.naturalWidth || img.width,

    img.naturalHeight || img.height,

    canvas.width,

    canvas.height,

  );



  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.drawImage(img, drawX, drawY, drawW, drawH);



  try {

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    const { data } = imageData;

    for (let i = 0; i < data.length; i += 4) {

      const gray = Math.round((data[i] * 299 + data[i + 1] * 587 + data[i + 2] * 114) / 1000);

      data[i] = gray;

      data[i + 1] = gray;

      data[i + 2] = gray;

    }

    ctx.putImageData(imageData, 0, 0);

  } catch (err) {

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.save();

    ctx.filter = 'grayscale(100%)';

    ctx.drawImage(img, drawX, drawY, drawW, drawH);

    ctx.restore();

  }

};

const formatTransferDateTime = (value) => {
  if (!value) return '';
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return '';
  return dt.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  });
};

const formatTransferTimelineLabel = (transfer) => {
  const acceptedAt = formatTransferDateTime(transfer?.accepted_at);
  const createdAt = formatTransferDateTime(transfer?.created_at);
  const expiresAt = formatTransferDateTime(transfer?.expires_at);

  if (transfer?.status === 'ACCEPTED' && acceptedAt) {
    return createdAt ? `Accepted ${acceptedAt} · Sent ${createdAt}` : `Accepted ${acceptedAt}`;
  }

  if (transfer?.status === 'PENDING') {
    const sentPart = createdAt ? `Sent ${createdAt}` : 'Sent —';
    const expiresPart = expiresAt ? `Expires ${expiresAt}` : 'Expires —';
    return `Pending · ${sentPart} · ${expiresPart}`;
  }

  return createdAt ? `Created ${createdAt}` : '';
};

const formatTransferWhatLabel = (transfer) => {
  const details = transfer?.ticket_details || {};
  const section = String(details.section || '').trim();
  const row = String(details.row || '').trim();
  const seat = String(details.seat_number ?? '').trim();
  const eventDate = String(details.event_date || '').trim();
  const parts = [];
  if (section) parts.push(section);
  if (row) parts.push(`Row ${row}`);
  if (seat) parts.push(`Seat ${seat}`);
  if (eventDate) parts.push(eventDate);
  return parts.join(' · ');
};



const Dashboard = () => {



  const navigate = useNavigate();



  const { user, isAuthenticated, logout, updateUser } = useAuth();



  const [activeSection, setActiveSection] = useState(() => {

    if (typeof window === 'undefined') return 'dashboard';

    return new URLSearchParams(window.location.search).get('section') || 'dashboard';

  });

  const isSectionPopstateRef = useRef(false);

  const hasSectionHistorySyncedRef = useRef(false);



  const [ampDayTab, setAmpDayTab] = useState('all');



  const [ampTicketsPage, setAmpTicketsPage] = useState(1);



  const [festivalTicketsPage, setFestivalTicketsPage] = useState(1);



  const [parkingTicketsPage, setParkingTicketsPage] = useState(1);



  const [isSidebarOpen, setIsSidebarOpen] = useState(false);



  const [isMobileViewport, setIsMobileViewport] = useState(() => (typeof window !== 'undefined' ? window.innerWidth <= 768 : false));



  const [ampTabsStickyTop, setAmpTabsStickyTop] = useState(92);

  const ampTabsRef = useRef(null);

  const [isAmpTabsSticky, setIsAmpTabsSticky] = useState(false);

  const tabsOriginalTopRef = useRef(null);



  useEffect(() => {

    if (typeof document !== 'undefined') {

      document.body.classList.add('dashboard-active');

    }

    return () => {

      if (typeof document !== 'undefined') {

        document.body.classList.remove('dashboard-active');

      }

    };

  }, []);



  const [tickets, setTickets] = useState([]);



  const [orders, setOrders] = useState([]);



  const [loading, setLoading] = useState(true);



  const [transferModal, setTransferModal] = useState({ open: false, ticket: null, tickets: [] });



  // Removed transferName state



  const [transferEmail, setTransferEmail] = useState('');

  const [transferLabel, setTransferLabel] = useState('');

  const [transferLoading, setTransferLoading] = useState(false);



  const [transferError, setTransferError] = useState('');



  const [transferSuccess, setTransferSuccess] = useState('');



  const [sentTransfers, setSentTransfers] = useState([]);



  const [receivedTransfers, setReceivedTransfers] = useState([]);



  const [userProfile, setUserProfile] = useState(null);







  // Vendor documents state



  const [vendorDocuments, setVendorDocuments] = useState([]);



  const [documentUploading, setDocumentUploading] = useState({});



  const [docuSignCompleting, setDocuSignCompleting] = useState(false);

  const [pendingSignContract, setPendingSignContract] = useState(false);



  const [documentError, setDocumentError] = useState('');



  const [documentSuccess, setDocumentSuccess] = useState('');



  const [showSignatureModal, setShowSignatureModal] = useState(false);



  const [signatureData, setSignatureData] = useState(null);







  // Wallet pass state



  const [_walletLoading, setWalletLoading] = useState({}); // eslint-disable-line no-unused-vars



  // Google Wallet visibility (from public config) — default OFF until config confirms

  const [googleWalletEnabled, setGoogleWalletEnabled] = useState(false);



  // Track if vendor approved/rejected status card has been viewed on dashboard tab

  // Uses localStorage so it persists across sessions. Key includes order ID + status

  // so a new status change (e.g., PENDING → APPROVED) will show the card again.

  const [vendorStatusSeenOnDashboard, setVendorStatusSeenOnDashboard] = useState(false);

  // Track that the card was rendered at least once on dashboard (so we know when to mark it seen)

  const [vendorCardShownOnDashboard, setVendorCardShownOnDashboard] = useState(false);



  // Password change state

  const [currentPassword, setCurrentPassword] = useState('');

  const [newPassword, setNewPassword] = useState('');

  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const [passwordLoading, setPasswordLoading] = useState(false);

  const [passwordMessage, setPasswordMessage] = useState({ type: '', text: '' });

  const [emailDraft, setEmailDraft] = useState('');

  const [emailSaving, setEmailSaving] = useState(false);

  const [emailMessage, setEmailMessage] = useState({ type: '', text: '' });



  // Saved card state

  const [savedCard, setSavedCard] = useState(null);

  const [savedCardLoading, setSavedCardLoading] = useState(false);

  const [savedCardAction, setSavedCardAction] = useState(''); // 'removing' | 'updating'



  // Social media state

  const [socialMedia, setSocialMedia] = useState({ facebook: '', instagram: '', tiktok: '' });

  const [socialMediaSaving, setSocialMediaSaving] = useState(false);

  const [socialMediaMsg, setSocialMediaMsg] = useState({ type: '', text: '' });



  // Social media assets / crop personalization state

  const [cropModal, setCropModal] = useState({ open: false, assetKey: null });

  const [cropImgSrc, setCropImgSrc] = useState(null);

  const [cropSelection, setCropSelection] = useState(null);

  const [cropRef, setCropRef] = useState(null);

  const [croppedResult, setCroppedResult] = useState(null);

  const [croppedResultAspect, setCroppedResultAspect] = useState(1);

  const [personalizedAssets, setPersonalizedAssets] = useState({});

  const [activeVideoKey, setActiveVideoKey] = useState(null);

  const [vendorLogoLayout, setVendorLogoLayout] = useState(() => ({ ...SOCIAL_TOOLKIT_VENDOR_LOGO_LAYOUT }));

  // Flag post state

  const [flagModal, setFlagModal] = useState(false);

  const [flagCountry, setFlagCountry] = useState('Palestine');

  const [flagPhotoSrc, setFlagPhotoSrc] = useState(null);

  const [flagCropSelection, setFlagCropSelection] = useState(null);

  const [flagCropRef, setFlagCropRef] = useState(null);

  const [flagCroppedPhoto, setFlagCroppedPhoto] = useState(null);

  const [flagPreviewUrl, setFlagPreviewUrl] = useState(null);

  // flagPostText removed (unused after v2 migration)

  // Flag post v2 (new themes)

  const [flagPostTheme, setFlagPostTheme] = useState('dark');

  const [flagV2Layout, setFlagV2Layout] = useState({ ...FLAG_POST_V2_DEFAULTS });



  // Affiliate program state

  const [affiliateInfo, setAffiliateInfo] = useState(null);

  const [zelleEmail, setZelleEmail] = useState('');

  const [zellePhone, setZellePhone] = useState('');

  const [zelleEmailSaving, setZelleEmailSaving] = useState(false);

  const [zelleEmailMsg, setZelleEmailMsg] = useState({ type: '', text: '' });

  const [affiliatePayouts, setAffiliatePayouts] = useState([]);

  const [affiliateOrdersPage, setAffiliateOrdersPage] = useState(1);

  const [referralLinkCopied, setReferralLinkCopied] = useState(false);

  const formatZellePhoneInput = (value) => {
    const digits = (value || '').replace(/\D/g, '').slice(0, 10);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };



  const getReferralLink = () => {

    if (!affiliateInfo?.coupon_code) return '';

    return `${window.location.origin}/?ref=${affiliateInfo.coupon_code}`;

  };



  const copyReferralLink = () => {

    const link = getReferralLink();

    if (!link) return;

    navigator.clipboard.writeText(link);

    setReferralLinkCopied(true);

    setTimeout(() => setReferralLinkCopied(false), 2500);

  };

  const AFFILIATE_ORDERS_PER_PAGE = 25;

  const toolkitStorageIdentity = affiliateInfo?.coupon_code || user?.email || '';

  const vendorPostStorageKey = toolkitStorageIdentity

    ? `socialToolkitVendorPost_${toolkitStorageIdentity}_${SOCIAL_TOOLKIT_LAYOUT_VERSION}`

    : '';

  const flagPostStorageKey = toolkitStorageIdentity

    ? `socialToolkitFlagPost_${toolkitStorageIdentity}_${SOCIAL_TOOLKIT_LAYOUT_VERSION}`

    : '';

  const flagCountryStorageKey = flagPostStorageKey

    ? `${flagPostStorageKey}_country`

    : '';

  const flagPostDarkStorageKey = toolkitStorageIdentity

    ? `socialToolkitFlagPostDark_${toolkitStorageIdentity}_${SOCIAL_TOOLKIT_LAYOUT_VERSION}`

    : '';

  const flagPostLightStorageKey = toolkitStorageIdentity

    ? `socialToolkitFlagPostLight_${toolkitStorageIdentity}_${SOCIAL_TOOLKIT_LAYOUT_VERSION}`

    : '';







  const userName = user?.full_name || user?.email || 'Guest';







  const cleanDashboardUrlParams = (...paramsToRemove) => {



    const nextUrl = new URL(window.location.href);



    paramsToRemove.forEach(param => nextUrl.searchParams.delete(param));



    const nextSearch = nextUrl.searchParams.toString();



    const nextPath = `${nextUrl.pathname}${nextSearch ? `?${nextSearch}` : ''}${nextUrl.hash}`;



    window.history.replaceState({}, document.title, nextPath);



  };



  const handleEmailUpdate = async () => {

    const nextEmail = (emailDraft || '').trim().toLowerCase();

    const currentEmail = ((userProfile?.email || user?.email || '')).trim().toLowerCase();

    if (!nextEmail) {

      setEmailMessage({ type: 'error', text: 'Please enter an email address.' });

      return;

    }

    if (nextEmail === currentEmail) {

      setEmailMessage({ type: 'error', text: 'This is already your current email.' });

      return;

    }

    setEmailSaving(true);

    setEmailMessage({ type: '', text: '' });

    try {

      const response = await api.updateProfile({ email: nextEmail });

      if (response?.success) {

        setUserProfile(response.data);

        setEmailDraft(response.data.email || nextEmail);

        if (typeof updateUser === 'function') {

          updateUser(response.data);

        }

        toast.success('Email updated successfully');

        setEmailMessage({ type: 'success', text: 'Email updated successfully.' });

      } else {

        setEmailMessage({ type: 'error', text: response?.error?.message || 'Failed to update email.' });

      }

    } catch (err) {

      setEmailMessage({ type: 'error', text: err?.response?.data?.error?.message || err?.message || 'Failed to update email.' });

    } finally {

      setEmailSaving(false);

    }

  };







  const isManualAffiliateComplimentaryOrder = (order) => {



    const metadata = order?.metadata || {};



    const items = order?.items || [];



    const orderNote = `${metadata.note || ''}`.toLowerCase();



    const hasThreeDayPassItem = items.some(item => {



      const itemName = `${item?.ticket_type_name || item?.name || ''}`.toLowerCase();



      return itemName.includes('3-day') || itemName.includes('3 day');



    });







    return Boolean(



      metadata.complimentary &&



      metadata.affiliate_partner &&



      (hasThreeDayPassItem || orderNote.includes('3-day pass') || orderNote.includes('3 day pass')) &&



      Number(order?.total || 0) === 0 &&



      Number(order?.total_cents || 0) === 0



    );



  };







  // Upload pending vendor documents from IndexedDB (stored before Stripe checkout)



  const uploadPendingVendorDocuments = useCallback(async (email) => {



    if (!email) return;







    const emailLower = email.toLowerCase();



    console.log(`[VendorDocs] Checking for pending uploads for: ${emailLower}`);







    try {



      const dbRequest = indexedDB.open('VendorDocuments', 1);



      dbRequest.onerror = (e) => {



        console.error('[VendorDocs] IndexedDB open error:', e.target.error);



      };



      dbRequest.onsuccess = async (event) => {



        const db = event.target.result;



        if (!db.objectStoreNames.contains('pendingUploads')) {



          console.log('[VendorDocs] No pendingUploads store found');



          return;



        }







        const transaction = db.transaction(['pendingUploads'], 'readonly');



        const store = transaction.objectStore('pendingUploads');







        // Try to get all entries and find matching email (case-insensitive)



        const getAllRequest = store.getAll();







        getAllRequest.onsuccess = async () => {



          const allEntries = getAllRequest.result || [];



          console.log(`[VendorDocs] Found ${allEntries.length} entries in IndexedDB`);







          // Find entry matching this email (case-insensitive), fallback to most recent

          let data = allEntries.find(entry =>

            entry.email && entry.email.toLowerCase() === emailLower

          );

          if (!data) {

            data = allEntries.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0))[0];

            if (data) console.log(`[VendorDocs] No exact email match, using most recent entry: ${data.email}`);

          }



          if (data && data.files && Object.keys(data.files).length > 0) {



            const fileKeys = Object.keys(data.files);



            console.log('[VendorDocs] Found pending documents to upload:', fileKeys);



            toast.info(`Uploading ${fileKeys.length} pending document(s)...`);







            const documentTypeMap = {



              sellerPermit: 'SELLER_PERMIT',



              businessLicense: 'BUSINESS_LICENSE',



              healthPermit: 'HEALTH_PERMIT',



              foodHandler: 'FOOD_HANDLER'



            };







            let successCount = 0;



            let failCount = 0;







            // Upload all documents



            for (const [key, fileData] of Object.entries(data.files)) {



              if (fileData && documentTypeMap[key]) {



                try {



                  // Reconstruct File object from stored ArrayBuffer + metadata



                  const file = new File(



                    [fileData.data],



                    fileData.name,



                    { type: fileData.type, lastModified: fileData.lastModified }



                  );



                  console.log(`[VendorDocs] Uploading pending ${key}: ${file.name}...`);



                  const result = await api.uploadVendorDocument(documentTypeMap[key], file);



                  if (result?.success) {



                    console.log(`[VendorDocs] Successfully uploaded ${key}`);



                    successCount++;



                  } else {



                    console.error(`[VendorDocs] Upload failed for ${key}:`, result?.error);



                    failCount++;



                  }



                } catch (uploadErr) {



                  console.error(`[VendorDocs] Failed to upload ${key}:`, uploadErr);



                  failCount++;



                }



              }



            }







            // Show result toast



            if (successCount > 0 && failCount === 0) {



              toast.success(`Successfully uploaded ${successCount} document(s)!`);



            } else if (successCount > 0 && failCount > 0) {



              toast.warning(`Uploaded ${successCount} document(s), ${failCount} failed`);



            } else if (failCount > 0) {



              toast.error(`Failed to upload ${failCount} document(s). Please try uploading manually.`);



            }







            // Clear stored files in a new transaction



            const deleteRequest = indexedDB.open('VendorDocuments', 1);



            deleteRequest.onsuccess = (e) => {



              const deleteDb = e.target.result;



              const deleteTx = deleteDb.transaction(['pendingUploads'], 'readwrite');



              const deleteStore = deleteTx.objectStore('pendingUploads');



              deleteStore.delete(data.email); // Use original email key



              deleteTx.oncomplete = () => {



                console.log('[VendorDocs] Cleared IndexedDB pending uploads');



                // Reload documents after cleanup



                setTimeout(() => loadVendorDocuments(), 1000);



              };



            };



          } else {



            console.log('[VendorDocs] No pending documents found for this email');



          }



        };







        getAllRequest.onerror = (e) => {



          console.error('[VendorDocs] Error getting entries:', e.target.error);



        };



      };



    } catch (err) {



      console.error('[VendorDocs] Error accessing IndexedDB:', err);



      toast.error('Error accessing stored documents');



    }



  }, []);







  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {



    // Check for DocuSign callback FIRST (before auth redirect)



    const urlParams = new URLSearchParams(window.location.search);



    const isDocuSignCallback = urlParams.get('docusign') === 'complete';



    if (!isAuthenticated) {



      // If this is a DocuSign callback, don't redirect - wait for auth to load



      if (isDocuSignCallback) {



        console.log('DocuSign callback detected, waiting for auth...');



        return; // Wait for auth to be ready



      }



      navigate('/login');



      return;



    }







    loadAllDashboardData();



    // Fetch public config for feature flags (Google Wallet toggle)

    api.getPublicConfig().then(res => {

      if (res?.success && res.data) {

        setGoogleWalletEnabled(res.data.google_wallet_enabled ?? false);

      }

    }).catch(() => { });







    // Check for pending vendor documents to upload



    if (user?.email) {



      uploadPendingVendorDocuments(user.email);



    }







    // Handle DocuSign callback after auth is confirmed



    if (isDocuSignCallback) {



      console.log('DocuSign callback - completing contract...');



      setDocuSignCompleting(true);



      // Complete the DocuSign contract (check status and download signed PDF)



      const completeDocuSign = async () => {



        try {



          console.log('Calling completeDocuSignContract API...');



          const result = await api.completeDocuSignContract();



          console.log('DocuSign complete result:', result);



          if (result?.success && result?.is_signed) {



            console.log('DocuSign contract completed successfully');



          } else if (result?.status === 'pending') {



            console.log('DocuSign contract still pending');



          }



        } catch (err) {



          console.error('Failed to complete DocuSign contract:', err);



        }



        // Reload vendor documents to reflect signed contract



        await loadVendorDocuments();



        setDocuSignCompleting(false);



      };



      completeDocuSign();



      // Clean URL



      cleanDashboardUrlParams('docusign');



      // Show success message



      setActiveSection('vendor-documents');



    }



    // If redirected from email with action=sign-contract, go to Vendor Docs tab

    // and auto-trigger DocuSign signing flow

    const actionParam = urlParams.get('action');

    if (actionParam === 'sign-contract') {

      setActiveSection('vendor-documents');

      setPendingSignContract(true);

      cleanDashboardUrlParams('action');

    }



  }, [isAuthenticated, navigate, uploadPendingVendorDocuments, user?.email]); // eslint-disable-line react-hooks/exhaustive-deps







  useEffect(() => {

    const handlePopState = () => {

      const sectionFromUrl = new URLSearchParams(window.location.search).get('section') || 'dashboard';

      isSectionPopstateRef.current = true;

      setActiveSection(sectionFromUrl);

    };



    window.addEventListener('popstate', handlePopState);



    return () => {

      window.removeEventListener('popstate', handlePopState);

    };

  }, []);



  useEffect(() => {

    if (typeof window === 'undefined') return;



    const nextUrl = new URL(window.location.href);

    const sectionInUrl = nextUrl.searchParams.get('section') || 'dashboard';



    if (sectionInUrl === activeSection) {

      hasSectionHistorySyncedRef.current = true;

      isSectionPopstateRef.current = false;

      return;

    }



    if (activeSection === 'dashboard') {

      nextUrl.searchParams.delete('section');

    } else {

      nextUrl.searchParams.set('section', activeSection);

    }



    const nextSearch = nextUrl.searchParams.toString();

    const nextPath = `${nextUrl.pathname}${nextSearch ? `?${nextSearch}` : ''}${nextUrl.hash}`;



    if (!hasSectionHistorySyncedRef.current) {

      window.history.replaceState(window.history.state, document.title, nextPath);

      hasSectionHistorySyncedRef.current = true;

      isSectionPopstateRef.current = false;

      return;

    }



    if (isSectionPopstateRef.current) {

      isSectionPopstateRef.current = false;

      return;

    }



    window.history.pushState(window.history.state, document.title, nextPath);

  }, [activeSection]);



  const loadVendorDocuments = async () => {



    try {



      const response = await api.getVendorDocuments();



      if (response?.success) {



        setVendorDocuments(response.data || []);



      }



    } catch (err) {



      console.error('Failed to load vendor documents:', err);



    }



  };







  const handleDocumentUpload = async (documentType, file) => {



    if (!file) return;







    const docTypeNames = {



      'SELLER_PERMIT': "Seller's Permit",



      'BUSINESS_LICENSE': 'Business License',



      'HEALTH_PERMIT': 'Health Permit',



      'FOOD_HANDLER': "Food Handler's License"



    };



    const docName = docTypeNames[documentType] || documentType;







    setDocumentUploading(prev => ({ ...prev, [documentType]: true }));



    setDocumentError('');



    setDocumentSuccess('');







    console.log(`[VendorDocs] Uploading ${docName}: ${file.name}`);







    try {



      const response = await api.uploadVendorDocument(documentType, file);



      console.log(`[VendorDocs] Upload response for ${docName}:`, response);







      if (response?.success) {



        await loadVendorDocuments();



        // Show both toast and inline success message



        toast.success(`${docName} uploaded successfully!`);



        setDocumentSuccess(`✅ ${docName} uploaded successfully!`);



        // Auto-clear success message after 5 seconds



        setTimeout(() => setDocumentSuccess(''), 5000);



      } else {



        const errorMsg = response?.error?.message || 'Failed to upload document';



        console.error(`[VendorDocs] Upload failed for ${docName}:`, errorMsg);



        toast.error(`Failed to upload ${docName}: ${errorMsg}`);



        setDocumentError(errorMsg);



      }



    } catch (err) {



      const errorMsg = err.message || 'Failed to upload document';



      console.error(`[VendorDocs] Upload error for ${docName}:`, err);



      toast.error(`Error uploading ${docName}: ${errorMsg}`);



      setDocumentError(errorMsg);



    } finally {



      setDocumentUploading(prev => ({ ...prev, [documentType]: false }));



    }



  };







  // Auto-trigger DocuSign when redirected from contract reminder email

  useEffect(() => {

    if (pendingSignContract && vendorDocuments.length >= 0 && activeSection === 'vendor-documents') {

      const contractDoc = vendorDocuments.find(d => d.document_type === 'CONTRACT');

      if (contractDoc?.is_signed) {

        setPendingSignContract(false);

        return;

      }

      setPendingSignContract(false);

      // Small delay to let the UI render before triggering DocuSign

      const timer = setTimeout(() => handleSignContract(), 500);

      return () => clearTimeout(timer);

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [pendingSignContract, vendorDocuments, activeSection]);



  const handleSignContract = async () => {



    setDocumentUploading(prev => ({ ...prev, CONTRACT: true }));



    setDocumentError('');







    try {



      // Try DocuSign - return to current dashboard page



      const returnUrl = `${window.location.origin}/dashboard?docusign=complete`;



      console.log('DocuSign: Creating contract with return URL:', returnUrl);







      const response = await api.createDocuSignContract(returnUrl);



      console.log('DocuSign: API response:', JSON.stringify(response, null, 2));







      if (response?.success && response?.signing_url) {



        console.log('DocuSign: Redirecting to signing URL:', response.signing_url);







        // Validate signing URL before redirect



        if (!response.signing_url.startsWith('https://')) {



          console.error('DocuSign: Invalid signing URL format:', response.signing_url);



          setDocumentError('Invalid signing URL received. Please contact support.');



          return;



        }







        // Redirect to DocuSign embedded signing



        window.location.href = response.signing_url;



        return;



      }







      // Show error message with full details for debugging



      const errorMsg = response?.error?.message || response?.error || 'Failed to create contract';



      console.error('DocuSign contract creation failed:', {



        success: response?.success,



        hasSigningUrl: !!response?.signing_url,



        error: response?.error,



        fullResponse: response



      });



      setDocumentError(`Contract signing unavailable: ${errorMsg}`);



    } catch (err) {



      // Show error message with more context



      console.error('DocuSign error:', err);



      const errorDetail = err.response?.data?.error?.message || err.message || 'Unknown error';



      setDocumentError(`Contract signing error: ${errorDetail}. Please contact support.`);



    } finally {



      setDocumentUploading(prev => ({ ...prev, CONTRACT: false }));



    }



  };







  const handleSignatureSubmit = async () => {



    if (!signatureData) {



      setDocumentError('Please sign the contract before submitting');



      return;



    }







    setDocumentUploading(prev => ({ ...prev, CONTRACT: true }));



    try {



      // Convert signature canvas to blob



      const response = await fetch(signatureData);



      const blob = await response.blob();



      const file = new File([blob], 'contract_signature.png', { type: 'image/png' });







      // Upload signature as CONTRACT document



      const uploadResponse = await api.uploadVendorDocument('CONTRACT', file);



      if (uploadResponse?.success) {



        await loadVendorDocuments();



        setShowSignatureModal(false);



        setSignatureData(null);



      } else {



        setDocumentError(uploadResponse?.error?.message || 'Failed to sign contract');



      }



    } catch (err) {



      setDocumentError(err.message || 'Failed to sign contract');



    } finally {



      setDocumentUploading(prev => ({ ...prev, CONTRACT: false }));



    }



  };







  const getDocumentByType = (docType) => {



    return vendorDocuments.find(doc => doc.document_type === docType);



  };







  const getDocumentStatus = (docType, isRequired = false) => {



    const doc = getDocumentByType(docType);



    if (!doc) {



      return isRequired ? { status: 'missing', label: 'Not uploaded', class: 'neutral' }



        : { status: 'not_uploaded', label: 'Not uploaded', class: 'neutral' };



    }



    switch (doc.validation_status) {



      case 'APPROVED':



        return { status: 'approved', label: 'Approved ✓', class: 'success' };



      case 'REJECTED':



        return { status: 'rejected', label: 'Rejected ✖', class: 'danger' };



      case 'EXPIRED':



        return { status: 'expired', label: 'Expired', class: 'warning' };



      default:



        return { status: 'uploaded', label: 'Uploaded', class: 'success' };



    }



  };







  const loadUserProfile = async () => {



    try {



      const response = await api.getProfile();



      if (response?.success) {



        setUserProfile(response.data);

        setEmailDraft(response.data.email || '');



        // Load social media from profile

        setSocialMedia({

          facebook: response.data.facebook || '',

          instagram: response.data.instagram || '',

          tiktok: response.data.tiktok || '',

        });



      }



    } catch (err) {



      console.error('Failed to load user profile:', err);



    }



  };



  const loadSavedCard = async () => {

    setSavedCardLoading(true);

    try {

      const res = await api.getSavedCard();

      if (res?.success) {

        setSavedCard(res.has_card ? res.card : null);

      }

    } catch (err) {

      console.error('Failed to load saved card:', err);

    } finally {

      setSavedCardLoading(false);

    }

  };



  const handleRemoveCard = async () => {

    if (!window.confirm('Are you sure you want to remove your saved card?')) return;

    setSavedCardAction('removing');

    try {

      const res = await api.removeSavedCard();

      if (res?.success) {

        setSavedCard(null);

        toast.success('Card removed successfully');

      } else {

        toast.error(res?.error?.message || 'Failed to remove card');

      }

    } catch (err) {

      toast.error('Failed to remove card');

    } finally {

      setSavedCardAction('');

    }

  };



  const handleSaveSocialMedia = async () => {

    setSocialMediaSaving(true);

    setSocialMediaMsg({ type: '', text: '' });

    try {

      const response = await api.updateProfile({

        facebook: socialMedia.facebook,

        instagram: socialMedia.instagram,

        tiktok: socialMedia.tiktok,

      });

      if (response?.success) {

        setSocialMediaMsg({ type: 'success', text: 'Social media saved successfully!' });

        setUserProfile(response.data);

      } else {

        setSocialMediaMsg({ type: 'error', text: response?.error?.message || 'Failed to save' });

      }

    } catch (err) {

      setSocialMediaMsg({ type: 'error', text: 'Failed to save social media' });

    } finally {

      setSocialMediaSaving(false);

    }

  };



  // --- Social media asset crop/personalize helpers ---

  const handleOpenCropModal = (assetKey) => {

    setCropModal({ open: true, assetKey });

    setCropImgSrc(null);

    setCropSelection(null);

    setCropRef(null);

    setCroppedResult(null);

    setCroppedResultAspect(1);

    setVendorLogoLayout({ ...SOCIAL_TOOLKIT_VENDOR_LOGO_LAYOUT });

  };



  const handleCropFileSelect = (e) => {

    const file = e.target.files?.[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = () => {

      setCropImgSrc(reader.result);

      setCroppedResult(null);

      setCroppedResultAspect(1);

      // Auto-select the full image (like MS Paint - selection already visible)

      setCropSelection({ unit: '%', x: 0, y: 0, width: 100, height: 100 });

    };

    reader.readAsDataURL(file);

  };



  // Step 1: Crop the selected area and show preview on poster

  const handleCropApply = () => {

    if (!cropImgSrc) return;

    const sel = cropSelection || { unit: '%', x: 0, y: 0, width: 100, height: 100 };

    const sourceImg = new Image();

    sourceImg.onload = () => {

      const cropCanvas = document.createElement('canvas');

      const isPercentCrop = sel.unit === '%';

      const sx = isPercentCrop ? ((sel.x || 0) / 100) * sourceImg.naturalWidth : ((sel.x || 0) / Math.max(cropRef?.width || sourceImg.naturalWidth, 1)) * sourceImg.naturalWidth;

      const sy = isPercentCrop ? ((sel.y || 0) / 100) * sourceImg.naturalHeight : ((sel.y || 0) / Math.max(cropRef?.height || sourceImg.naturalHeight, 1)) * sourceImg.naturalHeight;

      const sw = isPercentCrop ? ((sel.width || 100) / 100) * sourceImg.naturalWidth : ((sel.width || sourceImg.naturalWidth) / Math.max(cropRef?.width || sourceImg.naturalWidth, 1)) * sourceImg.naturalWidth;

      const sh = isPercentCrop ? ((sel.height || 100) / 100) * sourceImg.naturalHeight : ((sel.height || sourceImg.naturalHeight) / Math.max(cropRef?.height || sourceImg.naturalHeight, 1)) * sourceImg.naturalHeight;

      const targetW = Math.max(1, Math.round(sw));

      const targetH = Math.max(1, Math.round(sh));

      cropCanvas.width = targetW;

      cropCanvas.height = targetH;

      const cropCtx = cropCanvas.getContext('2d');

      cropCtx.drawImage(sourceImg, sx, sy, sw, sh, 0, 0, targetW, targetH);

      setCroppedResultAspect(targetW / targetH);

      setCroppedResult(cropCanvas.toDataURL('image/png'));

    };

    sourceImg.src = cropImgSrc;

  };



  const saveToolkitAssetToServer = useCallback(async (assetKey, dataUrl) => {

    const code = affiliateInfo?.coupon_code || '';

    if (!assetKey || !dataUrl || !code) return null;



    try {

      const response = await fetch(dataUrl);

      const blob = await response.blob();

      const result = await api.saveToolkitImages({ [assetKey]: blob }, SOCIAL_TOOLKIT_LAYOUT_VERSION, code);

      if (result?.success && result.images?.[assetKey]) {

        return result.images[assetKey];

      }

    } catch (err) {

      console.error(`Failed to save toolkit asset ${assetKey}:`, err);

    }



    return null;

  }, [affiliateInfo?.coupon_code]);



  const handleCropSave = () => {

    if (!croppedResult) return;

    const baseImg = new Image();

    baseImg.crossOrigin = 'anonymous';

    baseImg.onload = () => {

      const logoImg = new Image();

      logoImg.onload = async () => {

        const canvas = document.createElement('canvas');

        canvas.width = baseImg.naturalWidth;

        canvas.height = baseImg.naturalHeight;

        const ctx = canvas.getContext('2d');

        ctx.drawImage(baseImg, 0, 0);

        // Fixed height = 16% of canvas height (matches example), width scales proportionally

        const fixedH = canvas.height * SOCIAL_TOOLKIT_VENDOR_LOGO_LAYOUT.heightPct;

        const logoAspect = logoImg.naturalWidth / logoImg.naturalHeight;

        const drawH = fixedH;

        const drawW = fixedH * logoAspect;

        const drawX = canvas.width * vendorLogoLayout.centerXPct - drawW / 2;

        const drawY = canvas.height * vendorLogoLayout.centerYPct - drawH / 2;

        ctx.drawImage(logoImg, drawX, drawY, drawW, drawH);

        const compositeDataUrl = canvas.toDataURL('image/png');

        const assetKey = cropModal.assetKey;

        if (assetKey === 'vendor-post' && vendorPostStorageKey) {

          try {

            localStorage.setItem(vendorPostStorageKey, compositeDataUrl);

          } catch (_) { }

        }

        setPersonalizedAssets(prev => ({ ...prev, [assetKey]: compositeDataUrl }));

        const persistedUrl = await saveToolkitAssetToServer(assetKey, compositeDataUrl);

        if (persistedUrl) {

          if (assetKey === 'vendor-post' && vendorPostStorageKey) {

            try {

              localStorage.setItem(vendorPostStorageKey, persistedUrl);

            } catch (_) { }

          }

          setPersonalizedAssets(prev => ({ ...prev, [assetKey]: persistedUrl }));

        }

        setCropModal({ open: false, assetKey: null });

        setCropImgSrc(null);

        setCropSelection(null);

        setCropRef(null);

        setCroppedResult(null);

        setCroppedResultAspect(1);

        setVendorLogoLayout({ ...SOCIAL_TOOLKIT_VENDOR_LOGO_LAYOUT });

      };

      logoImg.src = croppedResult;

    };

    baseImg.src = personalizedAssets['vendor-output-base'] || getCmsImagePath('vendorOutputPost', '/Personalized Social Posts/ocmena-vendor-output.webp');

  };



  // Generate vendor base image with dynamic discount % and promo code drawn on the template

  const generateVendorBaseImage = (templateSrc, discountText, couponCode) => {

    return new Promise((resolve) => {

      const img = new Image();

      img.crossOrigin = 'anonymous';

      img.onload = () => {

        const canvas = document.createElement('canvas');

        canvas.width = img.naturalWidth;

        canvas.height = img.naturalHeight;

        const ctx = canvas.getContext('2d');

        ctx.drawImage(img, 0, 0);

        setFittedCanvasFont(ctx, discountText, canvas.width * SOCIAL_TOOLKIT_VENDOR_TEXT_LAYOUT.discountMaxWidthPct, Math.round(canvas.width * SOCIAL_TOOLKIT_VENDOR_TEXT_LAYOUT.discountFontSizePct), '#000000');

        ctx.fillText(discountText, canvas.width * SOCIAL_TOOLKIT_VENDOR_TEXT_LAYOUT.discountX, canvas.height * SOCIAL_TOOLKIT_VENDOR_TEXT_LAYOUT.discountY);

        setFittedCanvasFont(ctx, couponCode, canvas.width * SOCIAL_TOOLKIT_VENDOR_TEXT_LAYOUT.codeMaxWidthPct, Math.round(canvas.width * SOCIAL_TOOLKIT_VENDOR_TEXT_LAYOUT.codeFontSizePct), '#000000');

        ctx.fillText(couponCode, canvas.width * SOCIAL_TOOLKIT_VENDOR_TEXT_LAYOUT.codeX, canvas.height * SOCIAL_TOOLKIT_VENDOR_TEXT_LAYOUT.codeY);

        resolve(canvas.toDataURL('image/jpeg', 0.92));

      };

      img.onerror = () => resolve(null);

      img.src = templateSrc;

    });

  };



  // Generate coupon image with dynamic discount % and coupon code drawn on the blank template

  const generateCouponImage = (templateSrc, discountText, couponCode, layout) => {

    return new Promise((resolve) => {

      const img = new Image();

      img.crossOrigin = 'anonymous';

      img.onload = () => {

        const canvas = document.createElement('canvas');

        canvas.width = img.naturalWidth;

        canvas.height = img.naturalHeight;

        const ctx = canvas.getContext('2d');

        ctx.drawImage(img, 0, 0);

        const discountFontSize = Math.round(canvas.width * layout.fontSizePct);

        setFittedCanvasFont(ctx, discountText, canvas.width * (layout.discountMaxWidthPct || 0.86), discountFontSize, layout.discountColor || '#FFFFFF');

        ctx.strokeStyle = 'rgba(0,0,0,0.15)';

        ctx.lineWidth = Math.max(1, discountFontSize * 0.02);

        const dY = canvas.height * layout.discountY;

        const dX = canvas.width * (layout.discountX || 0.5);

        ctx.strokeText(discountText, dX, dY);

        ctx.fillText(discountText, dX, dY);

        const codeFontSize = Math.round(canvas.width * layout.codeFontSizePct);

        setFittedCanvasFont(ctx, couponCode, canvas.width * (layout.codeMaxWidthPct || 0.78), codeFontSize, layout.codeColor || '#000000');

        ctx.strokeStyle = 'transparent';

        ctx.lineWidth = 0;

        const cY = canvas.height * layout.codeY;

        const cX = canvas.width * (layout.codeX || 0.5);

        ctx.fillText(couponCode, cX, cY);

        resolve(canvas.toDataURL('image/jpeg', 0.92));

      };

      img.onerror = () => resolve(null);

      img.src = templateSrc;

    });

  };





  useEffect(() => {

    const code = affiliateInfo?.coupon_code || '';

    const discPct = affiliateInfo?.discount_percent ?? 10;

    if (!code) return;

    let cancelled = false;



    const REQUIRED_KEYS = ['vendor-base', 'vendor-output-base', 'coupon-a', 'coupon-b', 'im-attending'];



    const getLocalAsset = (storageKey) => {

      if (!storageKey) return null;

      try {

        const val = localStorage.getItem(storageKey);

        if (val) return val;

        const prevVersions = ['2026-03-14-social-toolkit-v19', '2026-03-13-social-toolkit-v18'];

        for (const pv of prevVersions) {

          const prevKey = storageKey.replace(SOCIAL_TOOLKIT_LAYOUT_VERSION, pv);

          if (prevKey === storageKey) continue;

          const prevVal = localStorage.getItem(prevKey);

          if (prevVal) {

            try { localStorage.setItem(storageKey, prevVal); localStorage.removeItem(prevKey); } catch (_) { }

            return prevVal;

          }

        }

        return null;

      } catch (_) {

        return null;

      }

    };



    const setImages = (imageMap, customAssets = {}) => {

      if (cancelled) return;

      setPersonalizedAssets((prev) => {

        const next = { ...prev, '__socialToolkitLayoutVersion': SOCIAL_TOOLKIT_LAYOUT_VERSION };

        if (prev.__socialToolkitLayoutVersion !== SOCIAL_TOOLKIT_LAYOUT_VERSION) {

          delete next['vendor-post'];

          delete next['personalized-flag'];

        }

        for (const k of REQUIRED_KEYS) if (imageMap[k]) next[k] = imageMap[k];

        if (customAssets['vendor-post']) next['vendor-post'] = customAssets['vendor-post'];

        if (customAssets['personalized-flag']) next['personalized-flag'] = customAssets['personalized-flag'];

        if (customAssets['personalized-flag-dark']) next['personalized-flag-dark'] = customAssets['personalized-flag-dark'];

        if (customAssets['personalized-flag-light']) next['personalized-flag-light'] = customAssets['personalized-flag-light'];

        return next;

      });

    };



    (async () => {

      const localCustomAssets = {

        'vendor-post': getLocalAsset(vendorPostStorageKey),

        'personalized-flag': getLocalAsset(flagPostStorageKey),

        'personalized-flag-dark': getLocalAsset(flagPostDarkStorageKey),

        'personalized-flag-light': getLocalAsset(flagPostLightStorageKey),

      };



      // Fetch server images for vendor-post and personalized-flag

      // No layout_version filter to avoid version mismatch between frontend/backend

      let serverCustomAssets = {};

      try {

        const savedResponse = await api.getToolkitImages('', '');

        if (savedResponse?.success && savedResponse.images) {

          serverCustomAssets = {

            'vendor-post': savedResponse.images['vendor-post'],

            'personalized-flag': savedResponse.images['personalized-flag'],

            'personalized-flag-dark': savedResponse.images['personalized-flag-dark'],

            'personalized-flag-light': savedResponse.images['personalized-flag-light'],

            [MENA_ROOTS_HELPER_STORY_ASSET_KEY]: savedResponse.images[MENA_ROOTS_HELPER_STORY_ASSET_KEY],

          };

        }

      } catch (err) {

        console.error('Failed to load toolkit images:', err);

      }



      const customAssets = {

        'vendor-post': serverCustomAssets['vendor-post'] || localCustomAssets['vendor-post'],

        'personalized-flag': serverCustomAssets['personalized-flag'] || localCustomAssets['personalized-flag'],

        'personalized-flag-dark': serverCustomAssets['personalized-flag-dark'] || localCustomAssets['personalized-flag-dark'],

        'personalized-flag-light': serverCustomAssets['personalized-flag-light'] || localCustomAssets['personalized-flag-light'],

        [MENA_ROOTS_HELPER_STORY_ASSET_KEY]: serverCustomAssets[MENA_ROOTS_HELPER_STORY_ASSET_KEY],

      };



      const assetStorageMap = {

        'vendor-post': vendorPostStorageKey,

        'personalized-flag': flagPostStorageKey,

        'personalized-flag-dark': flagPostDarkStorageKey,

        'personalized-flag-light': flagPostLightStorageKey,

      };

      for (const assetKey of Object.keys(assetStorageMap)) {

        if (!localCustomAssets[assetKey] || serverCustomAssets[assetKey]) continue;

        const persistedUrl = await saveToolkitAssetToServer(assetKey, localCustomAssets[assetKey]);

        if (persistedUrl) {

          customAssets[assetKey] = persistedUrl;

          try {

            const sk = assetStorageMap[assetKey];

            if (sk) localStorage.setItem(sk, persistedUrl);

          } catch (_) { }

        }

      }



      const [vendorBase, vendorOutputBase, couponA, couponB, attending] = await Promise.all([

        generateVendorBaseImage(getCmsImagePath('vendorInitialLoad', '/ocmena-vendor-inital-load.webp'), `${discPct}% OFF!`, code),

        generateVendorBaseImage(getCmsImagePath('vendorOutputPost', '/Personalized Social Posts/ocmena-vendor-output.webp'), `${discPct}% OFF!`, code),

        generateCouponImage(getCmsImagePath('couponPostA', '/Coupon & Promotion Posts/OCMENA-Coupon-A.webp'), `${discPct}% OFF!`, code, SOCIAL_TOOLKIT_COUPON_LAYOUTS.a),

        generateCouponImage(getCmsImagePath('couponPostB', '/Coupon & Promotion Posts/OCMENA-Coupon-B.webp'), `${discPct}% OFF!`, code, SOCIAL_TOOLKIT_COUPON_LAYOUTS.b),

        generateCouponImage(getCmsImagePath('attendingPost', '/OCMENA-Attending-Post.webp'), `${discPct}% OFF TICKETS WITH MY COUPON CODE:`, code, IM_ATTENDING_LAYOUT)

      ]);

      if (cancelled) return;



      const canvasImages = {

        'vendor-base': vendorBase,

        'vendor-output-base': vendorOutputBase,

        'coupon-a': couponA,

        'coupon-b': couponB,

        'im-attending': attending,

      };

      setImages(canvasImages, customAssets);

      console.log('[SocialToolkit] Canvas images rendered and displayed (deterministic, layout v' + SOCIAL_TOOLKIT_LAYOUT_VERSION + ')');

    })();



    return () => { cancelled = true; };

  }, [affiliateInfo?.coupon_code, affiliateInfo?.discount_percent, flagPostStorageKey, saveToolkitAssetToServer, vendorPostStorageKey]); // eslint-disable-line react-hooks/exhaustive-deps



  const handleOpenFlagModal = (theme) => {

    const t = theme || 'dark';

    setFlagPostTheme(t);

    setFlagV2Layout(t === 'light' ? { ...FLAG_POST_V2_LIGHT_DEFAULTS } : { ...FLAG_POST_V2_DEFAULTS });

    setFlagModal(true);

    setFlagPhotoSrc(null);

    setFlagCropSelection(null);

    setFlagCropRef(null);

    setFlagCroppedPhoto(null);

    setFlagPreviewUrl(null);

    try {

      const saved = flagCountryStorageKey ? localStorage.getItem(flagCountryStorageKey) : null;

      if (saved) setFlagCountry(saved);

    } catch (_) { }

  };



  const handleFlagPhotoSelect = (e) => {

    const file = e.target.files?.[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = () => {

      setFlagPhotoSrc(reader.result);

      setFlagCroppedPhoto(null);

      setFlagCropSelection(null); // will be set properly on image load

    };

    reader.readAsDataURL(file);

  };



  const handleFlagImgLoad = (e) => {

    const { naturalWidth, naturalHeight } = e.currentTarget;

    setFlagCropRef(e.currentTarget);

    // Compute a centered 1:1 crop that fits within the image

    const crop = centerCrop(

      makeAspectCrop({ unit: '%', width: 90 }, 1, naturalWidth, naturalHeight),

      naturalWidth,

      naturalHeight

    );

    setFlagCropSelection(crop);

  };



  const handleFlagCropApply = () => {

    if (!flagPhotoSrc) return;

    const sel = flagCropSelection || { unit: '%', x: 0, y: 0, width: 100, height: 100 };

    const sourceImg = new Image();

    sourceImg.onload = () => {

      const cropCanvas = document.createElement('canvas');

      const isPercentCrop = sel.unit === '%';

      const sx = isPercentCrop ? ((sel.x || 0) / 100) * sourceImg.naturalWidth : ((sel.x || 0) / Math.max(flagCropRef?.width || sourceImg.naturalWidth, 1)) * sourceImg.naturalWidth;

      const sy = isPercentCrop ? ((sel.y || 0) / 100) * sourceImg.naturalHeight : ((sel.y || 0) / Math.max(flagCropRef?.height || sourceImg.naturalHeight, 1)) * sourceImg.naturalHeight;

      const sw = isPercentCrop ? ((sel.width || 100) / 100) * sourceImg.naturalWidth : ((sel.width || sourceImg.naturalWidth) / Math.max(flagCropRef?.width || sourceImg.naturalWidth, 1)) * sourceImg.naturalWidth;

      const sh = isPercentCrop ? ((sel.height || 100) / 100) * sourceImg.naturalHeight : ((sel.height || sourceImg.naturalHeight) / Math.max(flagCropRef?.height || sourceImg.naturalHeight, 1)) * sourceImg.naturalHeight;

      // Force square output (1:1 aspect ratio)

      const side = Math.max(1, Math.round(Math.min(sw, sh)));

      cropCanvas.width = side;

      cropCanvas.height = side;

      const cropCtx = cropCanvas.getContext('2d');

      cropCtx.drawImage(sourceImg, sx, sy, sw, sh, 0, 0, side, side);

      setFlagCroppedPhoto(cropCanvas.toDataURL('image/png'));

    };

    sourceImg.src = flagPhotoSrc;

  };



  const handleFlagPostSave = () => {

    if (!flagCroppedPhoto) return;

    const themeConfig = FLAG_POST_THEMES[flagPostTheme] || FLAG_POST_THEMES.dark;

    const layout = flagV2Layout;

    const templateImg = new Image();

    templateImg.onload = () => {

      const photoImg = new Image();

      photoImg.onload = () => {

        const canvas = document.createElement('canvas');

        canvas.width = templateImg.naturalWidth;

        canvas.height = templateImg.naturalHeight;

        const ctx = canvas.getContext('2d');



        // 1. Draw template as background

        ctx.drawImage(templateImg, 0, 0);



        // 2. Draw user's photo (full color) in the designated square area

        //    Photo sits on top of the template's center region (solid dark/white)

        //    Frame borders remain visible because photo is smaller than canvas

        const photoSize = Math.round(canvas.width * layout.photoSize);

        const photoX = Math.round(canvas.width * layout.photoX);

        const photoY = Math.round(canvas.height * layout.photoY);

        ctx.drawImage(photoImg, photoX, photoY, photoSize, photoSize);



        // 3. Draw country name

        const countryUpper = flagCountry.toUpperCase();

        const countrySize = Math.round(canvas.width * layout.countryFontPct);

        ctx.textAlign = 'center';

        ctx.textBaseline = 'middle';

        let cSize = countrySize;

        ctx.font = `900 ${cSize}px "Arial Black", "Impact", sans-serif`;

        while (cSize > 12 && ctx.measureText(countryUpper).width > canvas.width * 0.7) {

          cSize -= 1;

          ctx.font = `900 ${cSize}px "Arial Black", "Impact", sans-serif`;

        }

        ctx.fillStyle = layout.countryColor || '#FFFFFF';

        ctx.fillText(countryUpper, canvas.width * 0.5, canvas.height * layout.countryY);



        // 4. Draw flag image

        const flagFile = FLAG_FILE_MAP[flagCountry];

        if (flagFile) {

          const flagImgEl = new Image();

          flagImgEl.onload = () => {

            const fH = canvas.height * layout.flagHeightPct;

            const fW = fH * (flagImgEl.naturalWidth / flagImgEl.naturalHeight);

            ctx.drawImage(flagImgEl, canvas.width * layout.flagX - fW / 2, canvas.height * layout.flagY - fH / 2, fW, fH);

            finalizeFlagPostV2(canvas);

          };

          flagImgEl.onerror = () => finalizeFlagPostV2(canvas);

          flagImgEl.src = `/Flags/2x/${flagFile}`;

        } else {

          finalizeFlagPostV2(canvas);

        }

      };

      photoImg.src = flagCroppedPhoto;

    };

    templateImg.src = themeConfig.templateSrc;

  };



  const _finalizeFlagPost = (canvas) => { // eslint-disable-line no-unused-vars

    const dataUrl = canvas.toDataURL('image/jpeg', 0.92);

    setPersonalizedAssets(prev => ({ ...prev, 'personalized-flag': dataUrl }));

    try {

      if (flagPostStorageKey) localStorage.setItem(flagPostStorageKey, dataUrl);

      if (flagCountryStorageKey) localStorage.setItem(flagCountryStorageKey, flagCountry);

    } catch (_) { }

    saveToolkitAssetToServer('personalized-flag', dataUrl).then((persistedUrl) => {

      if (persistedUrl) {

        try {

          if (flagPostStorageKey) localStorage.setItem(flagPostStorageKey, persistedUrl);

          if (flagCountryStorageKey) localStorage.setItem(flagCountryStorageKey, flagCountry);

        } catch (_) { }

        setPersonalizedAssets(prev => ({ ...prev, 'personalized-flag': persistedUrl }));

      }

      setFlagModal(false);

      setFlagPhotoSrc(null);

      setFlagCropSelection(null);

      setFlagCropRef(null);

      setFlagCroppedPhoto(null);

      setFlagPreviewUrl(null);

    });

  };



  const finalizeFlagPostV2 = (canvas) => {

    const dataUrl = canvas.toDataURL('image/jpeg', 0.92);

    const assetKey = flagPostTheme === 'light' ? 'personalized-flag-light' : 'personalized-flag-dark';

    const storageKey = flagPostTheme === 'light' ? flagPostLightStorageKey : flagPostDarkStorageKey;

    setPersonalizedAssets(prev => ({ ...prev, [assetKey]: dataUrl }));

    try {

      if (storageKey) localStorage.setItem(storageKey, dataUrl);

      if (flagCountryStorageKey) localStorage.setItem(flagCountryStorageKey, flagCountry);

    } catch (_) { }

    saveToolkitAssetToServer(assetKey, dataUrl).then((persistedUrl) => {

      if (persistedUrl) {

        try {

          if (storageKey) localStorage.setItem(storageKey, persistedUrl);

        } catch (_) { }

        setPersonalizedAssets(prev => ({ ...prev, [assetKey]: persistedUrl }));

      }

      setFlagModal(false);

      setFlagPhotoSrc(null);

      setFlagCropSelection(null);

      setFlagCropRef(null);

      setFlagCroppedPhoto(null);

    });

  };



  // Restore saved flag post from localStorage on mount

  useEffect(() => {

    try {

      const saved = localStorage.getItem(flagPostStorageKey);

      if (saved) {

        setPersonalizedAssets(prev => ({ ...prev, 'personalized-flag': saved }));

      }

    } catch (_) { }

  }, [flagPostStorageKey]);



  // Restore saved v2 dark/light flag posts from localStorage

  useEffect(() => {

    try {

      if (flagPostDarkStorageKey) {

        const savedDark = localStorage.getItem(flagPostDarkStorageKey);

        if (savedDark) setPersonalizedAssets(prev => ({ ...prev, 'personalized-flag-dark': savedDark }));

      }

      if (flagPostLightStorageKey) {

        const savedLight = localStorage.getItem(flagPostLightStorageKey);

        if (savedLight) setPersonalizedAssets(prev => ({ ...prev, 'personalized-flag-light': savedLight }));

      }

    } catch (_) { }

  }, [flagPostDarkStorageKey, flagPostLightStorageKey]);



  // Auto-generate MENA Roots Helper Story Post from personalized light frame

  useEffect(() => {

    const lightFrameSrc = personalizedAssets['personalized-flag-light'];

    if (!lightFrameSrc) {

      setPersonalizedAssets(prev => {

        if (!prev[MENA_ROOTS_HELPER_STORY_ASSET_KEY]) return prev;

        const next = { ...prev };

        delete next[MENA_ROOTS_HELPER_STORY_ASSET_KEY];

        return next;

      });

      return;

    }



    // If it's an R2/HTTP URL and we already have the helper story loaded, skip regeneration

    const isDataUrl = lightFrameSrc.startsWith('data:');

    if (!isDataUrl && personalizedAssets[MENA_ROOTS_HELPER_STORY_ASSET_KEY]) return;



    let cancelled = false;



    const generateFromDataUrl = (lightFrameDataUrl) => {

      const templateImg = new Image();

      templateImg.crossOrigin = 'anonymous';

      templateImg.onload = () => {

        if (cancelled) return;

        const lightFrameImg = new Image();

        lightFrameImg.onload = () => {

          if (cancelled) return;

          try {

            const canvas = document.createElement('canvas');

            canvas.width = templateImg.naturalWidth;

            canvas.height = templateImg.naturalHeight;

            const ctx = canvas.getContext('2d');

            ctx.drawImage(templateImg, 0, 0);



            const boxX = canvas.width * MENA_ROOTS_HELPER_STORY_LAYOUT.x;

            const boxY = canvas.height * MENA_ROOTS_HELPER_STORY_LAYOUT.y;

            const boxW = canvas.width * MENA_ROOTS_HELPER_STORY_LAYOUT.width;

            const boxH = canvas.height * MENA_ROOTS_HELPER_STORY_LAYOUT.height;

            const { drawW, drawH, drawX, drawY } = getContainDrawDimensions(

              lightFrameImg.naturalWidth || lightFrameImg.width,

              lightFrameImg.naturalHeight || lightFrameImg.height,

              boxW,

              boxH

            );



            ctx.drawImage(lightFrameImg, boxX + drawX, boxY + drawY, drawW, drawH);

            const nextDataUrl = canvas.toDataURL('image/jpeg', 0.92);

            if (cancelled) return;

            setPersonalizedAssets(prev => {

              if (prev[MENA_ROOTS_HELPER_STORY_ASSET_KEY] === nextDataUrl) return prev;

              return { ...prev, [MENA_ROOTS_HELPER_STORY_ASSET_KEY]: nextDataUrl };

            });

            // Persist to R2 Cloudflare — let the save finish even if this effect is cleaned up

            saveToolkitAssetToServer(MENA_ROOTS_HELPER_STORY_ASSET_KEY, nextDataUrl).then((persistedUrl) => {

              if (!persistedUrl) return;

              setPersonalizedAssets(prev => ({ ...prev, [MENA_ROOTS_HELPER_STORY_ASSET_KEY]: persistedUrl }));

            });

          } catch (err) {

            console.error('[HelperStory] Canvas generation failed:', err);

          }

        };

        lightFrameImg.onerror = () => { if (!cancelled) console.warn('[HelperStory] Failed to load light frame'); };

        lightFrameImg.src = lightFrameDataUrl;

      };

      templateImg.onerror = () => { if (!cancelled) console.warn('[HelperStory] Failed to load template'); };

      templateImg.src = MENA_ROOTS_HELPER_STORY_TEMPLATE_SRC;

    };



    if (isDataUrl) {

      // Fresh creation — use directly

      generateFromDataUrl(lightFrameSrc);

    } else {

      // R2 URL — fetch via backend proxy to get a CORS-safe data URL

      api.getToolkitImageProxy('personalized-flag-light').then((dataUrl) => {

        if (cancelled || !dataUrl) return;

        generateFromDataUrl(dataUrl);

      }).catch(() => { });

    }



    return () => { cancelled = true; };

  }, [personalizedAssets['personalized-flag-light']]); // eslint-disable-line react-hooks/exhaustive-deps



  // Generate canvas-based flag post preview (v2: template bg + full color photo + text + flag)

  useEffect(() => {

    if (!flagCroppedPhoto) { setFlagPreviewUrl(null); return; }

    let cancelled = false;

    const themeConfig = FLAG_POST_THEMES[flagPostTheme] || FLAG_POST_THEMES.dark;

    const layout = flagV2Layout;

    const renderPreview = () => {

      const templateImg = new Image();

      templateImg.onload = () => {

        if (cancelled) return;

        const photoImg = new Image();

        photoImg.onload = () => {

          if (cancelled) return;

          try {

            const canvas = document.createElement('canvas');

            canvas.width = templateImg.naturalWidth;

            canvas.height = templateImg.naturalHeight;

            const ctx = canvas.getContext('2d');



            // 1. Template as background

            ctx.drawImage(templateImg, 0, 0);



            // 2. User photo (full color) in the square area

            //    Photo draws on top of the template's center region

            const photoSize = Math.round(canvas.width * layout.photoSize);

            const photoX = Math.round(canvas.width * layout.photoX);

            const photoY = Math.round(canvas.height * layout.photoY);

            ctx.drawImage(photoImg, photoX, photoY, photoSize, photoSize);



            // 3. Country name

            const countryUpper = flagCountry.toUpperCase();

            const countrySize = Math.round(canvas.width * layout.countryFontPct);

            ctx.textAlign = 'center';

            ctx.textBaseline = 'middle';

            let sz = countrySize;

            ctx.font = `900 ${sz}px "Arial Black", "Impact", sans-serif`;

            while (sz > 12 && ctx.measureText(countryUpper).width > canvas.width * 0.7) {

              sz -= 1;

              ctx.font = `900 ${sz}px "Arial Black", "Impact", sans-serif`;

            }

            ctx.fillStyle = layout.countryColor || '#FFFFFF';

            ctx.fillText(countryUpper, canvas.width * 0.5, canvas.height * layout.countryY);



            // 5. Country flag

            const flagFile = FLAG_FILE_MAP[flagCountry];

            if (flagFile) {

              const flagImgEl = new Image();

              flagImgEl.onload = () => {

                if (cancelled) return;

                const fH = canvas.height * layout.flagHeightPct;

                const fW = fH * (flagImgEl.naturalWidth / flagImgEl.naturalHeight);

                ctx.drawImage(flagImgEl, canvas.width * layout.flagX - fW / 2, canvas.height * layout.flagY - fH / 2, fW, fH);

                setFlagPreviewUrl(canvas.toDataURL('image/jpeg', 0.85));

              };

              flagImgEl.onerror = (err) => {

                console.warn('[FlagPreview] flag image failed:', err);

                if (!cancelled) setFlagPreviewUrl(canvas.toDataURL('image/jpeg', 0.85));

              };

              flagImgEl.src = `/Flags/2x/${flagFile}`;

            } else {

              setFlagPreviewUrl(canvas.toDataURL('image/jpeg', 0.85));

            }

          } catch (err) {

            console.error('[FlagPreview] canvas error:', err);

          }

        };

        photoImg.onerror = (err) => console.error('[FlagPreview] photo load failed:', err);

        photoImg.src = flagCroppedPhoto;

      };

      templateImg.onerror = (err) => console.error('[FlagPreview] template load failed:', err);

      templateImg.src = themeConfig.templateSrc;

    };

    renderPreview();

    return () => { cancelled = true; };

  }, [flagCroppedPhoto, flagCountry, flagPostTheme, flagV2Layout]); // eslint-disable-line react-hooks/exhaustive-deps



  const loadDashboardData = async () => {



    try {



      const [ticketsRes, ordersRes, transfersRes] = await Promise.all([



        api.getUserTickets(),



        api.getMyOrders(),



        api.getMyTransfers().catch(() => null)



      ]);



      if (ticketsRes?.success) {



        // Re-categorize: move comp/festival-access tickets from vendor_tickets to festival_tickets

        // This is needed because the production backend may categorize comp tickets as vendor tickets

        // (their ticket_type_name contains "Vendor Booth" which triggers the vendor categorization)

        const data = { ...ticketsRes.data };

        const vendorTickets = (data.vendor_tickets || []).filter((ticket) => !isVoidedTicket(ticket));

        const festivalTickets = (data.festival_tickets || []).filter((ticket) => {
          if (isWristbandTicket(ticket) || isParkingPassTicket(ticket)) {
            return false;
          }
          if (isVoidedTicket(ticket) && isVendorCompTicket(ticket)) {
            return false;
          }
          return true;
        });

        const apiParkingTickets = Array.isArray(data.parking_tickets) ? data.parking_tickets : [];

        const parkingFromOther = (data.other_tickets || []).filter((ticket) => isParkingPassTicket(ticket));

        const parkingById = new Map();
        [...apiParkingTickets, ...parkingFromOther].forEach((ticket) => {
          if (!ticket?.id) return;
          parkingById.set(ticket.id, ticket);
        });

        data.parking_tickets = Array.from(parkingById.values());
        data.other_tickets = (data.other_tickets || []).filter((ticket) => !isParkingPassTicket(ticket));

        data.festival_tickets = festivalTickets;
        data.vendor_tickets = vendorTickets;



        console.log('[Dashboard] vendor_tickets from API:', vendorTickets.length, vendorTickets.map(t => ({ name: t.ticket_type_name, is_comp: t.is_comp, meta_type: t.metadata?.type, meta_comp: t.metadata?.complimentary })));

        console.log('[Dashboard] festival_tickets from API:', festivalTickets.length);



        const isCompTicket = (t) => {

          const name = (t.ticket_type_name || '').toLowerCase();

          return (

            t.is_comp === true ||

            t.metadata?.complimentary === true ||

            t.metadata?.type === 'festival_access' ||

            name.includes('complimentary') ||

            (name.includes('festival') && name.includes('pass')) ||

            (name.includes('festival') && name.includes('access'))

          );

        };



        const compFromVendor = vendorTickets.filter(isCompTicket);

        console.log('[Dashboard] comp tickets found in vendor_tickets:', compFromVendor.length, compFromVendor.map(t => t.ticket_type_name));



        if (compFromVendor.length > 0) {

          data.vendor_tickets = vendorTickets.filter(t => !isCompTicket(t));

          // Enrich comp tickets with vendor business name from orders if missing

          const enriched = compFromVendor.map(t => {

            if (!t.vendor_business_name && ordersRes?.data) {

              const order = ordersRes.data.find(o => o.id === t.order_id);

              const booths = order?.metadata?.vendor_booths;

              if (booths && booths.length > 0) {

                return { ...t, vendor_business_name: booths[0].business_name || booths[0].legal_name || '' };

              }

            }

            return t;

          });

          data.festival_tickets = [...festivalTickets, ...enriched];

          console.log('[Dashboard] After re-categorization: festival_tickets:', data.festival_tickets.length, 'vendor_tickets:', data.vendor_tickets.length);

        }



        setTickets(data);



      }



      if (ordersRes?.success) setOrders(ordersRes.data);



      if (transfersRes?.success) {

        setSentTransfers(transfersRes.data?.sent || []);

        setReceivedTransfers(transfersRes.data?.received || []);

      }



    } catch (err) {



      console.error('Failed to load dashboard data:', err);



    }



  };







  const loadAllDashboardData = async () => {



    try {



      await Promise.all([



        loadDashboardData(),



        loadUserProfile(),



        loadVendorDocuments(),



        // Load affiliate info on dashboard mount

        api.getMyAffiliateInfo().then(res => {

          if (res?.success && res.data) {

            setAffiliateInfo(res.data);

            setZelleEmail(res.data.zelle_email || '');

            setZellePhone(formatZellePhoneInput(res.data.zelle_phone || ''));

            setAffiliateOrdersPage(1);

          }

        }).catch(() => { }),



        api.getMyAffiliatePayouts().then(res => {

          if (res?.success) setAffiliatePayouts(res.data || []);

        }).catch(() => { })



      ]);



    } finally {



      setLoading(false);



    }



  };







  const handleLogout = async () => {



    await logout();



    navigate('/');



  };







  // Apple Wallet pass handler



  const handleAppleWallet = async (ticketId) => {



    setWalletLoading(prev => ({ ...prev, [`apple_${ticketId}`]: true }));



    // Open blank window BEFORE async call to avoid popup blocker (non-iOS only)

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    const walletWindow = !isIOS ? window.open('about:blank', '_blank') : null;



    try {



      const response = await api.createAppleWalletPass(ticketId);



      if (response?.inAppBrowser) {

        if (walletWindow && !walletWindow.closed) walletWindow.close();

        alert(response.error.message);

        return;

      }



      if (response?.success && response?.download_url) {

        if (isIOS) {

          window.location.href = response.download_url;

        } else if (walletWindow && !walletWindow.closed) {

          walletWindow.location.href = response.download_url;

        } else {

          window.location.href = response.download_url;

        }

        return;

      }



      if (walletWindow && !walletWindow.closed) walletWindow.close();

      alert(response?.error?.message || 'Apple Wallet is not available yet.');



    } catch (err) {



      if (walletWindow && !walletWindow.closed) walletWindow.close();

      console.error('Apple Wallet error:', err);

      alert('Apple Wallet is not available. Please download your ticket PDF instead.');



    } finally {



      setWalletLoading(prev => ({ ...prev, [`apple_${ticketId}`]: false }));



    }



  };







  // Google Wallet pass handler



  const handleGoogleWallet = async (ticketId) => {



    setWalletLoading(prev => ({ ...prev, [`google_${ticketId}`]: true }));



    // Open blank window BEFORE async call to avoid popup blocker

    const walletWindow = window.open('about:blank', '_blank');



    try {



      const response = await api.createGoogleWalletPass(ticketId);



      if (response?.success && response?.save_url) {



        if (walletWindow && !walletWindow.closed) {

          walletWindow.location.href = response.save_url;

        } else {

          window.location.href = response.save_url;

        }



      } else {



        if (walletWindow && !walletWindow.closed) walletWindow.close();



        alert(response?.error?.message || 'Google Wallet is not available yet.');



      }



    } catch (err) {



      if (walletWindow && !walletWindow.closed) walletWindow.close();



      console.error('Google Wallet error:', err);



      alert('Google Wallet is not available. Please download your ticket PDF instead.');



    } finally {



      setWalletLoading(prev => ({ ...prev, [`google_${ticketId}`]: false }));



    }



  };







  const [acceptingTransferId, setAcceptingTransferId] = useState(null);

  const [recallingTransferId, setRecallingTransferId] = useState(null);

  const [recallingGroupKey, setRecallingGroupKey] = useState(null);

  const [returningGroupKey, setReturningGroupKey] = useState(null);



  const handleRecallTransfer = async (transferId) => {

    if (!window.confirm('Are you sure you want to recall this transfer? The ticket will be returned to your account.')) return;

    setRecallingTransferId(transferId);

    try {

      const response = await api.cancelTransfer(transferId);

      if (response?.success) {

        await loadDashboardData();

      } else {

        alert(response?.error?.message || 'Failed to recall transfer');

      }

    } catch (err) {

      alert(err.message || 'Failed to recall transfer');

    } finally {

      setRecallingTransferId(null);

    }

  };



  const handleRecallTransferGroup = async (transferIds, groupKey) => {

    const ids = (transferIds || []).filter(Boolean);

    if (ids.length === 0) return;

    const confirmMsg = ids.length > 1

      ? `Recall this entire pass? All ${ids.length} ticket codes will be returned to your account.`

      : 'Are you sure you want to recall this transfer? The ticket will be returned to your account.';

    if (!window.confirm(confirmMsg)) return;

    setRecallingGroupKey(groupKey);

    try {

      const results = await Promise.all(ids.map(id => api.cancelTransfer(id).catch(e => ({ success: false, error: { message: e?.message } }))));

      const failed = results.filter(r => !r?.success);

      if (failed.length) alert(failed[0]?.error?.message || 'Failed to recall one or more ticket codes');

      await loadDashboardData();

    } catch (err) {

      alert(err.message || 'Failed to recall transfer');

    } finally {

      setRecallingGroupKey(null);

    }

  };



  const handleReturnTransferGroup = async (transferIds, groupKey) => {

    const ids = (transferIds || []).filter(Boolean);

    if (ids.length === 0) return;

    const confirmMsg = ids.length > 1

      ? `Return this entire pass (${ids.length} ticket codes) to the original sender?`

      : 'Are you sure you want to return this ticket to the original sender?';

    if (!window.confirm(confirmMsg)) return;

    setReturningGroupKey(groupKey);

    try {

      const results = await Promise.all(ids.map(id => api.returnTransfer(id).catch(e => ({ success: false, error: { message: e?.message } }))));

      const failed = results.filter(r => !r?.success);

      if (failed.length) alert(failed[0]?.error?.message || 'Failed to return one or more ticket codes');

      await loadDashboardData();

    } catch (err) {

      alert(err.message || 'Failed to return ticket');

    } finally {

      setReturningGroupKey(null);

    }

  };



  const handleAcceptTransfer = async (transferId) => {

    setAcceptingTransferId(transferId);

    try {

      const response = await api.acceptTransferById(transferId);

      if (response?.success) {

        await loadDashboardData();

      } else {

        alert(response?.error?.message || 'Failed to accept transfer');

      }

    } catch (err) {

      alert(err.message || 'Failed to accept transfer');

    } finally {

      setAcceptingTransferId(null);

    }

  };



  const handleTransfer = async () => {



    const ticketsToTransfer = transferModal.tickets || (transferModal.ticket ? [transferModal.ticket] : []);

    if (!transferEmail || ticketsToTransfer.length === 0) return;







    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;



    if (!emailRegex.test(transferEmail)) {



      setTransferError('Please enter a valid email address');



      return;



    }







    setTransferLoading(true);



    setTransferError('');



    setTransferSuccess(false);







    try {



      let response;

      if (ticketsToTransfer.length > 1) {

        response = await api.createBulkTransfer(ticketsToTransfer.map(t => t.id), transferEmail, transferLabel);

      } else {

        response = await api.createTransfer(ticketsToTransfer[0].id, transferEmail, transferLabel);

      }



      if (response?.success) {



        setTransferSuccess(true);



        await loadDashboardData(); // Reload tickets



      } else {



        setTransferError(response?.error?.message || 'Failed to initiate transfer');



        setTransferSuccess(false);



      }



    } catch (err) {



      setTransferError(err.message || 'Failed to initiate transfer');



      setTransferSuccess(false);



    } finally {



      setTransferLoading(false);



    }



  };







  // Check if user is a vendor (has vendor tickets, user_type, or vendor booth orders)



  const hasVendorOrder = orders.some(order => {

    if (order.status === 'REFUNDED') return false;

    const meta = order.metadata || {};

    if (meta.vendor_booths?.length > 0) return true;

    const items = order.items || [];

    return items.some(item => {

      const name = (item.ticket_type_name || item.name || '').toLowerCase();

      return name.includes('vendor') || name.includes('booth') || name.includes('bazaar') || name.includes('food truck') || name.includes('food booth');

    });

  });



  const activeVendorTickets = (tickets.vendor_tickets || []).filter((ticket) => !isVoidedTicket(ticket));

  const isVendor = (activeVendorTickets.length > 0) ||



    user?.user_type === 'food_vendor' ||



    user?.user_type === 'bazaar_vendor' ||



    userProfile?.user_type === 'food_vendor' ||



    userProfile?.user_type === 'bazaar_vendor' ||



    hasVendorOrder ||



    vendorDocuments.length > 0;



  // Collect ALL vendor orders for history display in vendor-status tab (exclude fully refunded)

  const allVendorOrders = orders.filter(o => o.vendor_status && o.metadata?.vendor_booths?.length > 0 && o.status !== 'REFUNDED');

  const buildVendorInfo = (order) => {

    const booth = order.metadata.vendor_booths[0] || {};

    const businessName = booth.legal_name || booth.business_name || booth.booth_name || '';

    const boothSize = booth.booth_size || '10x10';

    const businessType = booth.business_type || '';

    const boothType = booth.booth_type || '';

    const isFoodTruck = boothType.toLowerCase().includes('food-truck') || boothType.toLowerCase().includes('food_truck');

    let boothLabel = '';

    if (isFoodTruck) {

      boothLabel = 'Food/Beverage Truck';

    } else if (businessType.toLowerCase().includes('food')) {

      boothLabel = boothSize + ' Food/Beverage Booth';

    } else if (businessType.toLowerCase().includes('bazaar')) {

      boothLabel = boothSize + ' Bazaar Booth';

    } else {

      boothLabel = boothSize + ' Vendor Booth';

    }

    return {

      status: order.vendor_status,

      businessName,

      orderNumber: order.order_number,

      boothLabel,

      vendorName: order.buyer?.full_name || user?.full_name || '',

      orderId: order.id,

      createdAt: order.created_at,

      totalPaid: Number(order.total || 0),

      licensePlateNumber: booth.license_plate_number || '',

      productType: booth.product_type || '',

      isFoodTruck,

    };

  };

  // Priority: PENDING > APPROVED > REJECTED for the active one on dashboard overview

  const statusPriority = { PENDING: 0, APPROVED: 1, REJECTED: 2 };

  const activeVendorOrder = [...allVendorOrders].sort((a, b) => (statusPriority[a.vendor_status] ?? 9) - (statusPriority[b.vendor_status] ?? 9))[0];

  const vendorOrderInfo = activeVendorOrder ? buildVendorInfo(activeVendorOrder) : null;

  const allVendorOrderInfos = allVendorOrders.map(buildVendorInfo);

  // Vendors with vendor_status are "new flow" vendors; legacy vendors (no vendor_status) keep old UI

  const isNewFlowVendor = !!vendorOrderInfo;

  const vendorIsPending = vendorOrderInfo?.status === 'PENDING';

  const vendorIsApproved = vendorOrderInfo?.status === 'APPROVED';

  const showVendorDashboardHelperText = isNewFlowVendor && (vendorIsPending || vendorIsApproved);

  const dashboardHelperText = showVendorDashboardHelperText

    ? 'Welcome to your dashboard. Here you can find vendor documents and other important information. Please use the menu to your left (desktop) or click on the dropdown menu above (mobile)'

    : 'Please find your tickets below. Select any to view additional details.';



  // Initialize "seen" flag from localStorage once we know the vendor order info

  // Key includes orderId + status so if status changes (PENDING → APPROVED), the card shows again

  useEffect(() => {

    if (vendorOrderInfo && !vendorIsPending) {

      const seenKey = `vendorStatusSeen_${vendorOrderInfo.orderId}_${vendorOrderInfo.status}`;

      const alreadySeen = localStorage.getItem(seenKey) === 'true';

      setVendorStatusSeenOnDashboard(alreadySeen);

      console.log('[Dashboard] Vendor status seen check:', seenKey, '=', alreadySeen);

    }

  }, [vendorOrderInfo?.orderId, vendorOrderInfo?.status, vendorIsPending]); // eslint-disable-line react-hooks/exhaustive-deps



  // Mark approved/rejected card as "seen" ONLY when user navigates AWAY from dashboard

  // after the card was rendered at least once

  useEffect(() => {

    if (activeSection !== 'dashboard' && vendorCardShownOnDashboard && vendorOrderInfo && !vendorIsPending) {

      const seenKey = `vendorStatusSeen_${vendorOrderInfo.orderId}_${vendorOrderInfo.status}`;

      localStorage.setItem(seenKey, 'true');

      setVendorStatusSeenOnDashboard(true);

      setVendorCardShownOnDashboard(false);

      console.log('[Dashboard] Marked vendor status as seen:', seenKey);

    }

  }, [activeSection]); // eslint-disable-line react-hooks/exhaustive-deps



  // Scroll to top of dashboard content whenever the active tab changes

  useEffect(() => {

    const contentEl = document.querySelector('.dashboard-content');

    if (contentEl) contentEl.scrollTop = 0;

    window.scrollTo({ top: 0, behavior: 'instant' });

  }, [activeSection]);



  useEffect(() => {

    const updateAmpTabsStickyMetrics = () => {

      if (typeof window === 'undefined') return;

      const mobile = window.innerWidth <= 768;

      setIsMobileViewport((prev) => (prev === mobile ? prev : mobile));

      if (!mobile) {

        setIsAmpTabsSticky(false);

        return;

      }

      const headerEl = document.querySelector('.header');

      if (!headerEl) {

        setAmpTabsStickyTop((prev) => (prev === 92 ? prev : 92));

        return;

      }

      const headerBottom = Math.max(0, headerEl.getBoundingClientRect().bottom);

      const nextTop = Math.max(56, Math.round(headerBottom + 8));

      setAmpTabsStickyTop((prev) => (prev === nextTop ? prev : nextTop));

      // Determine if tabs should be sticky based on original document position

      if (ampTabsRef.current) {

        if (tabsOriginalTopRef.current === null) {

          tabsOriginalTopRef.current = ampTabsRef.current.offsetTop;

        }

        setIsAmpTabsSticky(window.scrollY + nextTop >= tabsOriginalTopRef.current);

      }

    };



    updateAmpTabsStickyMetrics();

    window.addEventListener('scroll', updateAmpTabsStickyMetrics, { passive: true });

    window.addEventListener('resize', updateAmpTabsStickyMetrics);

    return () => {

      window.removeEventListener('scroll', updateAmpTabsStickyMetrics);

      window.removeEventListener('resize', updateAmpTabsStickyMetrics);

    };

  }, []);



  useEffect(() => {

    setAmpTicketsPage(1);

  }, [ampDayTab, tickets.amphitheater_tickets?.length]);



  useEffect(() => {

    setFestivalTicketsPage(1);

  }, [tickets.festival_tickets?.length, tickets.vendor_tickets?.length]);



  useEffect(() => {

    setParkingTicketsPage(1);

  }, [tickets.parking_tickets?.length]);



  // Load saved card when payment-methods tab is opened

  useEffect(() => {

    if (activeSection === 'payment-methods') {

      loadSavedCard();

    }

  }, [activeSection]); // eslint-disable-line react-hooks/exhaustive-deps





  const getAmpEventDate = (ticket) => ticket.amphitheater_ticket?.event_date || ticket.metadata?.event_date || '';

  const ampTicketsSat = (tickets.amphitheater_tickets || []).filter(t => getAmpEventDate(t) === '2026-06-20');

  const ampTicketsSun = (tickets.amphitheater_tickets || []).filter(t => getAmpEventDate(t) === '2026-06-21');

  const ampTicketsAll = (tickets.amphitheater_tickets || []).filter(t => {

    const eventDate = getAmpEventDate(t);

    return eventDate === '2026-06-20' || eventDate === '2026-06-21';

  });



  const renderDashboardPagination = (currentPage, totalPages, totalItems, onPageChange) => {

    if (totalPages <= 1) return null;



    const startItem = ((currentPage - 1) * DASHBOARD_TICKETS_PAGE_SIZE) + 1;

    const endItem = Math.min(currentPage * DASHBOARD_TICKETS_PAGE_SIZE, totalItems);



    return (

      <div style={{

        display: 'flex',

        justifyContent: 'space-between',

        alignItems: 'center',

        gap: '0.75rem',

        flexWrap: 'wrap',

        marginTop: '1rem'

      }}>

        <div style={{ fontSize: '0.88rem', color: '#6b7280' }}>

          Showing {startItem}-{endItem} of {totalItems}

        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>

          <button

            onClick={() => onPageChange(Math.max(1, currentPage - 1))}

            disabled={currentPage === 1}

            style={{

              padding: '0.45rem 0.85rem',

              backgroundColor: currentPage === 1 ? '#f3f4f6' : '#fff',

              color: currentPage === 1 ? '#9ca3af' : '#374151',

              border: '1px solid #d1d5db',

              borderRadius: '8px',

              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',

              fontSize: '0.85rem',

              fontWeight: 600

            }}

          >

            Previous

          </button>

          <span style={{ fontSize: '0.88rem', fontWeight: 600, color: '#374151' }}>

            Page {currentPage} of {totalPages}

          </span>

          <button

            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}

            disabled={currentPage === totalPages}

            style={{

              padding: '0.45rem 0.85rem',

              backgroundColor: currentPage === totalPages ? '#f3f4f6' : '#fff',

              color: currentPage === totalPages ? '#9ca3af' : '#374151',

              border: '1px solid #d1d5db',

              borderRadius: '8px',

              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',

              fontSize: '0.85rem',

              fontWeight: 600

            }}

          >

            Next

          </button>

        </div>

      </div>

    );

  };



  const menuItems = [



    { id: 'dashboard', label: 'Dashboard' },



    { id: 'social-media', label: 'Social Media Toolkit' },



    { id: 'amphitheater-tickets', label: 'Amphitheater Tickets' },



    { id: 'tickets', label: 'Festival Tickets' },



    ...((Boolean(tickets?.vip_parking_eligible) || (tickets?.parking_tickets || []).length > 0)
      ? [{ id: 'parking-passes', label: 'Parking Passes' }]
      : []),



    // Hide vendor tickets for new-flow pending vendors

    ...(isNewFlowVendor && vendorIsPending ? [] : [{ id: 'vendor-tickets', label: 'Vendor Tickets' }]),



    // Show Vendor Status tab for new-flow vendors

    ...(isNewFlowVendor ? [{ id: 'vendor-status', label: 'Vendor Status' }] : []),



    // Vendor Docs & Info tab — only for users who purchased a vendor booth

    ...(hasVendorOrder ? [{ id: 'vendor-documents', label: 'Vendor Docs & Info' }] : []),



    { id: 'orders', label: 'Orders' },



    { id: 'downloads', label: 'Downloads' },



    ...(affiliateInfo ? [{ id: 'affiliate-program', label: 'Affiliate Program' }] : []),



    { id: 'addresses', label: 'Addresses' },



    { id: 'payment-methods', label: 'Payment Methods' },



    { id: 'account-details', label: 'Account details' },



    { id: 'logout', label: 'Log out' }



  ];







  const generateInvoice = (order) => {

    const invoiceWindow = window.open('', '_blank');

    if (!invoiceWindow) {

      toast.error('Please allow popups to download your invoice.');

      return;

    }

    const orderDate = new Date(order.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

    const invoiceStatusClass = order.status === 'DISPUTED' ? 'status-disputed' : 'status-paid';

    const invoiceStatusLabel = order.status === 'DISPUTED' ? 'DISPUTED' : 'PAID';

    const subtotal = Number(order.total) - Number(order.tax || 0);

    const items = order.items || order.tickets || [];

    const isVendorOrder = order.metadata?.vendor_booths?.length > 0;

    const vendorBooth = isVendorOrder ? order.metadata.vendor_booths[0] : null;

    const vendorLegalName = vendorBooth?.legal_name || vendorBooth?.legal_business_name || vendorBooth?.business_name || '';

    const vendorFullName = vendorBooth?.vendor_name || order.buyer?.full_name || user?.full_name || '';

    const vendorPhone = vendorBooth?.vendor_phone || vendorBooth?.phone || order.buyer?.phone || user?.phone || '';

    const vendorEmail = vendorBooth?.vendor_email || order.buyer?.email || user?.email || '';



    // For Bill To: show full name first, then legal business name, phone, email

    const buyerFullName = vendorFullName || user?.full_name || user?.email || '';

    const buyerEmail = vendorEmail || user?.email || '';

    const buyerPhone = vendorPhone || user?.phone || '';



    // Build Bill To section

    let billToHtml = '';

    if (isVendorOrder && vendorLegalName) {

      billToHtml = `<strong>${buyerFullName}</strong>`;

      billToHtml += `<br>${vendorLegalName}`;

      if (buyerPhone) billToHtml += `<br>${buyerPhone}`;

      billToHtml += `<br>${buyerEmail}`;

    } else {

      billToHtml = `<strong>${buyerFullName}</strong>`;

      if (buyerPhone) billToHtml += `<br>${buyerPhone}`;

      billToHtml += `<br>${buyerEmail}`;

    }



    // Build enhanced item rows with AMP ticket details (section/row/seat)

    const buildItemDescription = (item) => {

      let name = item.ticket_type_name || item.name || item.description || 'Festival Ticket';

      // Check if this is an amphitheater ticket — add seat details

      const nameLower = name.toLowerCase();

      if (nameLower.includes('amphitheater') || nameLower.includes('amp')) {

        // Collect seat info from order metadata amphitheater_items[].seatDetails[]

        const ampItems = order.metadata?.amphitheater_items || [];

        const allSeats = [];

        ampItems.forEach(ai => {

          (ai.seatDetails || []).forEach(sd => {

            allSeats.push(`${sd.section || ''} Row ${sd.row || ''}, Seat ${sd.number || ''}`);

          });

        });

        if (allSeats.length > 0) {

          name += `<br><span style="font-size:12px;color:#6b7280">${allSeats.join('; ')}</span>`;

        }

      }

      return name;

    };



    const itemRows = items.length > 0

      ? items.map((item, i) => {

        const name = buildItemDescription(item);

        const qty = item.quantity || 1;

        const price = item.price || item.unit_price || (Number(order.total) / (items.length || 1));

        return `<tr>

            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;font-size:14px">${i + 1}</td>

            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;font-size:14px">${name}</td>

            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:center;font-size:14px">${qty}</td>

            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:right;font-size:14px">$${Number(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>

            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:right;font-size:14px;font-weight:600">$${(Number(price) * qty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>

          </tr>`;

      }).join('')

      : `<tr>

          <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;font-size:14px">1</td>

          <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;font-size:14px">Festival Tickets</td>

          <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:center;font-size:14px">1</td>

          <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:right;font-size:14px">$${subtotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>

          <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:right;font-size:14px;font-weight:600">$${subtotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>

        </tr>`;



    const discountCents = order.metadata?.discount_cents || 0;

    const couponCode = order.metadata?.coupon_code || '';



    invoiceWindow.document.write(`<!DOCTYPE html><html><head><title>Invoice - ${order.order_number}</title>

    <style>

      * { margin:0; padding:0; box-sizing:border-box; }

      body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; color:#1a1a1a; background:#f8fafc; padding:40px; }

      .invoice { max-width:800px; margin:0 auto; background:#fff; border-radius:12px; box-shadow:0 1px 3px rgba(0,0,0,0.1); overflow:hidden; }

      .header { padding:40px; display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #e5e7eb; }

      .header h1 { font-size:28px; font-weight:700; letter-spacing:0.5px; color:#1a1a2e; }

      .header .brand { font-size:13px; color:#6b7280; margin-top:4px; }

      .header .invoice-meta { text-align:right; font-size:13px; line-height:1.8; color:#374151; }

      .header .invoice-meta .label { color:#6b7280; }

      .body { padding:40px; }

      .parties { display:flex; justify-content:space-between; margin-bottom:32px; gap:40px; }

      .party h3 { font-size:11px; text-transform:uppercase; letter-spacing:1.5px; color:#6b7280; margin-bottom:8px; font-weight:600; }

      .party p { font-size:14px; line-height:1.7; color:#374151; }

      table { width:100%; border-collapse:collapse; margin-bottom:24px; }

      thead th { background:#f9fafb; padding:10px 12px; text-align:left; font-size:11px; text-transform:uppercase; letter-spacing:0.5px; color:#6b7280; font-weight:600; border-bottom:2px solid #e5e7eb; }

      .totals { display:flex; justify-content:flex-end; }

      .totals-table { width:260px; }

      .totals-table .row { display:flex; justify-content:space-between; padding:6px 0; font-size:14px; color:#374151; }

      .totals-table .row.total { border-top:2px solid #1a1a2e; padding-top:10px; margin-top:6px; font-size:16px; font-weight:700; color:#1a1a2e; }

      .footer { border-top:1px solid #e5e7eb; padding:24px 40px; text-align:center; color:#9ca3af; font-size:12px; line-height:1.8; }

      .status-badge { display:inline-block; padding:4px 12px; border-radius:20px; font-size:12px; font-weight:600; }

      .status-paid { background:#dcfce7; color:#166534; }

      .status-disputed { background:#fee2e2; color:#b91c1c; }

      .status-refunded { background:#fee2e2; color:#991b1b; }

      .status-partial { background:#ffedd5; color:#9a3412; }

      @media print { body { padding:0; background:#fff; } .invoice { box-shadow:none; } }

    </style></head><body>

    <div class="invoice">

      <div class="header">

        <div style="display:flex;align-items:center;gap:16px">

          <img src="${window.location.origin}/logo.webp" alt="OC MENA Festival" style="height:48px;width:auto;border-radius:6px" />

          <div>

            <h1>INVOICE</h1>

            <div class="brand">OC MENA Festival 2026</div>

          </div>

        </div>

        <div class="invoice-meta">

          <div><span class="label">Invoice #:</span> <strong>${order.order_number}</strong></div>

          <div><span class="label">Date:</span> ${orderDate}</div>

          <div><span class="label">Status:</span> <span class="status-badge ${invoiceStatusClass}">${invoiceStatusLabel}</span></div>

        </div>

      </div>

      <div class="body">

        <div class="parties">

          <div class="party">

            <h3>From</h3>

            <p><strong>OC MENA Festival</strong><br>Irvine, CA 92602<br>United States<br>info@ocmenafestival.com</p>

          </div>

          <div class="party">

            <h3>Bill To</h3>

            <p>${billToHtml}</p>

          </div>

        </div>

        <table>

          <thead><tr>

            <th style="width:40px">#</th>

            <th>Description</th>

            <th style="text-align:center;width:60px">Qty</th>

            <th style="text-align:right;width:100px">Unit Price</th>

            <th style="text-align:right;width:100px">Amount</th>

          </tr></thead>

          <tbody>${itemRows}</tbody>

        </table>

        <div class="totals">

          <div class="totals-table">

            <div class="row"><span>Subtotal</span><span>$${subtotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>

            ${discountCents > 0 ? `<div class="row" style="color:#059669"><span>${couponCode && (couponCode.startsWith('UPAMP') || couponCode.startsWith('UPPASS')) ? 'Upsell Discount (' + (order.metadata?.discount_percent || '') + '% off)' : 'Discount' + (couponCode ? ' (' + couponCode + ')' : '')}</span><span>-$${(discountCents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>` : ''}

            ${Number(order.tax) > 0 ? `<div class="row"><span>Tax (7.75%)</span><span>$${Number(order.tax).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>` : ''}

            <div class="row total"><span>Total</span><span>$${Number(order.total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>

          </div>

        </div>

        <div style="margin-top:32px;padding:16px;background:#f0fdf4;border-radius:8px;border:1px solid #bbf7d0">

          <p style="font-size:13px;color:#166534;margin:0">

            <strong>Payment:</strong> ${order.payment_method === 'cash' ? 'Cash on Delivery' : order.payment_method === 'card' ? 'Credit Card' + (order.card_last4 ? ' ****' + order.card_last4 : '') : 'Credit Card'}

          </p>

        </div>

      </div>

      <div class="footer">

        <p>Thank you for your purchase!</p>

        <p>OC MENA Festival &mdash; Irvine, CA &mdash; www.ocmenafestival.com</p>

      </div>

    </div>

    <script>window.onload = function() { window.print(); }</script>

    </body></html>`);

    invoiceWindow.document.close();

  };



  const generateRefundInvoice = (order) => {

    const invoiceWindow = window.open('', '_blank');

    if (!invoiceWindow) {

      toast.error('Please allow popups to download your refund invoice.');

      return;

    }

    const refundDate = order.metadata?.refund_date

      ? new Date(order.metadata.refund_date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })

      : new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

    const isPartial = order.status === 'PARTIALLY_REFUNDED';

    const refundedDollars = (order.refunded_cents || 0) / 100;

    const totalCharged = Number(order.total);

    const netAfterRefund = totalCharged - refundedDollars;

    const refundReason = order.metadata?.refund_reason || '';



    const isVendorOrder = order.metadata?.vendor_booths?.length > 0;

    const vendorBooth = isVendorOrder ? order.metadata.vendor_booths[0] : null;

    const vendorLegalName = vendorBooth?.legal_name || vendorBooth?.legal_business_name || vendorBooth?.business_name || '';

    const vendorFullName = vendorBooth?.vendor_name || order.buyer?.full_name || user?.full_name || '';

    const vendorPhone = vendorBooth?.vendor_phone || vendorBooth?.phone || order.buyer?.phone || user?.phone || '';

    const vendorEmail = vendorBooth?.vendor_email || order.buyer?.email || user?.email || '';

    const buyerFullName = vendorFullName || user?.full_name || user?.email || '';

    const buyerEmail = vendorEmail || user?.email || '';

    const buyerPhone = vendorPhone || user?.phone || '';



    let billToHtml = '';

    if (isVendorOrder && vendorLegalName) {

      billToHtml = `<strong>${buyerFullName}</strong><br>${vendorLegalName}`;

      if (buyerPhone) billToHtml += `<br>${buyerPhone}`;

      billToHtml += `<br>${buyerEmail}`;

    } else {

      billToHtml = `<strong>${buyerFullName}</strong>`;

      if (buyerPhone) billToHtml += `<br>${buyerPhone}`;

      billToHtml += `<br>${buyerEmail}`;

    }



    invoiceWindow.document.write(`<!DOCTYPE html><html><head><title>Refund - ${order.order_number}</title>

    <style>

      * { margin:0; padding:0; box-sizing:border-box; }

      body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; color:#1a1a1a; background:#f8fafc; padding:40px; }

      .invoice { max-width:800px; margin:0 auto; background:#fff; border-radius:12px; box-shadow:0 1px 3px rgba(0,0,0,0.1); overflow:hidden; }

      .header { padding:40px; display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #fecaca; }

      .header h1 { font-size:28px; font-weight:700; letter-spacing:0.5px; color:#991b1b; }

      .header .brand { font-size:13px; color:#6b7280; margin-top:4px; }

      .header .invoice-meta { text-align:right; font-size:13px; line-height:1.8; color:#374151; }

      .header .invoice-meta .label { color:#6b7280; }

      .body { padding:40px; }

      .parties { display:flex; justify-content:space-between; margin-bottom:32px; gap:40px; }

      .party h3 { font-size:11px; text-transform:uppercase; letter-spacing:1.5px; color:#6b7280; margin-bottom:8px; font-weight:600; }

      .party p { font-size:14px; line-height:1.7; color:#374151; }

      .totals { display:flex; justify-content:flex-end; }

      .totals-table { width:300px; }

      .totals-table .row { display:flex; justify-content:space-between; padding:8px 0; font-size:14px; color:#374151; }

      .totals-table .row.total { border-top:2px solid #991b1b; padding-top:12px; margin-top:8px; font-size:18px; font-weight:700; color:#991b1b; }

      .totals-table .row.net { border-top:2px solid ${isPartial ? '#f97316' : '#991b1b'}; padding-top:12px; margin-top:8px; font-size:16px; font-weight:700; color:${isPartial ? '#9a3412' : '#991b1b'}; }

      .footer { border-top:1px solid #e5e7eb; padding:24px 40px; text-align:center; color:#9ca3af; font-size:12px; line-height:1.8; }

      .status-badge { display:inline-block; padding:4px 12px; border-radius:20px; font-size:12px; font-weight:600; }

      .status-refunded { background:#fee2e2; color:#991b1b; }

      .status-partial { background:#ffedd5; color:#9a3412; }

      @media print { body { padding:0; background:#fff; } .invoice { box-shadow:none; } }

    </style></head><body>

    <div class="invoice">

      <div class="header">

        <div style="display:flex;align-items:center;gap:16px">

          <img src="${window.location.origin}/logo.webp" alt="OC MENA Festival" style="height:48px;width:auto;border-radius:6px" />

          <div>

            <h1>CREDIT MEMO</h1>

            <div class="brand">OC MENA Festival 2026</div>

          </div>

        </div>

        <div class="invoice-meta">

          <div><span class="label">Ref:</span> <strong>${order.order_number}</strong></div>

          <div><span class="label">Refund Date:</span> ${refundDate}</div>

          <div><span class="label">Status:</span> <span class="status-badge ${isPartial ? 'status-partial' : 'status-refunded'}">${isPartial ? 'PARTIALLY REFUNDED' : 'REFUNDED'}</span></div>

        </div>

      </div>

      <div class="body">

        <div class="parties">

          <div class="party">

            <h3>From</h3>

            <p><strong>OC MENA Festival</strong><br>Irvine, CA 92602<br>United States<br>info@ocmenafestival.com</p>

          </div>

          <div class="party">

            <h3>Refund To</h3>

            <p>${billToHtml}</p>

          </div>

        </div>

        ${refundReason ? `<div style="margin-bottom:24px;padding:12px 16px;background:#fef2f2;border-radius:8px;border:1px solid #fecaca"><p style="font-size:13px;color:#991b1b;margin:0"><strong>Reason:</strong> ${refundReason}</p></div>` : ''}

        <div class="totals">

          <div class="totals-table">

            <div class="row"><span>Original Total Charged</span><span>$${totalCharged.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>

            <div class="row total"><span>Refund Amount</span><span style="color:#dc2626">-$${refundedDollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>

            <div class="row net"><span>${isPartial ? 'Amount After Refund' : 'Balance'}</span><span>$${netAfterRefund.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>

          </div>

        </div>

        <div style="margin-top:32px;padding:16px;background:#fef2f2;border-radius:8px;border:1px solid #fecaca">

          <p style="font-size:13px;color:#991b1b;margin:0">

            <strong>Refund Method:</strong> Returned to original payment method${order.card_last4 ? ' (****' + order.card_last4 + ')' : ''}

          </p>

        </div>

      </div>

      <div class="footer">

        <p>This is a refund confirmation for your records.</p>

        <p>OC MENA Festival &mdash; Irvine, CA &mdash; www.ocmenafestival.com</p>

      </div>

    </div>

    <script>window.onload = function() { window.print(); }</script>

    </body></html>`);

    invoiceWindow.document.close();

  };



  // Vendor Status Card — matches the exact design from screenshots

  const renderVendorStatusCard = () => {

    if (!vendorOrderInfo) return null;

    const { status, businessName, orderNumber, boothLabel, vendorName } = vendorOrderInfo;



    const statusConfig = {

      PENDING: { label: 'PENDING', bg: '#FDFBE7', color: '#78350F' },

      APPROVED: { label: 'APPROVED!', bg: '#EFFCF3', color: '#15803D' },

      REJECTED: { label: 'REJECTED', bg: '#FDF1F1', color: '#B81C1C' },

    };

    const cfg = statusConfig[status] || statusConfig.PENDING;



    return (

      <div style={{ borderRadius: '16px', border: '1px solid #e5e7eb', overflow: 'hidden', marginBottom: '24px', background: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>

        <h3 style={{ textAlign: 'center', fontWeight: 700, fontSize: '18px', padding: '20px 20px 12px', margin: 0, color: '#1a1a2e' }}>Vendor Approval Status</h3>



        {/* Status banner */}

        <div style={{ background: cfg.bg, padding: '28px 24px', textAlign: 'center', margin: '0 20px', borderRadius: '12px' }}>

          <div style={{ fontSize: '32px', fontWeight: 800, color: cfg.color, marginBottom: '8px', letterSpacing: '1px' }}>{cfg.label}</div>

          <div style={{ fontSize: '16px', fontWeight: 700, color: cfg.color, marginBottom: '4px' }}>{businessName}</div>

          <div style={{ fontSize: '14px', color: '#555', marginBottom: '12px' }}>Order #{orderNumber}</div>

          <div style={{ fontSize: '14px', color: cfg.color }}>{boothLabel}</div>

        </div>



        {/* Bottom section */}

        <div style={{ padding: '20px 24px', textAlign: 'center' }}>

          {status === 'PENDING' && (

            <>

              <p style={{ margin: '0 0 4px', fontSize: '14px', color: '#333' }}>You will receive an email within 1-2 business days!</p>

              <p style={{ margin: '0 0 16px', fontSize: '14px', color: '#333' }}>Please check your spam/junk folder</p>

            </>

          )}



          {status === 'APPROVED' && (() => {

            const cDoc = getDocumentByType('CONTRACT');

            const cSigned = cDoc?.is_signed;

            if (cSigned) return null;

            return (

              <button

                onClick={handleSignContract}

                disabled={documentUploading.CONTRACT}

                style={{

                  display: 'inline-block', background: '#D42533', color: '#fff', fontSize: '16px', fontWeight: 600,

                  padding: '14px 48px', borderRadius: '30px', border: 'none', cursor: documentUploading.CONTRACT ? 'wait' : 'pointer',

                  marginBottom: '16px', opacity: documentUploading.CONTRACT ? 0.7 : 1,

                }}

              >

                {documentUploading.CONTRACT ? 'Loading...' : 'Sign Vendor Agreement'}

              </button>

            );

          })()}



          {status === 'REJECTED' && (

            <div style={{ textAlign: 'left', padding: '0 8px', fontSize: '14px', color: '#333', lineHeight: '1.7' }}>

              <p style={{ marginBottom: '12px' }}>Hi {vendorName},</p>

              <p style={{ marginBottom: '12px' }}>Thank you for your interest in participating in OC MENA Festival 2026.</p>

              <p style={{ marginBottom: '12px' }}>After reviewing all submissions, we regret to inform you that we are unable to approve your vendor application at this time.</p>

              <p style={{ marginBottom: '12px' }}>Vendor participation is subject to review and approval to maintain a balanced and diverse marketplace. In some cases, we receive multiple applications within the same category and must limit participation accordingly.</p>

              <p style={{ marginBottom: '12px' }}>Per our vendor policy, we reserve the right to approve or decline applications at our discretion.</p>

              <p style={{ marginBottom: '12px' }}>A full refund of your booth payment will be processed within 5–10 business days to your original payment method.</p>

              <p style={{ marginBottom: '12px' }}>We truly appreciate your interest and encourage you to apply for future events.</p>

              <p style={{ marginBottom: '24px' }}>Sincerely,<br />OC MENA Festival Team</p>



              {/* Refund order summary */}

              <div style={{ border: '1px solid #e5e5e5', borderRadius: '8px', overflow: 'hidden', marginBottom: '20px' }}>

                <div style={{ textAlign: 'center', padding: '16px 16px 4px' }}>

                  <h3 style={{ margin: '0 0 4px', fontSize: '18px', fontWeight: 700, color: '#D42533' }}>Refund Confirmed</h3>

                  <p style={{ margin: 0, fontSize: '13px', color: '#666' }}>Hi {vendorName}, your refund for order <strong>#{orderNumber}</strong> has been processed.</p>

                </div>

                <div style={{ padding: '12px 16px' }}>

                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>

                    <thead>

                      <tr style={{ backgroundColor: '#f9f9f9' }}>

                        <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '11px', color: '#666', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Item</th>

                        <th style={{ padding: '8px 12px', textAlign: 'right', fontSize: '11px', color: '#666', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Status</th>

                      </tr>

                    </thead>

                    <tbody>

                      <tr>

                        <td style={{ padding: '10px 12px', fontSize: '14px', color: '#333' }}>{boothLabel}</td>

                        <td style={{ padding: '10px 12px', fontSize: '14px', color: '#D42533', textAlign: 'right', fontWeight: 600 }}>Refunded</td>

                      </tr>

                      <tr style={{ backgroundColor: '#fef2f2' }}>

                        <td style={{ padding: '10px 12px', fontSize: '14px', fontWeight: 700, color: '#D42533' }}>Refund Total</td>

                        <td style={{ padding: '10px 12px', fontSize: '14px', fontWeight: 700, color: '#D42533', textAlign: 'right' }}>${vendorOrderInfo?.totalPaid?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</td>

                      </tr>

                    </tbody>

                  </table>

                  <p style={{ margin: '8px 0 0', fontSize: '13px', color: '#666' }}>The refund has been recorded in our system.</p>

                </div>

              </div>

            </div>

          )}



          {documentError && status === 'APPROVED' && (

            <div style={{ padding: '10px', backgroundColor: '#fee2e2', color: '#991b1b', borderRadius: '8px', marginBottom: '12px', fontSize: '13px' }}>{documentError}</div>

          )}



          <p style={{ fontWeight: 700, fontSize: '14px', color: '#1a1a2e', margin: '16px 0 4px' }}>For more information:</p>

          <p style={{ margin: '0', fontSize: '14px', color: '#555' }}>razan@ocmenafestival.com</p>

          <p style={{ margin: '0', fontSize: '14px', color: '#555' }}>(949) 208-7791</p>

        </div>

      </div>

    );

  };



  const renderContent = () => {



    if (loading) {



      return (



        <div className="content-section">



          <p>Loading...</p>



        </div>



      );



    }







    switch (activeSection) {



      case 'dashboard':



        return (



          <div className="content-section">



            <h2 className="section-title" style={{ textAlign: 'center', display: 'block', position: 'static' }}>Hi {userName}</h2>



            <p className="section-subtitle">(<span onClick={handleLogout} style={{ cursor: 'pointer', textDecoration: 'underline' }}>not {userName}? Log out</span>)</p>



            <p style={{

              textAlign: 'center',

              color: '#4b5563',

              fontSize: '14px',

              lineHeight: 1.55,

              margin: '-14px auto 20px',

              maxWidth: '760px'

            }}>{dashboardHelperText}</p>



            {/* Incoming transfer invitations on dashboard tab — grouped by sender */}

            {receivedTransfers.filter(t => t.status === 'PENDING' && !t.is_expired).length > 0 && (

              <div style={{

                marginBottom: '1.5rem',

                padding: '1.25rem',

                backgroundColor: '#ede9fe',

                border: '2px solid #8b5cf6',

                borderRadius: '12px'

              }}>

                <h3 style={{ margin: '0 0 0.75rem', fontSize: '1rem', color: '#5b21b6' }}>🎁 Incoming Ticket Transfers</h3>

                {(() => {

                  const pending = receivedTransfers.filter(t => t.status === 'PENDING' && !t.is_expired);

                  const grouped = {};

                  pending.forEach(t => {

                    const key = `${t.from_user_email}__${t.ticket_type || 'Festival Ticket'}`;

                    if (!grouped[key]) grouped[key] = [];

                    grouped[key].push(t);

                  });

                  return Object.values(grouped).map(group => {

                    const first = group[0];

                    const count = group.length;

                    const label = first.ticket_type || 'Festival Ticket';

                    const displayLabel = count > 1 ? `${count}-Day Pass` : label;

                    return (

                      <div key={first.id} style={{

                        display: 'flex',

                        justifyContent: 'space-between',

                        alignItems: 'center',

                        padding: '0.75rem 1rem',

                        backgroundColor: '#fff',

                        borderRadius: '8px',

                        marginBottom: '0.5rem',

                        border: '1px solid #c4b5fd'

                      }}>

                        <div>

                          <p style={{ margin: 0, fontWeight: 600, color: '#1f2937' }}>

                            {displayLabel}

                          </p>

                          <p style={{ margin: '0.25rem 0 0', fontSize: '0.85rem', color: '#6b7280' }}>

                            From: {first.from_user_email}

                          </p>

                        </div>

                        <button

                          onClick={() => handleAcceptTransfer(first.id)}

                          disabled={acceptingTransferId === first.id}

                          style={{

                            padding: '0.5rem 1.25rem',

                            backgroundColor: acceptingTransferId === first.id ? '#a78bfa' : '#8b5cf6',

                            color: '#fff',

                            border: 'none',

                            borderRadius: '8px',

                            fontWeight: 600,

                            fontSize: '0.9rem',

                            cursor: acceptingTransferId === first.id ? 'not-allowed' : 'pointer'

                          }}

                        >

                          {acceptingTransferId === first.id ? 'Accepting...' : 'Accept'}

                        </button>

                      </div>

                    );

                  });

                })()}

              </div>

            )}



            <div className="dashboard-buttons">



              <button className="action-button" style={{ backgroundColor: '#7c3aed', borderColor: '#7c3aed' }} onClick={() => setActiveSection('amphitheater-tickets')}>Amphitheater Tickets ({tickets.amphitheater_tickets?.length || 0})</button>



              <button className="action-button" onClick={() => setActiveSection('tickets')}>Festival Tickets ({(() => {

                const ft = tickets.festival_tickets?.length || 0;

                const compInV = (tickets.vendor_tickets || []).filter(t => {

                  if (isVoidedTicket(t)) return false;

                  const n = (t.ticket_type_name || '').toLowerCase();

                  return t.is_comp === true || t.metadata?.complimentary === true || t.metadata?.type === 'festival_access' || n.includes('complimentary') || (n.includes('festival') && (n.includes('pass') || n.includes('access')));

                }).filter(t => !(tickets.festival_tickets || []).some(f => f.id === t.id)).length;

                return ft + compInV;

              })()})</button>



              {Boolean(tickets?.vip_parking_eligible) && (

                <button className="action-button" style={{ backgroundColor: '#047857', borderColor: '#047857' }} onClick={() => setActiveSection('parking-passes')}>

                  Parking Passes ({tickets.parking_tickets?.length || 0})

                </button>

              )}



              {!isNewFlowVendor && <button className="action-button" onClick={() => setActiveSection('vendor-tickets')}>Vendor Tickets ({activeVendorTickets.length})</button>}



              <button className="action-button" onClick={() => setActiveSection('orders')}>View orders ({orders.length})</button>



              {(userProfile?.is_superuser || userProfile?.is_staff) && (



                <button className="action-button" style={{ backgroundColor: '#dc2626', borderColor: '#dc2626' }} onClick={() => navigate('/hq')}>



                  Admin Dashboard



                </button>



              )}



              {userProfile?.is_staff && (



                <button className="action-button" style={{ backgroundColor: '#7c3aed', borderColor: '#7c3aed' }} onClick={() => navigate('/scanner')}>



                  Scanner



                </button>



              )}



            </div>

            {/* Affiliate Program Card — shown if user is an affiliate */}

            {affiliateInfo && (

              <div style={{

                marginBottom: '1.5rem',

                padding: '1.25rem',

                backgroundColor: '#f0fdf4',

                border: '2px solid #16a34a',

                borderRadius: '12px'

              }}>

                <h3 style={{ margin: '0 0 0.75rem', fontSize: '1rem', color: '#166534' }}>🤝 Affiliate Program</h3>

                <div className="affiliate-overview-inner" style={{

                  display: 'flex',

                  justifyContent: 'space-between',

                  alignItems: 'center',

                  padding: '0.75rem 1rem',

                  backgroundColor: '#fff',

                  borderRadius: '8px',

                  border: '1px solid #bbf7d0'

                }}>

                  <div style={{ flex: 1 }}>

                    <p style={{ margin: 0, fontWeight: 600, color: '#1f2937', display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>

                      Your Promo Code: <span style={{ color: '#16a34a', fontSize: '1.1rem' }}>{affiliateInfo.coupon_code}</span>

                      <button

                        title="Copy coupon code"

                        onClick={() => { navigator.clipboard.writeText(affiliateInfo.coupon_code); }}

                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px', display: 'flex', alignItems: 'center' }}

                      >

                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>

                      </button>

                    </p>

                    <p style={{ margin: '0.25rem 0 0', fontSize: '0.85rem', color: '#6b7280' }}>

                      {affiliateInfo.commission_percent}% commission · {(affiliateInfo.discount_percent !== null && affiliateInfo.discount_percent !== undefined) ? affiliateInfo.discount_percent : 10}% off for customers (any ticket) · {(affiliateInfo.total_orders || 0).toLocaleString()} order(s) · ${Number(affiliateInfo.total_commission || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} earned

                    </p>

                    <div style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>

                      <span style={{ fontSize: '0.82rem', color: '#374151', fontWeight: 500 }}>Referral Link:</span>

                      <code style={{ fontSize: '0.78rem', color: '#16a34a', background: '#ecfdf5', padding: '2px 8px', borderRadius: '4px', wordBreak: 'break-all' }}>{getReferralLink()}</code>

                      <button

                        onClick={copyReferralLink}

                        style={{

                          padding: '4px 12px', fontSize: '0.78rem', fontWeight: 600,

                          background: referralLinkCopied ? '#16a34a' : '#fff', color: referralLinkCopied ? '#fff' : '#16a34a',

                          border: '1.5px solid #16a34a', borderRadius: '6px', cursor: 'pointer',

                          transition: 'all 0.15s', whiteSpace: 'nowrap'

                        }}

                      >

                        {referralLinkCopied ? 'Copied!' : 'Copy Link'}

                      </button>

                    </div>

                  </div>

                  <button

                    className="affiliate-view-details-btn"

                    onClick={() => setActiveSection('affiliate-program')}

                    style={{

                      padding: '0.5rem 1.25rem',

                      backgroundColor: '#16a34a',

                      color: '#fff',

                      border: 'none',

                      borderRadius: '8px',

                      fontWeight: 600,

                      fontSize: '0.9rem',

                      cursor: 'pointer'

                    }}

                  >

                    View Details

                  </button>

                </div>

              </div>

            )}



            {/* Vendor Status Card for new-flow vendors on dashboard tab */}

            {/* PENDING: always show. APPROVED/REJECTED: show once, hide after user navigates away */}

            {isNewFlowVendor && (vendorIsPending || !vendorStatusSeenOnDashboard) && (() => {

              // Flag that the card was shown — useEffect will mark as "seen" when user leaves dashboard tab

              if (!vendorIsPending && !vendorCardShownOnDashboard) {

                setTimeout(() => setVendorCardShownOnDashboard(true), 0);

              }

              return renderVendorStatusCard();

            })()}



            {/* MENA Roots Collage — links to Social Media Toolkit */}

            <div

              style={{ marginBottom: '1.5rem', cursor: 'pointer' }}

              onClick={() => setActiveSection('social-media')}

            >

              <img

                src="/MENA Roots Collage.webp"

                alt="Show Your MENA Roots — Create Mine"

                style={{ width: '100%', borderRadius: '12px', display: 'block' }}

              />

            </div>



            {(userProfile?.is_staff || userProfile?.is_superuser || userProfile?.is_admin || userProfile?.role === 'ADMIN' || userProfile?.role === 'STAFF_SCANNER') && (
              <ManualDashboardScanPanel enabled />
            )}



          </div>



        );



      case 'amphitheater-tickets': {

        const isAllTab = ampDayTab === 'all';

        const isSatTab = ampDayTab === 'sat';

        const filteredAmpTickets = isAllTab

          ? ampTicketsAll

          : (isSatTab ? ampTicketsSat : ampTicketsSun);

        const ampTicketsTotalPages = Math.max(1, Math.ceil(filteredAmpTickets.length / DASHBOARD_TICKETS_PAGE_SIZE));

        const currentAmpTicketsPage = Math.min(ampTicketsPage, ampTicketsTotalPages);

        const paginatedAmpTickets = filteredAmpTickets.slice(

          (currentAmpTicketsPage - 1) * DASHBOARD_TICKETS_PAGE_SIZE,

          currentAmpTicketsPage * DASHBOARD_TICKETS_PAGE_SIZE,

        );

        const dayLabel = isAllTab ? 'Saturday and Sunday' : (isSatTab ? 'Saturday, June 20' : 'Sunday, June 21');

        const festivalAdmissionMsg = isAllTab

          ? 'Your amphitheater tickets include festival admission on each ticket\'s event day (Saturday or Sunday).'

          : isSatTab

            ? 'Your amphitheater ticket includes festival admission for Saturday, June 20.'

            : 'Your amphitheater ticket includes festival admission for Sunday, June 21.';



        return (



          <div className="content-section">



            <h2 className="section-title">Amphitheater Tickets</h2>



            <div
              ref={ampTabsRef}
              className={`dashboard-amp-day-tabs ${isMobileViewport && isAmpTabsSticky ? 'is-sticky' : ''}`}
              style={isMobileViewport && isAmpTabsSticky ? { '--dashboard-amp-tabs-sticky-top': `${ampTabsStickyTop}px` } : undefined}
            >

              <button

                onClick={() => { setAmpDayTab('all'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                className={`dashboard-amp-day-tab-button ${ampDayTab === 'all' ? 'active' : ''}`}

              >

                All ({ampTicketsAll.length})

              </button>

              <button

                onClick={() => { setAmpDayTab('sat'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                className={`dashboard-amp-day-tab-button ${ampDayTab === 'sat' ? 'active' : ''}`}

              >

                Saturday ({ampTicketsSat.length})

              </button>

              <button

                onClick={() => { setAmpDayTab('sun'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                className={`dashboard-amp-day-tab-button ${ampDayTab === 'sun' ? 'active' : ''}`}

              >

                Sunday ({ampTicketsSun.length})

              </button>

            </div>

            {isMobileViewport && isAmpTabsSticky && <div className="amp-tabs-placeholder" />}



            <div className="static-content">



              {filteredAmpTickets.length === 0 ? (



                <div style={{ textAlign: 'center', padding: '2rem' }}>



                  <p style={{ marginBottom: '1rem' }}>No amphitheater tickets for {dayLabel}.</p>



                  <p style={{ color: '#666', fontSize: '14px', marginBottom: '1.5rem' }}>



                    Pacific Amphitheatre tickets include same-day access to the OC MENA Festival!



                  </p>



                  <a href="/amphitheater-tickets" className="browse-cta-btn" style={{



                    display: 'inline-block',



                    backgroundColor: '#7c3aed',



                    color: 'white',



                    padding: '12px 24px',



                    borderRadius: '25px',



                    textDecoration: 'none',



                    fontWeight: '600',



                    transition: 'all 0.3s ease'



                  }}>



                    Browse Amphitheater Tickets



                  </a>



                </div>



              ) : (



                <>



                  <div style={{

                    padding: '0.75rem 1rem',

                    backgroundColor: '#f0fdf4',

                    borderRadius: '8px',

                    border: '1px solid #bbf7d0',

                    marginBottom: '1rem',

                    fontSize: '0.9rem',

                    color: '#166534',

                    fontWeight: '500'

                  }}>

                    {festivalAdmissionMsg}

                  </div>



                  {paginatedAmpTickets.map(ticket => {
                    const _dead = isVoidedTicket(ticket);
                    // const isWalletEnabled = googleWalletEnabled || true;
                    
                    return (
                      <div key={ticket.id} style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        maxWidth: '480px',
                        margin: '0 auto 1.5rem auto',
                        borderRadius: '20px',
                        overflow: 'hidden',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                        backgroundColor: _dead ? '#f3f4f6' : '#faf5ff',
                        border: _dead ? '2px solid #e5e7eb' : '2px solid #c084fc',
                        opacity: _dead ? 0.8 : 1,
                        position: 'relative'
                      }}>
                        {/* Top Section: Date, Section, Row, Seat */}
                        <div style={{
                          padding: '1.5rem 1.5rem 2rem 1.5rem',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          borderBottom: '3px dashed #e5e7eb',
                          position: 'relative',
                          backgroundColor: '#f3e8ff'
                        }}>
                          {/* Ticket Cutouts */}
                          <div style={{ position: 'absolute', bottom: '-12px', left: '-12px', width: '24px', height: '24px', backgroundColor: '#fff', borderRadius: '50%', border: '1px solid #e5e7eb', zIndex: 10 }}></div>
                          <div style={{ position: 'absolute', bottom: '-12px', right: '-12px', width: '24px', height: '24px', backgroundColor: '#fff', borderRadius: '50%', border: '1px solid #e5e7eb', zIndex: 10 }}></div>
                          
                          {/* VIP Badge */}
                          {ticket.metadata?.is_vip && (
                            <div style={{
                              padding: '6px 16px', borderRadius: '20px', background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: '#fff',
                              fontSize: '0.8rem', fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', boxShadow: '0 2px 8px rgba(245,158,11,0.3)', marginBottom: '1rem'
                            }}>⭐ VIP</div>
                          )}

                          {/* PAC AMP Info (Date, Section, Row, Seat) - Front and center as requested */}
                          <h3 style={{ margin: '0 0 0.5rem 0', color: _dead ? '#6b7280' : '#4c1d95', fontSize: '1.25rem', textAlign: 'center', fontWeight: '800' }}>
                            {ticket.ticket_type_name}
                          </h3>
                          
                          <p style={{ margin: '0 0 1rem 0', color: _dead ? '#6b7280' : '#6d28d9', fontSize: '1.1rem', fontWeight: '700', textAlign: 'center' }}>
                            {(() => { const _ed = getAmpEventDate(ticket); if (_ed === '2026-06-20') return 'Saturday, June 20'; if (_ed === '2026-06-21') return 'Sunday, June 21'; return dayLabel; })()}
                          </p>

                          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '1rem' }}>
                            {ticket.metadata?.section_name || ticket.metadata?.section_display || ticket.metadata?.section ? (
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: '#6b7280', fontWeight: 'bold' }}>Section</span>
                                <span style={{ fontSize: '1.25rem', fontWeight: '900', color: '#111' }}>{ticket.metadata?.section_name || ticket.metadata?.section_display || ticket.metadata?.section}</span>
                              </div>
                            ) : null}
                            
                            {ticket.metadata?.row ? (
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: '#6b7280', fontWeight: 'bold' }}>Row</span>
                                <span style={{ fontSize: '1.25rem', fontWeight: '900', color: '#111' }}>{ticket.metadata.row}</span>
                              </div>
                            ) : null}
                            
                            {ticket.metadata?.seat_number ? (
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: '#6b7280', fontWeight: 'bold' }}>Seat</span>
                                <span style={{ fontSize: '1.25rem', fontWeight: '900', color: '#111' }}>{ticket.metadata.seat_number}</span>
                              </div>
                            ) : null}
                          </div>

                          {/* Refunded ticket notice */}
                          {isVoidedTicket(ticket) && (
                            <div style={{ padding: '0.5rem 1rem', backgroundColor: '#fef2f2', color: '#991b1b', borderRadius: '6px', fontSize: '0.8rem', fontWeight: 600, textAlign: 'center', border: '1px solid #fecaca', marginBottom: '1rem', width: '100%' }}>
                              {getVoidedTicketNotice(ticket)}
                            </div>
                          )}

                          {/* QR Code Container */}
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', width: '100%' }}>
                            {ticket.qr_code && !isWristbandTicket(ticket) && (
                              <div style={{
                                width: '100%',
                                maxWidth: '224px',
                                aspectRatio: '1',
                                padding: '12px',
                                boxSizing: 'border-box',
                                backgroundColor: '#fff',
                                borderRadius: '16px',
                                boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
                                border: isVoidedTicket(ticket) ? '2px solid #9ca3af' : ticket.metadata?.is_vip ? '3px solid #f59e0b' : '1px solid #e5e7eb',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: '0 auto'
                              }}>
                                {isVoidedTicket(ticket) ? (
                                  <img loading="lazy"
                                    src="/QR_Voided.svg"
                                    alt={"QR Code for " + ticket.ticket_code}
                                    style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block', opacity: 0.5, borderRadius: '8px' }}
                                  />
                                ) : (
                                  <RotatingQrImg
                                    ticket={ticket}
                                    size={224}
                                    alt={"QR Code for " + ticket.ticket_code}
                                    style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block', borderRadius: '8px' }}
                                  />
                                )}
                              </div>
                            )}
                            
                            {/* Download PDF button */}
                            {!isVoidedTicket(ticket) && ticket.qr_code && !isWristbandTicket(ticket) && (
                              <a
                                href={api.getTicketPDFUrl(ticket.id)}
                                download
                                style={{
                                  marginTop: '0.5rem', padding: '12px 28px', backgroundColor: '#7c3aed', color: '#ffffff', textDecoration: 'none', borderRadius: '50px', fontSize: '14px', fontWeight: '600', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', width: '100%', maxWidth: '240px', transition: 'all 0.3s ease'
                                }}
                              >
                                Download PDF Ticket
                              </a>
                            )}
                          </div>
                        </div>

                        {/* Bottom Section: Details & Status */}
                        <div style={{ padding: '1.5rem', backgroundColor: _dead ? '#f9fafb' : '#fff' }}>
                          
                          {/* Dual status for AMP tickets */}
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1.5rem', padding: '1rem', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <strong style={{ color: '#334155', fontSize: '0.9rem' }}>Festival Access:</strong>
                              <span style={{
                                padding: '4px 10px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.05em',
                                backgroundColor: isVoidedTicket(ticket) ? '#e5e7eb' : ticket.metadata?.festival_scanned ? '#fee2e2' : ticket.status === 'ISSUED' ? '#dcfce7' : '#fef3c7',
                                color: isVoidedTicket(ticket) ? '#6b7280' : ticket.metadata?.festival_scanned ? '#991b1b' : ticket.status === 'ISSUED' ? '#166534' : '#92400e'
                              }}>
                                {isVoidedTicket(ticket) ? (ticket.display_status || ticket.status) : ticket.metadata?.festival_scanned ? 'Scanned' : ticket.status === 'ISSUED' ? 'Active' : (ticket.display_status || ticket.status)}
                              </span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <strong style={{ color: '#334155', fontSize: '0.9rem' }}>Amphitheater Access:</strong>
                              <span style={{
                                padding: '4px 10px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.05em',
                                backgroundColor: isVoidedTicket(ticket) ? '#e5e7eb' : ticket.metadata?.amp_scanned ? '#fee2e2' : ticket.status === 'ISSUED' ? '#dcfce7' : '#fef3c7',
                                color: isVoidedTicket(ticket) ? '#6b7280' : ticket.metadata?.amp_scanned ? '#991b1b' : ticket.status === 'ISSUED' ? '#166534' : '#92400e'
                              }}>
                                {isVoidedTicket(ticket) ? (ticket.display_status || ticket.status) : ticket.metadata?.amp_scanned ? 'Scanned' : ticket.status === 'ISSUED' ? 'Active' : (ticket.display_status || ticket.status)}
                              </span>
                            </div>
                          </div>

                          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0.5rem', fontSize: '0.9rem' }}>
                            <p style={{ margin: '0', color: _dead ? '#9ca3af' : '#4b5563' }}><strong>Ticket Code:</strong> <span style={{ fontFamily: 'monospace', fontSize: '1rem', color: '#111', wordBreak: 'break-all' }}>{ticket.ticket_code}</span></p>
                            <p style={{ margin: '0', color: _dead ? '#9ca3af' : '#4b5563' }}><strong>Date Added:</strong> {ticket.created_at ? new Date(ticket.created_at).toLocaleDateString() : 'N/A'}</p>
                            {ticket.metadata?.price_paid && (
                              <p style={{ margin: '0', color: _dead ? '#9ca3af' : '#4b5563' }}><strong>Price:</strong> ${(ticket.metadata.price_paid / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                            )}
                          </div>

                          {/* Wallets */}
                          {!isVoidedTicket(ticket) && (
                            <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', marginTop: '1.5rem', flexWrap: 'wrap' }}>
                              <div style={{ width: '140px' }}>
                                <img loading="lazy" src={getCmsImagePath("appleBadge", "/apple.webp")} alt="Add to Apple Wallet" style={{ width: '100%', height: 'auto', display: 'block', cursor: 'pointer', borderRadius: '8px', border: '1.5px solid #1a1a1a' }} onClick={() => handleAppleWallet(ticket.id)} />
                              </div>
                              {googleWalletEnabled && (
                                <div style={{ width: '140px' }}>
                                  <img loading="lazy" src={getCmsImagePath("googleWalletBadge", "/enUS_add_to_google_wallet_add-wallet-badge.svg")} alt="Add to Google Wallet" style={{ width: '100%', height: 'auto', display: 'block', cursor: 'pointer', borderRadius: '8px' }} onClick={() => handleGoogleWallet(ticket.id)} />
                                </div>
                              )}
                            </div>
                          )}

                          {/* Transfer & Return Buttons */}
                          <div style={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            {ticket.pending_transfer && (
                              <div style={{ padding: '0.75rem', backgroundColor: '#fef9c3', borderRadius: '8px', borderLeft: '4px solid #eab308' }}>
                                <p style={{ margin: '0', fontSize: '0.9rem', fontWeight: '600', color: '#854d0e' }}>Transfer Pending</p>
                                <p style={{ margin: '0.25rem 0 0', fontSize: '0.85rem', color: '#854d0e' }}>To: {ticket.pending_transfer.to_email}</p>
                                <p style={{ margin: '0.25rem 0 0', fontSize: '0.75rem', color: '#854d0e' }}>Expires: {new Date(ticket.pending_transfer.expires_at).toLocaleString()}</p>
                              </div>
                            )}

                            {(ticket.status === 'ISSUED' || ticket.status === 'Active' || ticket.display_status === 'Active') && !ticket.pending_transfer && (
                              <button
                                onClick={() => { setTransferModal({ open: true, ticket, tickets: [ticket] }); setTransferEmail(''); setTransferLabel(''); setTransferError(''); setTransferSuccess(false); }}
                                style={{ padding: '0.75rem 1rem', backgroundColor: 'white', color: '#5b21b6', border: '2px solid #7c3aed', borderRadius: '8px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: '600', transition: 'all 0.2s ease', width: '100%' }}
                              >
                                Transfer Ticket
                              </button>
                            )}

                            {(() => {
                              const rt = receivedTransfers.find(t => t.status === 'ACCEPTED' && t.ticket_code === ticket.ticket_code);
                              if (!rt || ticket.status !== 'ISSUED') return null;
                              const returnGroupKey = rt.pass_group_key || rt.id;
                              const groupReturns = receivedTransfers.filter(t => t.status === 'ACCEPTED' && (t.pass_group_key || t.id) === returnGroupKey);
                              const returnIds = (groupReturns.length ? groupReturns : [rt]).map(t => t.id);
                              const returnBusy = returningGroupKey === returnGroupKey;
                              return (
                                <button
                                  onClick={() => handleReturnTransferGroup(returnIds, returnGroupKey)}
                                  disabled={returnBusy}
                                  style={{ padding: '0.75rem 1rem', backgroundColor: '#fff', color: '#dc2626', border: '2px solid #dc2626', borderRadius: '8px', cursor: returnBusy ? 'not-allowed' : 'pointer', fontSize: '0.85rem', fontWeight: '600', transition: 'all 0.2s ease', opacity: returnBusy ? 0.6 : 1, width: '100%' }}
                                >
                                  {returnBusy ? 'Returning...' : (returnIds.length > 1 ? 'Return Pass to Sender' : 'Return to Sender')}
                                </button>
                              );
                            })()}
                          </div>
                        </div>
                      </div>
                    );
                  })}



                  {renderDashboardPagination(currentAmpTicketsPage, ampTicketsTotalPages, filteredAmpTickets.length, setAmpTicketsPage)}



                </>



              )}



              {/* Sent/Transferred amphitheater tickets */}

              {sentTransfers.filter(t => {

                const cat = t.ticket_category || '';

                const name = (t.ticket_type || '').toLowerCase();

                const isAmp = cat === 'amphitheater' || name.includes('amphitheater') || name.includes('amphitheatre') || name.includes('pacific');

                return isAmp && (t.status === 'ACCEPTED' || t.status === 'PENDING');

              }).length > 0 && (

                  <div style={{ marginTop: '2rem', borderTop: '1px solid #e5e7eb', paddingTop: '1.5rem' }}>

                    <h3 style={{ margin: '0 0 1rem', fontSize: '1rem', color: '#6b7280' }}>Transferred Tickets</h3>

                    {sentTransfers.filter(t => {

                      const cat = t.ticket_category || '';

                      const name = (t.ticket_type || '').toLowerCase();

                      const isAmp = cat === 'amphitheater' || name.includes('amphitheater') || name.includes('amphitheatre') || name.includes('pacific');

                      return isAmp && (t.status === 'ACCEPTED' || t.status === 'PENDING');

                    }).map(transfer => (

                      <div key={transfer.id} style={{

                        border: '1px solid #e5e7eb',

                        borderRadius: '10px',

                        padding: '1rem 1.25rem',

                        marginBottom: '0.75rem',

                        backgroundColor: '#f9fafb',

                        opacity: 0.85

                      }}>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>

                          <div>

                            <p style={{ margin: 0, fontWeight: 600, fontSize: '0.95rem', color: '#374151' }}>

                              {transfer.ticket_type || 'Amphitheater Ticket'}

                            </p>

                            <p style={{ margin: '0.25rem 0 0', fontSize: '0.85rem', color: '#6b7280' }}>

                              Transferred to: {transfer.to_email}

                            </p>

                            <p style={{ margin: '0.25rem 0 0', fontSize: '0.8rem', color: '#4b5563' }}>

                              Ticket: {transfer.ticket_code || '—'}

                              {formatTransferWhatLabel(transfer) ? ` · ${formatTransferWhatLabel(transfer)}` : ''}

                            </p>

                            <p style={{ margin: '0.25rem 0 0', fontSize: '0.75rem', color: '#9ca3af' }}>

                              {formatTransferTimelineLabel(transfer)}

                            </p>

                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>

                            {transfer.status === 'PENDING' && (

                              <button

                                onClick={() => handleRecallTransfer(transfer.id)}

                                disabled={recallingTransferId === transfer.id}

                                style={{

                                  padding: '5px 14px', borderRadius: '20px', fontSize: '0.78rem', fontWeight: 600,

                                  border: '1.5px solid #dc2626', backgroundColor: '#fff', color: '#dc2626',

                                  cursor: recallingTransferId === transfer.id ? 'not-allowed' : 'pointer', opacity: recallingTransferId === transfer.id ? 0.6 : 1

                                }}

                              >

                                {recallingTransferId === transfer.id ? 'Recalling...' : 'Recall Ticket'}

                              </button>

                            )}

                            <span style={{

                              padding: '4px 12px', borderRadius: '20px', fontSize: '0.78rem', fontWeight: 600,

                              backgroundColor: transfer.status === 'ACCEPTED' ? '#dbeafe' : '#fef3c7',

                              color: transfer.status === 'ACCEPTED' ? '#1d4ed8' : '#92400e'

                            }}>

                              {transfer.status === 'ACCEPTED' ? 'Transferred' : 'Pending'}

                            </span>

                          </div>

                        </div>

                      </div>

                    ))}

                  </div>

                )}



            </div>



          </div>



        );

      }



      case 'vendor-booths':



        return (



          <div className="content-section">



            <h2 className="section-title">Vendor Booths</h2>



            <div className="static-content">



              <div style={{ textAlign: 'center', padding: '2rem' }}>



                <div style={{ fontSize: '48px', marginBottom: '1rem' }}>🏪</div>



                <p style={{ marginBottom: '1rem' }}>View or manage your vendor booths.</p>



                <p style={{ color: '#666', fontSize: '14px', marginBottom: '1.5rem' }}>



                  Reserve your booth space at the OC MENA Festival!



                </p>



                <a href="/vendor-booths" className="browse-cta-btn" style={{



                  display: 'inline-block',



                  backgroundColor: '#9333ea',



                  color: 'white',



                  padding: '12px 24px',



                  textDecoration: 'none',



                  borderRadius: '8px',



                  fontWeight: '600',



                  transition: 'all 0.3s ease'



                }}>



                  Browse Vendor Booths



                </a>



              </div>



            </div>



          </div>



        );



      case 'vendor-status':

        return (

          <div className="content-section">

            <h2 className="section-title">Vendor Status</h2>

            {renderVendorStatusCard()}

            {/* Show rejected history if there are older rejected orders */}

            {allVendorOrderInfos.filter(v => v.status === 'REJECTED' && v.orderId !== activeVendorOrder?.id).length > 0 && (

              <div style={{ marginTop: '24px' }}>

                <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#6b7280', marginBottom: '12px' }}>Previous Applications</h3>

                {allVendorOrderInfos.filter(v => v.status === 'REJECTED' && v.orderId !== activeVendorOrder?.id).map(v => (

                  <div key={v.orderId} style={{ border: '1px solid #e5e7eb', borderRadius: '10px', padding: '14px 18px', marginBottom: '10px', background: '#fafafa' }}>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                      <div>

                        <span style={{ fontWeight: 600, fontSize: '14px' }}>{v.businessName}</span>

                        <span style={{ marginLeft: '8px', fontSize: '12px', color: '#999' }}>Order #{v.orderNumber}</span>

                      </div>

                      <span style={{ fontSize: '12px', fontWeight: 700, color: '#B81C1C', background: '#FDF1F1', padding: '3px 10px', borderRadius: '12px' }}>REJECTED</span>

                    </div>

                    <div style={{ fontSize: '13px', color: '#888', marginTop: '4px' }}>{v.boothLabel}{v.createdAt ? ` · ${new Date(v.createdAt).toLocaleDateString()}` : ''}</div>

                  </div>

                ))}

              </div>

            )}

          </div>

        );



      case 'vendor-documents':



        const contractDoc = getDocumentByType('CONTRACT');



        const contractSigned = contractDoc?.is_signed;



        const contractStatus = getDocumentStatus('CONTRACT', true);



        const sellerPermitStatus = getDocumentStatus('SELLER_PERMIT', true);



        const businessLicenseStatus = getDocumentStatus('BUSINESS_LICENSE', false);



        const healthPermitStatus = getDocumentStatus('HEALTH_PERMIT', false);



        const foodHandlerStatus = getDocumentStatus('FOOD_HANDLER', false);



        const sellerPermitDoc = getDocumentByType('SELLER_PERMIT');



        const businessLicenseDoc = getDocumentByType('BUSINESS_LICENSE');



        const healthPermitDoc = getDocumentByType('HEALTH_PERMIT');



        const foodHandlerDoc = getDocumentByType('FOOD_HANDLER');







        // Check if all required docs are approved



        const allDocsApproved = contractStatus.status === 'approved' && sellerPermitStatus.status === 'approved';







        return (



          <div className="content-section vendor-docs">



            <h2 className="section-title">Vendor Docs & Info</h2>







            {allDocsApproved && (



              <div style={{



                padding: '1rem',



                backgroundColor: '#d1fae5',



                color: '#065f46',



                borderRadius: '8px',



                marginBottom: '1rem',



                fontWeight: 'bold',



                textAlign: 'center'



              }}>



                ✅ All Required Documents Approved! You're all set for the festival.



              </div>



            )}







            {documentError && (



              <div style={{



                padding: '1rem',



                backgroundColor: '#fee2e2',



                color: '#991b1b',



                borderRadius: '8px',



                marginBottom: '1rem'



              }}>



                {documentError}



              </div>



            )}







            {documentSuccess && (



              <div style={{



                padding: '1rem',



                backgroundColor: '#dcfce7',



                color: '#166534',



                borderRadius: '8px',



                marginBottom: '1rem',



                fontWeight: '600'



              }}>



                {documentSuccess}



              </div>



            )}







            <div className="vendor-docs-card">



              <div className="vendor-docs-header">



                <div className="contract-label">Contract:</div>



                <div className="contract-actions">



                  <button



                    className="doc-btn primary"



                    onClick={handleSignContract}



                    disabled={contractSigned || documentUploading.CONTRACT || vendorIsPending || vendorOrderInfo?.status === 'REJECTED'}



                    style={{



                      opacity: (contractSigned || vendorIsPending || vendorOrderInfo?.status === 'REJECTED') ? 0.6 : 1,



                      cursor: (contractSigned || vendorIsPending || vendorOrderInfo?.status === 'REJECTED') ? 'default' : 'pointer'



                    }}



                  >



                    {documentUploading.CONTRACT ? 'Signing...' : contractSigned ? 'Contract Signed' : vendorIsPending ? 'Sign Vendor Contract* (Available after approval)' : vendorOrderInfo?.status === 'REJECTED' ? 'Sign Vendor Contract*' : 'Sign Vendor Contract*'}



                  </button>



                  <span className={`status-pill ${docuSignCompleting ? 'warning' : contractSigned ? 'success' : 'danger'}`}>



                    {docuSignCompleting ? (<>Retrieving<span className="dot-animation">...</span></>) : contractSigned ? 'Signed ✓' : 'Not signed'}



                  </span>



                  {contractSigned && contractDoc?.file_url && (

                    <a

                      href={contractDoc.file_url}

                      target="_blank"

                      rel="noopener noreferrer"

                      style={{

                        display: 'inline-block',

                        padding: '8px 20px',

                        fontSize: '14px',

                        fontWeight: 600,

                        color: '#000',

                        border: '2px solid #000',

                        borderRadius: '25px',

                        textDecoration: 'none',

                        background: 'transparent',

                        cursor: 'pointer',

                        transition: 'all 0.2s',

                        marginLeft: '6px'

                      }}

                    >

                      Download Contract

                    </a>

                  )}



                </div>



              </div>







              <div className="vendor-docs-note">



                <strong>Permits:</strong> Permit documentation is due a minimum of 14 days prior to the event. No refunds will be issued for late or missing submissions.



              </div>







              {(vendorOrderInfo?.licensePlateNumber || vendorOrderInfo?.productType) && (

                <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', marginBottom: '1rem', padding: '0.75rem 1rem', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>

                  {vendorOrderInfo.licensePlateNumber && (

                    <div>

                      <span style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>License Plate</span>

                      <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1e293b', marginTop: '2px' }}>{vendorOrderInfo.licensePlateNumber}</div>

                    </div>

                  )}

                  {vendorOrderInfo.productType && (

                    <div>

                      <span style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Product Type</span>

                      <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1e293b', marginTop: '2px' }}>

                        {vendorOrderInfo.productType === 'prepackaged' ? 'Prepackaged' : vendorOrderInfo.productType === 'prepackaged_sampling' ? 'Prepackaged w/ Sampling' : vendorOrderInfo.productType === 'unpackaged' ? 'Unpackaged/Open Food' : vendorOrderInfo.productType}

                      </div>

                    </div>

                  )}

                </div>

              )}



              <div className="upload-list">



                <div className="upload-row">



                  <div className="upload-label">Upload Seller's Permit</div>



                  <div className="upload-control">



                    <input



                      type="file"



                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp"



                      onChange={(e) => handleDocumentUpload('SELLER_PERMIT', e.target.files[0])}



                      disabled={documentUploading.SELLER_PERMIT}



                      style={{ display: 'none' }}



                      id="seller-permit-upload"



                    />



                    <label



                      htmlFor="seller-permit-upload"



                      className="upload-display"



                      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}



                    >



                      <span>{documentUploading.SELLER_PERMIT ? 'Uploading...' : sellerPermitDoc?.original_filename || 'Click to upload file'}</span>



                      {sellerPermitDoc && (



                        <a



                          href={api.getVendorDocumentDownloadUrl(sellerPermitDoc.id)}



                          onClick={(e) => e.stopPropagation()}



                          style={{ marginLeft: '8px', color: '#0284c7' }}



                        >



                          ⇩



                        </a>



                      )}



                    </label>



                  </div>



                  <span className={`status-pill ${sellerPermitStatus.class}`}>{sellerPermitStatus.label}</span>



                </div>







                <div className="upload-row">



                  <div className="upload-label">Upload Business License or Tax Certificate</div>



                  <div className="upload-control">



                    <input



                      type="file"



                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp"



                      onChange={(e) => handleDocumentUpload('BUSINESS_LICENSE', e.target.files[0])}



                      disabled={documentUploading.BUSINESS_LICENSE}



                      style={{ display: 'none' }}



                      id="business-license-upload"



                    />



                    <label



                      htmlFor="business-license-upload"



                      className="upload-display"



                      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}



                    >



                      <span>{documentUploading.BUSINESS_LICENSE ? 'Uploading...' : businessLicenseDoc?.original_filename || 'Click to upload file'}</span>



                      {businessLicenseDoc && (



                        <a



                          href={api.getVendorDocumentDownloadUrl(businessLicenseDoc.id)}



                          onClick={(e) => e.stopPropagation()}



                          style={{ marginLeft: '8px', color: '#0284c7' }}



                        >



                          ⇩



                        </a>



                      )}



                    </label>



                  </div>



                  <span className={`status-pill ${businessLicenseStatus.class}`}>{businessLicenseStatus.label}</span>



                </div>







                <div className="upload-row">



                  <div className="upload-label">Upload Health Permit (if applicable)</div>



                  <div className="upload-control">



                    <input



                      type="file"



                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp"



                      onChange={(e) => handleDocumentUpload('HEALTH_PERMIT', e.target.files[0])}



                      disabled={documentUploading.HEALTH_PERMIT}



                      style={{ display: 'none' }}



                      id="health-permit-upload"



                    />



                    <label



                      htmlFor="health-permit-upload"



                      className="upload-display"



                      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}



                    >



                      <span>{documentUploading.HEALTH_PERMIT ? 'Uploading...' : healthPermitDoc?.original_filename || 'Click to upload file'}</span>



                      {healthPermitDoc && (



                        <a



                          href={api.getVendorDocumentDownloadUrl(healthPermitDoc.id)}



                          onClick={(e) => e.stopPropagation()}



                          style={{ marginLeft: '8px', color: '#0284c7' }}



                        >



                          ⇩



                        </a>



                      )}



                    </label>



                  </div>



                  <span className={`status-pill ${healthPermitStatus.class}`}>{healthPermitStatus.label}</span>



                </div>







                <div className="upload-row">



                  <div className="upload-label">Upload Food Handler's License (if applicable)</div>



                  <div className="upload-control">



                    <input



                      type="file"



                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp"



                      onChange={(e) => handleDocumentUpload('FOOD_HANDLER', e.target.files[0])}



                      disabled={documentUploading.FOOD_HANDLER}



                      style={{ display: 'none' }}



                      id="food-handler-upload"



                    />



                    <label



                      htmlFor="food-handler-upload"



                      className="upload-display"



                      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}



                    >



                      <span>{documentUploading.FOOD_HANDLER ? 'Uploading...' : foodHandlerDoc?.original_filename || 'Click to upload file'}</span>



                      {foodHandlerDoc && (



                        <a



                          href={api.getVendorDocumentDownloadUrl(foodHandlerDoc.id)}



                          onClick={(e) => e.stopPropagation()}



                          style={{ marginLeft: '8px', color: '#0284c7' }}



                        >



                          ⇩



                        </a>



                      )}



                    </label>



                  </div>



                  <span className={`status-pill ${foodHandlerStatus.class}`}>{foodHandlerStatus.label}</span>



                </div>



              </div>



            </div>



            {/* ── Information Section ── */}

            <div className="vendor-info-section" style={{

              marginTop: '32px',

              border: '1px solid #e5e7eb',

              borderLeft: '4px solid #38bdf8',

              borderRadius: '8px',

              padding: '24px 28px',

              background: '#fff',

              fontSize: '14px',

              color: '#111827',

              lineHeight: '1.65',

            }}>

              <h3 style={{ fontSize: '18px', fontWeight: '700', margin: '0 0 8px', borderBottom: '2px solid #111827', display: 'inline-block', paddingBottom: '2px' }}>Information</h3>

              <p style={{ margin: '8px 0 16px', color: '#374151' }}>Please review the details below to help you prepare for a smooth and successful experience at OC MENA Festival. We're excited to have you join us.</p>



              <h4 style={{ fontSize: '15px', fontWeight: '700', margin: '0 0 8px' }}>Entry Tickets</h4>

              <ul style={{ margin: '0 0 18px', paddingLeft: '22px' }}>

                <li>Each Vendor will receive (3) vendor wristbands.</li>

                <li>Each vendor will be provided with (2) Free 3-Day Festival Entry tickets.</li>

              </ul>



              <h4 style={{ fontSize: '15px', fontWeight: '700', margin: '0 0 8px' }}>Vendor Guidelines & Logistics</h4>

              <ul style={{ margin: '0 0 18px', paddingLeft: '22px' }}>

                <li><strong><u>Approval Required:</u></strong> All vendor registrations are subject to review and approval before confirmation.</li>

                <li><strong><u>Final Sales:</u></strong> No refunds or cancellations will be accepted after April 31, 2026.</li>

                <li><strong><u>Booth Assignment:</u></strong> Vendor locations are assigned based on registration completion order and booth type.</li>

                <li><strong><u>Setup Day:</u></strong> Vendor check-in and setup will take place on Thursday, June 18, 9 AM - 7 PM, or Friday, June 19, from 7 AM to 9:30 PM.</li>

                <li><strong><u>Setup Deadline:</u></strong> All booths must be fully set up by Friday at 9:30 am.</li>

                <li><strong><u>Late Setup Policy:</u></strong> No vendor setup will be allowed after 9 AM on Saturday. This is strictly enforced with no refunds.</li>

                <li><strong><u>Venue Access:</u></strong> The venue opens to vendors on Saturday, starting at 7 AM.</li>

                <li><strong><u>Security:</u></strong> The facility will be locked overnight, with on-site security provided each evening.</li>

                <li><strong><u>Parking:</u></strong> A designated vendor parking area will be available.</li>

                <li><strong><u>Indoor Bazaar:</u></strong> All vendor booths will be indoors. Vendors must bring their own tables and chairs.</li>

                <li><strong><u>Food Truck Parking:</u></strong> Food trucks will be assigned a designated parking space within the food truck zone and must remain parked in their assigned location for the duration of the event.</li>

                <li><strong><u>Lighting:</u></strong> General lighting is provided; vendors should bring rechargeable lights for product displays.</li>

                <li><strong><u>Safety:</u></strong> Vendors are responsible for providing their own safety equipment, including fire extinguishers if required.</li>

                <li><strong><u>Cleanliness:</u></strong> Vendors may be charged for spills, damage, or excessive cleaning beyond normal use.</li>

                <li><strong><u>Teardown:</u></strong> Breakdown may begin after the event on Sunday, June 21, 2026 after the event, or Monday, June 22, 2026, from 7 AM – 7 PM.</li>

              </ul>



              <h4 style={{ fontSize: '15px', fontWeight: '700', margin: '0 0 8px' }}>Additional Note</h4>

              <ul style={{ margin: '0 0 18px', paddingLeft: '22px' }}>

                <li><strong>OC Health Info:</strong> <a href="https://ochealthinfo.com/services-programs/environmental-health/food-and-pool/food/food-safety-programs/food-booths" target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', textDecoration: 'underline' }}>https://ochealthinfo.com/services-programs/environmental-health/food-and-pool/food/food-safety-programs/food-booths</a></li>

                <li><strong>Prohibited goods from BDS List:</strong> <a href="https://bdsmovement.net/Guide-to-BDS-Boycott" target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', textDecoration: 'underline' }}>https://bdsmovement.net/Guide-to-BDS-Boycott</a></li>

              </ul>



              <h4 style={{ fontSize: '15px', fontWeight: '700', margin: '0 0 8px' }}>Quick Links for Food Vendors</h4>

              <ul style={{ margin: '0 0 0', paddingLeft: '22px' }}>

                <li>OC Health Permit can be found <a href="https://ochealthinfo.com/services-programs/environmental-health/food-and-pool/food/food-safety-programs/food-booths" target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', textDecoration: 'underline' }}>here</a>

                  <ul style={{ paddingLeft: '20px', marginTop: '4px' }}>

                    <li>Event Name: OC MENA Festival</li>

                    <li>Event Organizer Name: MENA Events, Inc.</li>

                    <li>Event Organizer Phone: (714) 580-6104</li>

                    <li>Event Organizer email: sam@ocmenafestival.com</li>

                  </ul>

                </li>

                <li>TTF Application can be found <a href="https://ochealthinfo.com/services-programs/environmental-health/food-and-pool/food/food-safety-programs/food-booths" target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', textDecoration: 'underline' }}>here</a></li>

                <li>TTF Checklist can be found <a href="https://ochealthinfo.com/services-programs/environmental-health/food-and-pool/food/food-safety-programs/food-booths" target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', textDecoration: 'underline' }}>here</a></li>

              </ul>

            </div>



            {/* Signature Modal */}



            {showSignatureModal && (



              <div style={{



                position: 'fixed',



                top: 0,



                left: 0,



                right: 0,



                bottom: 0,



                backgroundColor: 'rgba(0,0,0,0.5)',



                display: 'flex',



                alignItems: 'center',



                justifyContent: 'center',



                zIndex: 1000



              }}>



                <div style={{



                  backgroundColor: 'white',



                  borderRadius: '12px',



                  padding: '2rem',



                  maxWidth: '600px',



                  width: '90%',



                  maxHeight: '90vh',



                  overflow: 'auto'



                }}>



                  <h3 style={{ marginTop: 0 }}>Sign Vendor Contract</h3>



                  <p style={{ color: '#666', marginBottom: '1.5rem' }}>



                    Please sign below to agree to the vendor contract terms and conditions.



                  </p>







                  <div style={{



                    border: '2px solid #ddd',



                    borderRadius: '8px',



                    backgroundColor: '#fff',



                    marginBottom: '1rem',



                    position: 'relative'



                  }}>



                    <canvas



                      ref={(canvas) => {



                        if (canvas && !canvas.dataset.initialized) {



                          canvas.dataset.initialized = 'true';



                          canvas.width = canvas.offsetWidth;



                          canvas.height = 200;



                          const ctx = canvas.getContext('2d');



                          let drawing = false;







                          const startDrawing = (e) => {



                            drawing = true;



                            const rect = canvas.getBoundingClientRect();



                            const x = (e.clientX || e.touches[0].clientX) - rect.left;



                            const y = (e.clientY || e.touches[0].clientY) - rect.top;



                            ctx.beginPath();



                            ctx.moveTo(x, y);



                          };







                          const draw = (e) => {



                            if (!drawing) return;



                            e.preventDefault();



                            const rect = canvas.getBoundingClientRect();



                            const x = (e.clientX || e.touches[0].clientX) - rect.left;



                            const y = (e.clientY || e.touches[0].clientY) - rect.top;



                            ctx.lineTo(x, y);



                            ctx.strokeStyle = '#000';



                            ctx.lineWidth = 2;



                            ctx.lineCap = 'round';



                            ctx.stroke();



                          };







                          const stopDrawing = () => {



                            if (drawing) {



                              drawing = false;



                              setSignatureData(canvas.toDataURL());



                            }



                          };







                          canvas.addEventListener('mousedown', startDrawing);



                          canvas.addEventListener('mousemove', draw);



                          canvas.addEventListener('mouseup', stopDrawing);



                          canvas.addEventListener('mouseout', stopDrawing);



                          canvas.addEventListener('touchstart', startDrawing);



                          canvas.addEventListener('touchmove', draw);



                          canvas.addEventListener('touchend', stopDrawing);



                        }



                      }}



                      style={{



                        width: '100%',



                        height: '200px',



                        cursor: 'crosshair',



                        touchAction: 'none'



                      }}



                    />



                  </div>







                  <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>



                    <button



                      onClick={() => {



                        const canvas = document.querySelector('canvas');



                        if (canvas) {



                          const ctx = canvas.getContext('2d');



                          ctx.clearRect(0, 0, canvas.width, canvas.height);



                          setSignatureData(null);



                        }



                      }}



                      style={{



                        padding: '0.75rem 1.5rem',



                        backgroundColor: '#f3f4f6',



                        color: '#374151',



                        border: 'none',



                        borderRadius: '8px',



                        cursor: 'pointer',



                        fontWeight: '500'



                      }}



                    >



                      Clear



                    </button>



                    <button



                      onClick={() => {



                        setShowSignatureModal(false);



                        setSignatureData(null);



                      }}



                      style={{



                        padding: '0.75rem 1.5rem',



                        backgroundColor: '#6b7280',



                        color: 'white',



                        border: 'none',



                        borderRadius: '8px',



                        cursor: 'pointer',



                        fontWeight: '500'



                      }}



                    >



                      Cancel



                    </button>



                    <button



                      onClick={handleSignatureSubmit}



                      disabled={!signatureData || documentUploading.CONTRACT}



                      style={{



                        padding: '0.75rem 1.5rem',



                        backgroundColor: signatureData ? '#0284c7' : '#d1d5db',



                        color: 'white',



                        border: 'none',



                        borderRadius: '8px',



                        cursor: signatureData ? 'pointer' : 'not-allowed',



                        fontWeight: '500'



                      }}



                    >



                      {documentUploading.CONTRACT ? 'Submitting...' : 'Submit Signature'}



                    </button>



                  </div>



                </div>



              </div>



            )}



          </div>



        );



      case 'tickets':



        return (



          <div className="content-section">



            <h2 className="section-title">Festival Tickets</h2>



            <div className="static-content">



              {/* Transfer disclaimer */}

              <div style={{

                marginBottom: '1.25rem',

                padding: '0.75rem 1rem',

                backgroundColor: '#fef3c7',

                border: '1px solid #f59e0b',

                borderRadius: '10px',

                display: 'flex',

                alignItems: 'flex-start',

                gap: '0.75rem'

              }}>

                <span style={{ fontSize: '1.2rem', lineHeight: 1 }}>⚠️</span>

                <div style={{ flex: 1 }}>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.35rem', flexWrap: 'wrap' }}>

                    <span style={{

                      display: 'inline-block',

                      padding: '0.15rem 0.6rem',

                      borderRadius: '20px',

                      fontSize: '0.72rem',

                      fontWeight: 700,

                      backgroundColor: '#fbbf24',

                      color: '#78350f',

                      letterSpacing: '0.3px',

                      textTransform: 'uppercase'

                    }}>Festival Tickets Policy</span>

                  </div>

                  <p style={{ margin: 0, fontSize: '0.85rem', color: '#92400e', lineHeight: 1.5, marginBottom: '0.75rem' }}>

                    <strong>How Your Tickets Work</strong><br />

                    Each QR code is valid for one (1) day of entry.

                    A 3-Day Pass includes three (3) individual QR codes, and a 2-Day Pass includes two (2) QR codes. Multi-day passes may be used on any event day.

                  </p>

                  <p style={{ margin: 0, fontSize: '0.85rem', color: '#92400e', lineHeight: 1.5 }}>

                    <strong>Transfer Policy:</strong><br />

                    If you transfer a multi-day pass, all included QR codes will be transferred together.

                  </p>

                </div>

              </div>



              {/* Incoming transfer invitations — grouped by sender so a 3-day pass shows as ONE row */}

              {receivedTransfers.filter(t => t.status === 'PENDING' && !t.is_expired).length > 0 && (

                <div style={{

                  marginBottom: '1.5rem',

                  padding: '1.25rem',

                  backgroundColor: '#ede9fe',

                  border: '2px solid #8b5cf6',

                  borderRadius: '12px'

                }}>

                  <h3 style={{ margin: '0 0 0.75rem', fontSize: '1rem', color: '#5b21b6' }}>🎁 Incoming Ticket Transfers</h3>

                  {(() => {

                    const pending = receivedTransfers.filter(t => t.status === 'PENDING' && !t.is_expired);

                    const grouped = {};

                    pending.forEach(t => {

                      const key = `${t.from_user_email}__${t.ticket_type || 'Festival Ticket'}`;

                      if (!grouped[key]) grouped[key] = [];

                      grouped[key].push(t);

                    });

                    return Object.values(grouped).map(group => {

                      const first = group[0];

                      const count = group.length;

                      const label = first.ticket_type || 'Festival Ticket';

                      const displayLabel = count > 1 ? `${count}-Day Pass` : label;

                      return (

                        <div key={first.id} style={{

                          display: 'flex',

                          justifyContent: 'space-between',

                          alignItems: 'center',

                          padding: '0.75rem 1rem',

                          backgroundColor: '#fff',

                          borderRadius: '8px',

                          marginBottom: '0.5rem',

                          border: '1px solid #c4b5fd'

                        }}>

                          <div>

                            <p style={{ margin: 0, fontWeight: 600, color: '#1f2937' }}>

                              {displayLabel}

                            </p>

                            <p style={{ margin: '0.25rem 0 0', fontSize: '0.85rem', color: '#6b7280' }}>

                              From: {first.from_user_email}

                            </p>

                          </div>

                          <button

                            onClick={() => handleAcceptTransfer(first.id)}

                            disabled={acceptingTransferId === first.id}

                            style={{

                              padding: '0.5rem 1.25rem',

                              backgroundColor: acceptingTransferId === first.id ? '#a78bfa' : '#8b5cf6',

                              color: '#fff',

                              border: 'none',

                              borderRadius: '8px',

                              fontWeight: 600,

                              fontSize: '0.9rem',

                              cursor: acceptingTransferId === first.id ? 'not-allowed' : 'pointer'

                            }}

                          >

                            {acceptingTransferId === first.id ? 'Accepting...' : 'Accept'}

                          </button>

                        </div>

                      );

                    });

                  })()}

                </div>

              )}



              {(() => {

                // NUCLEAR FIX: Always pull comp tickets from vendor_tickets too at render time

                // This guarantees comp tickets show here regardless of backend categorization

                const _isComp = (t) => {

                  const n = (t.ticket_type_name || '').toLowerCase();

                  return t.is_comp === true || t.metadata?.complimentary === true ||

                    t.metadata?.type === 'festival_access' || n.includes('complimentary') ||

                    (n.includes('festival') && (n.includes('pass') || n.includes('access')));

                };

                const compFromVendor = (tickets.vendor_tickets || []).filter((ticket) => !isVoidedTicket(ticket)).filter(_isComp);

                const festivalIds = new Set((tickets.festival_tickets || []).map(t => t.id));

                const extraComp = compFromVendor.filter(t => !festivalIds.has(t.id)).map(t => {

                  if (!t.vendor_business_name && vendorOrderInfo?.businessName) {

                    return { ...t, vendor_business_name: vendorOrderInfo.businessName };

                  }

                  return t;

                });

                const allFestival = [...(tickets.festival_tickets || []), ...extraComp].filter((ticket) => {
                  if (isWristbandTicket(ticket)) {
                    return false;
                  }
                  if (isVoidedTicket(ticket) && isVendorCompTicket(ticket)) {
                    return false;
                  }
                  return true;
                });

                console.log('[Festival Tab] festival:', (tickets.festival_tickets || []).length, 'comp from vendor:', extraComp.length, 'total:', allFestival.length);



                if (allFestival.length === 0) return (



                  <div style={{ textAlign: 'center', padding: '2rem' }}>



                    <div style={{ fontSize: '48px', marginBottom: '1rem' }}>🎪</div>



                    <p style={{ marginBottom: '1rem' }}>No festival tickets yet.</p>



                    <p style={{ color: '#666', fontSize: '14px', marginBottom: '1.5rem' }}>



                      Get your tickets to the OC MENA Festival!



                    </p>



                    <a href="/tickets" className="browse-cta-btn" style={{



                      display: 'inline-block',



                      backgroundColor: '#0284c7',



                      color: 'white',



                      padding: '12px 24px',



                      borderRadius: '25px',



                      textDecoration: 'none',



                      fontWeight: '600',



                      transition: 'all 0.3s ease'



                    }}>



                      Browse Festival Tickets



                    </a>



                  </div>



                );



                // Sort festival tickets: group by ticket type, then by day_number

                const _passOrder = (name) => {

                  const n = (name || '').toLowerCase();

                  if (n.includes('1-day') || n.includes('1 day') || n.includes('1day')) return 1;

                  if (n.includes('2-day') || n.includes('2 day') || n.includes('2day')) return 2;

                  if (n.includes('3-day') || n.includes('3 day') || n.includes('3day')) return 3;

                  if (n.includes('complimentary') || n.includes('comp')) return 4;

                  return 5;

                };

                const _getPassDays = (ticket) => {

                  const metadataDays = Number(
                    ticket?.metadata?.festival_pass_entries_allowed ||
                    ticket?.metadata?.entries_allowed ||
                    ticket?.metadata?.total_days ||
                    0
                  );

                  if (Number.isFinite(metadataDays) && metadataDays >= 2) {
                    return metadataDays;
                  }

                  const n = (ticket?.ticket_type_name || '').toLowerCase();

                  if (n.includes('3-day') || n.includes('3 day') || n.includes('3day')) return 3;

                  if (n.includes('2-day') || n.includes('2 day') || n.includes('2day')) return 2;

                  return 1;

                };

                const sorted = [...allFestival].sort((a, b) => {

                  const typeA = _passOrder(a.ticket_type_name);

                  const typeB = _passOrder(b.ticket_type_name);

                  if (typeA !== typeB) return typeA - typeB;

                  const dayA = a.metadata?.day_number || 0;

                  const dayB = b.metadata?.day_number || 0;

                  if (dayA !== dayB) return dayA - dayB;

                  const dateA = a.metadata?.valid_for_date || a.metadata?.event_date || '';

                  const dateB = b.metadata?.valid_for_date || b.metadata?.event_date || '';

                  return dateA.localeCompare(dateB);

                });



                // Group tickets into pass groups

                const orderTypeGroups = {};

                sorted.forEach(ticket => {

                  const days = _getPassDays(ticket);

                  const isComp = ticket.is_comp || ticket.metadata?.complimentary;

                  if (days === 1) {

                    const key = `single_${ticket.id}`;

                    orderTypeGroups[key] = { tickets: [ticket], daysPerPass: 1, isComp };

                  } else {

                    const orderId = ticket.order_id || 'no-order';

                    const typeName = ticket.ticket_type_name || 'unknown';

                    const key = `${orderId}__${typeName}`;

                    if (!orderTypeGroups[key]) orderTypeGroups[key] = { tickets: [], daysPerPass: days, isComp };

                    if (isComp) orderTypeGroups[key].isComp = true;

                    orderTypeGroups[key].tickets.push(ticket);

                  }

                });



                const passGroups = [];

                const passTypeCounter = {}; // global counter per pass type label

                Object.values(orderTypeGroups).forEach(group => {

                  if (group.daysPerPass === 1) {

                    group.tickets.forEach(ticket => {

                      const label = '1-Day Pass';

                      passTypeCounter[label] = (passTypeCounter[label] || 0) + 1;

                      const num = passTypeCounter[label];

                      passGroups.push({

                        tickets: [ticket],

                        passLabel: `${label} #${num}`,

                        isMultiDay: false,

                        passNumber: num,

                        totalPasses: 0, // updated after loop

                        _passTypeLabel: label,

                        isComp: group.isComp

                      });

                    });

                  } else {

                    const numPasses = Math.max(1, Math.round(group.tickets.length / group.daysPerPass));

                    const uniqueDates = [...new Set(group.tickets.map(t => t.metadata?.valid_for_date || ''))].filter(d => d !== '').sort();

                    const label = `${group.daysPerPass}-Day Pass`;



                    if (uniqueDates.length === 0) {

                      // No valid_for_date on tickets (e.g. vendor comp QRs valid any day)

                      // Group by ticket_number metadata, or split evenly into passes

                      const byPassNum = {};

                      group.tickets.forEach(t => {

                        const pn = t.metadata?.ticket_number || 1;

                        if (!byPassNum[pn]) byPassNum[pn] = [];

                        byPassNum[pn].push(t);

                      });

                      const passNums = Object.keys(byPassNum).sort((a, b) => a - b);

                      if (passNums.length > 1) {

                        // Group by ticket_number

                        passNums.forEach(pn => {

                          const passTickets = byPassNum[pn];

                          if (passTickets.length === 0) return;

                          passTypeCounter[label] = (passTypeCounter[label] || 0) + 1;

                          const num = passTypeCounter[label];

                          passGroups.push({

                            tickets: passTickets,

                            passLabel: `${label} #${num}`,

                            isMultiDay: true,

                            passNumber: num,

                            totalPasses: 0,

                            _passTypeLabel: label,

                            isComp: group.isComp

                          });

                        });

                      } else {

                        // All same ticket_number or no metadata — split evenly

                        const perPass = Math.max(1, Math.ceil(group.tickets.length / numPasses));

                        for (let i = 0; i < numPasses; i++) {

                          const passTickets = group.tickets.slice(i * perPass, (i + 1) * perPass);

                          if (passTickets.length === 0) continue;

                          passTypeCounter[label] = (passTypeCounter[label] || 0) + 1;

                          const num = passTypeCounter[label];

                          passGroups.push({

                            tickets: passTickets,

                            passLabel: `${label} #${num}`,

                            isMultiDay: true,

                            passNumber: num,

                            totalPasses: 0,

                            _passTypeLabel: label,

                            isComp: group.isComp

                          });

                        }

                      }

                    } else {

                      // Date-specific tickets — group by valid_for_date as before

                      for (let i = 0; i < numPasses; i++) {

                        const passTickets = [];

                        uniqueDates.forEach(date => {

                          const ticketsForDate = group.tickets.filter(t => (t.metadata?.valid_for_date || '') === date);

                          if (ticketsForDate[i]) passTickets.push(ticketsForDate[i]);

                        });

                        if (passTickets.length === 0) continue;

                        passTypeCounter[label] = (passTypeCounter[label] || 0) + 1;

                        const num = passTypeCounter[label];

                        passGroups.push({

                          tickets: passTickets,

                          passLabel: `${label} #${num}`,

                          isMultiDay: true,

                          passNumber: num,

                          totalPasses: 0,

                          _passTypeLabel: label,

                          isComp: group.isComp

                        });

                      }

                    }

                  }

                });

                // Backfill totalPasses per type

                Object.entries(passTypeCounter).forEach(([label, count]) => {

                  passGroups.filter(g => g._passTypeLabel === label).forEach(g => { g.totalPasses = count; });

                });



                const festivalTicketsTotalPages = Math.max(1, Math.ceil(passGroups.length / DASHBOARD_TICKETS_PAGE_SIZE));

                const currentFestivalPage = Math.min(festivalTicketsPage, festivalTicketsTotalPages);

                const paginatedPassGroups = passGroups.slice(

                  (currentFestivalPage - 1) * DASHBOARD_TICKETS_PAGE_SIZE,

                  currentFestivalPage * DASHBOARD_TICKETS_PAGE_SIZE,

                );



                return (

                  <>

                    {paginatedPassGroups.map((group, groupIdx) => (

                      <React.Fragment key={`pass-group-${groupIdx}`}>

                        {group.passLabel && (

                          <div style={{

                            margin: groupIdx > 0 ? '1.5rem 0 0.75rem' : '0 0 0.75rem',

                            padding: '0.5rem 0',

                            borderBottom: '2px solid #e5e7eb',

                            display: 'flex',

                            alignItems: 'center',

                            gap: '0.5rem'

                          }}>

                            <span style={{ fontSize: '1.1rem' }}>🎫</span>

                            <h3 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 800, color: '#4c1d95' }}>{group.passLabel}</h3>

                          </div>

                        )}

                        {group.tickets.map((ticket, ticketIdx) => {
                          const isCompTicket = ticket.is_comp || ticket.metadata?.complimentary;
                          const isActualVendorBooth = !isCompTicket && (
                            ticket.ticket_type_name?.toLowerCase().includes('vendor') ||
                            ticket.ticket_type_name?.toLowerCase().includes('booth')
                          );
                          const _dead = isVoidedTicket(ticket);
                          
                          return (
                            <div key={ticket.id} style={{
                              display: 'flex',
                              flexDirection: 'column',
                              width: '100%',
                              maxWidth: '480px',
                              margin: '0 auto 1.5rem auto',
                              borderRadius: '20px',
                              overflow: 'hidden',
                              boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                              backgroundColor: _dead ? '#f3f4f6' : isActualVendorBooth ? '#faf5ff' : '#ffffff',
                              border: _dead ? '2px solid #e5e7eb' : isActualVendorBooth ? '2px solid #c084fc' : '1px solid #e5e7eb',
                              opacity: _dead ? 0.8 : 1,
                              position: 'relative'
                            }}>
                              {/* Top Section: QR Code and Status */}
                              <div style={{
                                padding: '1.5rem 1.5rem 2rem 1.5rem',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                borderBottom: '3px dashed #e5e7eb',
                                position: 'relative',
                                backgroundColor: isActualVendorBooth ? '#f3e8ff' : '#fafafa'
                              }}>
                                {/* Ticket Cutouts */}
                                <div style={{ position: 'absolute', bottom: '-12px', left: '-12px', width: '24px', height: '24px', backgroundColor: '#fff', borderRadius: '50%', border: '1px solid #e5e7eb', zIndex: 10 }}></div>
                                <div style={{ position: 'absolute', bottom: '-12px', right: '-12px', width: '24px', height: '24px', backgroundColor: '#fff', borderRadius: '50%', border: '1px solid #e5e7eb', zIndex: 10 }}></div>
                                
                                {/* Header / Status / VIP */}
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                                  <span style={{
                                    padding: '4px 12px', borderRadius: '20px', fontSize: '0.8rem', fontWeight: 'bold',
                                    backgroundColor: isVoidedTicket(ticket) ? '#e5e7eb' : ticket.is_transferred ? '#dbeafe' : ticket.status === 'ISSUED' ? '#dcfce7' : ticket.status === 'USED' ? '#fee2e2' : '#fef3c7',
                                    color: isVoidedTicket(ticket) ? '#4b5563' : ticket.is_transferred ? '#1d4ed8' : ticket.status === 'ISSUED' ? '#166534' : ticket.status === 'USED' ? '#991b1b' : '#92400e',
                                    textTransform: 'uppercase', letterSpacing: '0.05em'
                                  }}>
                                    {ticket.display_status || ticket.status}
                                  </span>
                                  {ticket.metadata?.is_vip && (
                                    <span style={{
                                      padding: '4px 12px', borderRadius: '20px', background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: '#fff',
                                      fontSize: '0.8rem', fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', boxShadow: '0 2px 8px rgba(245,158,11,0.3)'
                                    }}>⭐ VIP</span>
                                  )}
                                </div>
                                
                                {/* Pass Label */}
                                <h3 style={{ margin: '0 0 1rem 0', color: _dead ? '#6b7280' : isActualVendorBooth ? '#6b21a8' : '#111', fontSize: '1.25rem', textAlign: 'center', fontWeight: '800' }}>
                                  {isActualVendorBooth && '🏪 '}
                                  {(() => {
                                    if (group.passLabel) {
                                      if (group.isMultiDay || group.tickets.length > 1) {
                                        return group.passLabel + " (QR Code " + (ticketIdx + 1) + " of " + group.tickets.length + ")";
                                      }
                                      return group.passLabel;
                                    }
                                    return isCompTicket ? '3-Day Pass' : ticket.ticket_type_name;
                                  })()}
                                </h3>

                                {/* Refunded ticket notice */}
                                {isVoidedTicket(ticket) && (
                                  <div style={{ padding: '0.5rem 1rem', backgroundColor: '#fef2f2', color: '#991b1b', borderRadius: '6px', fontSize: '0.8rem', fontWeight: 600, textAlign: 'center', border: '1px solid #fecaca', marginBottom: '1rem', width: '100%' }}>
                                    {getVoidedTicketNotice(ticket)}
                                  </div>
                                )}

                                {/* QR Code Container */}
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', width: '100%' }}>
                                  {ticket.metadata?.type === 'vendor-booth' && vendorIsPending ? (
                                    <div style={{ width: '100%', maxWidth: '220px', aspectRatio: '1', padding: '1rem', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: '2px dashed #d97706', borderRadius: '16px', backgroundColor: '#fffbeb', margin: '0 auto' }}>
                                      <span style={{ fontSize: '2.5rem' }}>⏳</span>
                                      <p style={{ margin: '0.5rem 0 0', fontWeight: '600', color: '#92400e', fontSize: '0.9rem', textAlign: 'center' }}>Pending Approval</p>
                                      <p style={{ margin: '0.25rem 0 0', color: '#b45309', fontSize: '0.75rem', textAlign: 'center' }}>QR code available after approval</p>
                                    </div>
                                  ) : ticket.qr_code && !isWristbandTicket(ticket) && (
                                    <div style={{
                                      padding: '12px',
                                      backgroundColor: '#fff',
                                      borderRadius: '16px',
                                      boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
                                      border: isVoidedTicket(ticket) ? '2px solid #9ca3af' : ticket.metadata?.is_vip ? '3px solid #f59e0b' : '1px solid #e5e7eb',
                                    }}>
                                      {isVoidedTicket(ticket) ? (
                                        <img loading="lazy"
                                          src="/QR_Voided.svg"
                                          alt={"QR Code for " + ticket.ticket_code}
                                          style={{ width: '200px', height: '200px', maxWidth: '100%', display: 'block', opacity: 0.5, borderRadius: '8px' }}
                                        />
                                      ) : (
                                        <RotatingQrImg
                                          ticket={ticket}
                                          size={200}
                                          alt={"QR Code for " + ticket.ticket_code}
                                          style={{ width: '200px', height: '200px', maxWidth: '100%', display: 'block', borderRadius: '8px' }}
                                        />
                                      )}
                                    </div>
                                  )}
                                  
                                  {/* Download PDF button right below QR for easy access */}
                                  {!isVoidedTicket(ticket) && ticket.qr_code && !isWristbandTicket(ticket) && (
                                    <a
                                      href={api.getTicketPDFUrl(ticket.id)}
                                      download
                                      style={{
                                        marginTop: '0.5rem', padding: '12px 28px', backgroundColor: '#1d1d1d', color: '#ffffff', textDecoration: 'none', borderRadius: '50px', fontSize: '14px', fontWeight: '600', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', width: '100%', maxWidth: '240px', transition: 'all 0.3s ease'
                                      }}
                                    >
                                      Download PDF Ticket
                                    </a>
                                  )}
                                </div>
                              </div>

                              {/* Bottom Section: Details & Transfer */}
                              <div style={{ padding: '1.5rem', backgroundColor: _dead ? '#f9fafb' : isActualVendorBooth ? '#faf5ff' : '#fff' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0.75rem', fontSize: '0.9rem' }}>
                                  
                                  {/* Code */}
                                  {((ticket.ticket_type_name?.toLowerCase().includes('vendor') || ticket.ticket_type_name?.toLowerCase().includes('booth')) && vendorIsPending) ? (
                                    <p style={{ margin: '0', color: '#854d0e', fontSize: '0.85rem' }}>Booth code available after approval</p>
                                  ) : (
                                    <p style={{ margin: '0', color: _dead ? '#9ca3af' : '#4b5563' }}>
                                      <strong>{(ticket.ticket_type_name?.toLowerCase().includes('vendor') || ticket.ticket_type_name?.toLowerCase().includes('booth')) ? 'Booth Code:' : 'Code:'}</strong> <span style={{ fontFamily: 'monospace', fontSize: '1rem', color: '#111', wordBreak: 'break-all' }}>{ticket.ticket_code}</span>
                                    </p>
                                  )}

                                  <p style={{ margin: '0', color: _dead ? '#9ca3af' : '#4b5563' }}><strong>Date Added:</strong> {ticket.created_at ? new Date(ticket.created_at).toLocaleDateString() : 'N/A'}</p>

                                  {ticket.metadata?.booth_name && <p style={{ margin: '0', color: _dead ? '#9ca3af' : '#4b5563' }}><strong>Booth Name:</strong> {ticket.metadata.booth_name}</p>}
                                  {ticket.metadata?.legal_business_name && <p style={{ margin: '0', color: _dead ? '#9ca3af' : '#4b5563' }}><strong>Business:</strong> {ticket.metadata.legal_business_name}</p>}
                                  
                                  {isCompTicket && (ticket.vendor_business_name || vendorOrderInfo?.businessName) && (
                                    <p style={{ margin: '0.25rem 0', color: _dead ? '#9ca3af' : '#7c3aed', fontSize: '0.85rem', fontWeight: 500 }}>Vendor complimentary ticket - {ticket.vendor_business_name || vendorOrderInfo?.businessName}</p>
                                  )}
                                  {isCompTicket && (
                                    <p style={{ margin: '0.25rem 0', color: _dead ? '#9ca3af' : '#666', fontSize: '0.85rem', fontStyle: 'italic' }}>Valid for any one festival day</p>
                                  )}

                                  {ticket.is_transferred && ticket.original_owner_email && (
                                    <p style={{ margin: '0', color: '#6b7280', fontSize: '0.85rem' }}>Transferred from: {ticket.original_owner_email}</p>
                                  )}
                                </div>

                                {/* Wallets */}
                                {!isVoidedTicket(ticket) && (
                                  <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', marginTop: '1.5rem', flexWrap: 'wrap' }}>
                                    <div style={{ width: '140px' }}>
                                      <img loading="lazy" src={getCmsImagePath("appleBadge", "/apple.webp")} alt="Add to Apple Wallet" style={{ width: '100%', height: 'auto', display: 'block', cursor: 'pointer', borderRadius: '8px', border: '1.5px solid #1a1a1a' }} onClick={() => handleAppleWallet(ticket.id)} />
                                    </div>
                                    {googleWalletEnabled && (
                                      <div style={{ width: '140px' }}>
                                        <img loading="lazy" src={getCmsImagePath("googleWalletBadge", "/enUS_add_to_google_wallet_add-wallet-badge.svg")} alt="Add to Google Wallet" style={{ width: '100%', height: 'auto', display: 'block', cursor: 'pointer', borderRadius: '8px' }} onClick={() => handleGoogleWallet(ticket.id)} />
                                      </div>
                                    )}
                                  </div>
                                )}

                                {/* Transfer & Return Buttons */}
                                <div style={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                  {ticket.pending_transfer && (
                                    <div style={{ padding: '0.75rem', backgroundColor: '#fef9c3', borderRadius: '8px', borderLeft: '4px solid #eab308' }}>
                                      <p style={{ margin: '0', fontSize: '0.9rem', fontWeight: '600', color: '#854d0e' }}>Transfer Pending</p>
                                      <p style={{ margin: '0.25rem 0 0', fontSize: '0.85rem', color: '#854d0e' }}>To: {ticket.pending_transfer.to_email}</p>
                                      <p style={{ margin: '0.25rem 0 0', fontSize: '0.75rem', color: '#854d0e' }}>Expires: {new Date(ticket.pending_transfer.expires_at).toLocaleString()}</p>
                                    </div>
                                  )}

                                  {!group.isMultiDay && (ticket.status === 'ISSUED' || ticket.status === 'Active' || ticket.display_status === 'Active') && (isCompTicket || (!ticket.ticket_type_name?.toLowerCase().includes('vendor') && !ticket.ticket_type_name?.toLowerCase().includes('booth'))) && !ticket.pending_transfer && (
                                    <button
                                      onClick={() => { setTransferModal({ open: true, ticket, tickets: [ticket] }); setTransferEmail(''); setTransferLabel(''); setTransferError(''); setTransferSuccess(false); }}
                                      className="secondary-btn"
                                      style={{ padding: '0.75rem 1rem', backgroundColor: 'white', color: '#1a1a1a', border: '2px solid #1a1a1a', borderRadius: '8px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: '600', transition: 'all 0.2s ease', width: '100%' }}
                                    >
                                      Transfer Ticket
                                    </button>
                                  )}

                                  {(() => {
                                    const rt = receivedTransfers.find(t => t.status === 'ACCEPTED' && t.ticket_code === ticket.ticket_code);
                                    if (!rt || ticket.status !== 'ISSUED') return null;
                                    const returnGroupKey = rt.pass_group_key || rt.id;
                                    const groupReturns = receivedTransfers.filter(t => t.status === 'ACCEPTED' && (t.pass_group_key || t.id) === returnGroupKey);
                                    const returnIds = (groupReturns.length ? groupReturns : [rt]).map(t => t.id);
                                    const returnBusy = returningGroupKey === returnGroupKey;
                                    return (
                                      <button
                                        onClick={() => handleReturnTransferGroup(returnIds, returnGroupKey)}
                                        disabled={returnBusy}
                                        style={{ padding: '0.75rem 1rem', backgroundColor: '#fff', color: '#dc2626', border: '2px solid #dc2626', borderRadius: '8px', cursor: returnBusy ? 'not-allowed' : 'pointer', fontSize: '0.85rem', fontWeight: '600', transition: 'all 0.2s ease', opacity: returnBusy ? 0.6 : 1, width: '100%' }}
                                      >
                                        {returnBusy ? 'Returning...' : (returnIds.length > 1 ? 'Return Pass to Sender' : 'Return to Sender')}
                                      </button>
                                    );
                                  })()}
                                </div>
                              </div>
                            </div>
                          );
                        })}

                        {/* Group-level Transfer button for multi-day passes */}

                        {group.isMultiDay && group.tickets.some(t => t.status === 'ISSUED' && !t.pending_transfer) && (

                          <div style={{ textAlign: 'center', margin: '0.5rem 0 1.5rem' }}>

                            <button

                              onClick={() => {

                                setTransferModal({ open: true, ticket: group.tickets[0], tickets: group.tickets });

                                setTransferEmail('');

                                setTransferLabel('');

                                setTransferError('');

                                setTransferSuccess(false);

                              }}

                              className="secondary-btn"

                              style={{

                                padding: '0.6rem 1.5rem',

                                backgroundColor: 'white',

                                color: '#1a1a1a',

                                border: '2px solid #1a1a1a',

                                borderRadius: '6px',

                                cursor: 'pointer',

                                fontSize: '0.9rem',

                                fontWeight: '600',

                                transition: 'all 0.2s ease'

                              }}

                            >

                              Transfer Entire {group.passLabel || 'Pass'}

                            </button>

                          </div>

                        )}



                      </React.Fragment>

                    ))}



                    {renderDashboardPagination(currentFestivalPage, festivalTicketsTotalPages, passGroups.length, setFestivalTicketsPage)}



                  </>

                );

              })()}



              {/* Sent/Transferred festival tickets (exclude amp transfers — they show in amp tab) */}

              {sentTransfers.filter(t => {

                const cat = t.ticket_category || '';

                const name = (t.ticket_type || '').toLowerCase();

                const isAmp = cat === 'amphitheater' || name.includes('amphitheater') || name.includes('amphitheatre') || name.includes('pacific');

                return !isAmp && (t.status === 'ACCEPTED' || t.status === 'PENDING');

              }).length > 0 && (

                  <div style={{ marginTop: '2rem', borderTop: '1px solid #e5e7eb', paddingTop: '1.5rem' }}>

                    <h3 style={{ margin: '0 0 1rem', fontSize: '1rem', color: '#6b7280' }}>Transferred Tickets</h3>

                    {(() => {

                      const visible = sentTransfers.filter(t => {
                        const cat = t.ticket_category || '';
                        const name = (t.ticket_type || '').toLowerCase();
                        const isAmp = cat === 'amphitheater' || name.includes('amphitheater') || name.includes('amphitheatre') || name.includes('pacific');
                        return !isAmp && (t.status === 'ACCEPTED' || t.status === 'PENDING');
                      });

                      // Group all QR codes of the SAME pass (same recipient + pass_group_key)
                      // so a 2/3-day pass shows ONE card with ONE recall button.
                      const groupsMap = {};
                      visible.forEach(tr => {
                        const gk = `${(tr.to_email || '').toLowerCase()}::${tr.pass_group_key || tr.id}`;
                        if (!groupsMap[gk]) groupsMap[gk] = [];
                        groupsMap[gk].push(tr);
                      });

                      return Object.entries(groupsMap).map(([groupKey, groupTransfers]) => {
                        const rep = groupTransfers[0];
                        const groupCount = groupTransfers.length;
                        const pendingIds = groupTransfers.filter(t => t.status === 'PENDING').map(t => t.id);
                        const allAccepted = groupTransfers.every(t => t.status === 'ACCEPTED');
                        const busy = recallingGroupKey === groupKey;
                        const baseLabel = (rep.ticket_type || 'Festival Ticket').replace(/\s*\(.*\)\s*$/, '').trim() || 'Festival Ticket';
                        return (
                          <div key={groupKey} style={{
                            border: '1px solid #e5e7eb',
                            borderRadius: '10px',
                            padding: '1rem 1.25rem',
                            marginBottom: '0.75rem',
                            backgroundColor: '#f9fafb',
                            opacity: 0.85
                          }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
                              <div>
                                <p style={{ margin: 0, fontWeight: 600, fontSize: '0.95rem', color: '#374151' }}>
                                  {baseLabel}{groupCount > 1 ? ` · ${groupCount} ticket codes` : ''}
                                </p>
                                <p style={{ margin: '0.25rem 0 0', fontSize: '0.85rem', color: '#6b7280' }}>
                                  Transferred to: {rep.to_email}
                                </p>
                                <p style={{ margin: '0.25rem 0 0', fontSize: '0.75rem', color: '#9ca3af' }}>
                                  {allAccepted
                                    ? `All ${groupCount} transfer${groupCount > 1 ? 's' : ''} accepted`
                                    : `${pendingIds.length} pending transfer${pendingIds.length > 1 ? 's' : ''}`
                                  }
                                </p>
                                <div style={{ margin: '0.35rem 0 0', fontSize: '0.76rem', color: '#6b7280' }}>
                                  {[...groupTransfers]
                                    .sort((a, b) => new Date(a.created_at || 0).getTime() - new Date(b.created_at || 0).getTime())
                                    .map((tr) => (
                                      <p key={tr.id} style={{ margin: '0.12rem 0' }}>
                                        {tr.ticket_code || tr.id}
                                        {formatTransferWhatLabel(tr) ? ` · ${formatTransferWhatLabel(tr)}` : ''}
                                        {` · ${formatTransferTimelineLabel(tr)}`}
                                      </p>
                                    ))}
                                </div>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                {pendingIds.length > 0 && (
                                  <button
                                    onClick={() => handleRecallTransferGroup(pendingIds, groupKey)}
                                    disabled={busy}
                                    style={{
                                      padding: '5px 14px', borderRadius: '20px', fontSize: '0.78rem', fontWeight: 600,
                                      border: '1.5px solid #dc2626', backgroundColor: '#fff', color: '#dc2626',
                                      cursor: busy ? 'not-allowed' : 'pointer', opacity: busy ? 0.6 : 1
                                    }}
                                  >
                                    {busy ? 'Recalling...' : (groupCount > 1 ? 'Recall Pass' : 'Recall Ticket')}
                                  </button>
                                )}
                                <span style={{
                                  padding: '4px 12px', borderRadius: '20px', fontSize: '0.78rem', fontWeight: 600,
                                  backgroundColor: allAccepted ? '#dbeafe' : '#fef3c7',
                                  color: allAccepted ? '#1d4ed8' : '#92400e'
                                }}>
                                  {allAccepted ? 'Transferred' : 'Pending'}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      });

                    })()}

                  </div>

                )}



            </div>



          </div>



        );



      case 'parking-passes': {

        const parkingPassTickets = (tickets.parking_tickets || []).filter((ticket) => isParkingPassTicket(ticket));

        const parkingTicketsTotalPages = Math.max(1, Math.ceil(parkingPassTickets.length / DASHBOARD_TICKETS_PAGE_SIZE));

        const currentParkingPage = Math.min(parkingTicketsPage, parkingTicketsTotalPages);

        const paginatedParkingTickets = parkingPassTickets.slice(

          (currentParkingPage - 1) * DASHBOARD_TICKETS_PAGE_SIZE,

          currentParkingPage * DASHBOARD_TICKETS_PAGE_SIZE,

        );



        return (

          <div className="content-section">

            <h2 className="section-title">Parking Passes</h2>

            <div className="static-content">

              {parkingPassTickets.length === 0 ? (

                <div style={{ textAlign: 'center', padding: '2rem' }}>

                  <div style={{ fontSize: '42px', marginBottom: '0.8rem' }}>🅿️</div>

                  <p style={{ marginBottom: '0.5rem' }}>No parking passes available.</p>

                  <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>

                    Parking passes are issued for eligible VIP registrations with 2 or more plus-ones.

                  </p>

                </div>

              ) : (

                <>

                  <div style={{

                    marginBottom: '1rem',

                    padding: '0.75rem 1rem',

                    borderRadius: '10px',

                    border: '1px solid #a7f3d0',

                    backgroundColor: '#ecfdf5',

                    color: '#065f46',

                    fontSize: '0.9rem',

                    fontWeight: 600,

                  }}>

                    VIP Parking Pass — scan this QR code at parking entry.

                  </div>



                  {paginatedParkingTickets.map((ticket) => {

                    const _dead = isVoidedTicket(ticket);
                    const canTransferParking = !_dead &&
                      (ticket.status === 'ISSUED' || ticket.status === 'Active' || ticket.display_status === 'Active') &&
                      !ticket.pending_transfer;

                    const ticketCode = ticket?.ticket_code || '';

                    const scanLink = ticketCode ? `${window.location.origin}/scan?code=${encodeURIComponent(ticketCode)}` : '';

                    const qrImageUrl = ticket?.qr_code || (scanLink

                      ? `https://api.qrserver.com/v1/create-qr-code/?size=240x240&margin=0&data=${encodeURIComponent(scanLink)}`

                      : '');



                    return (

                      <div key={ticket.id} style={{

                        border: _dead ? '2px solid #d1d5db' : '2px solid #10b981',

                        borderRadius: '12px',

                        padding: '1.2rem',

                        marginBottom: '1rem',

                        backgroundColor: _dead ? '#f9fafb' : '#ecfdf5',

                        opacity: _dead ? 0.85 : 1,

                      }}>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.9rem' }}>

                          <div style={{ textAlign: 'center' }}>

                            <h3 style={{ margin: '0 0 0.35rem 0', color: '#065f46' }}>VIP Parking Pass</h3>

                            <p style={{ margin: 0, color: '#065f46', fontSize: '0.92rem' }}><strong>Code:</strong> {ticket.ticket_code}</p>

                            <p style={{ margin: '0.35rem 0 0', color: '#065f46', fontSize: '0.85rem' }}><strong>Status:</strong> {ticket.display_status || ticket.status}</p>

                            {ticket.pending_transfer && (
                              <div style={{
                                marginTop: '0.6rem',
                                padding: '0.55rem 0.8rem',
                                borderRadius: '8px',
                                backgroundColor: '#fef3c7',
                                borderLeft: '4px solid #eab308',
                              }}>
                                <p style={{ margin: 0, fontSize: '0.82rem', fontWeight: 600, color: '#854d0e' }}>
                                  Transfer Pending
                                </p>
                                <p style={{ margin: '0.2rem 0 0', fontSize: '0.78rem', color: '#854d0e' }}>
                                  To: {ticket.pending_transfer.to_email}
                                </p>
                              </div>
                            )}

                            {canTransferParking && (
                              <button
                                onClick={() => {
                                  setTransferModal({ open: true, ticket, tickets: [ticket] });
                                  setTransferEmail('');
                                  setTransferLabel('');
                                  setTransferError('');
                                  setTransferSuccess(false);
                                }}
                                className="secondary-btn"
                                style={{
                                  marginTop: '0.75rem',
                                  padding: '0.45rem 0.95rem',
                                  backgroundColor: '#fff',
                                  color: '#065f46',
                                  border: '1px solid #10b981',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  fontSize: '0.82rem',
                                  fontWeight: 700,
                                }}
                              >
                                Transfer
                              </button>
                            )}

                          </div>



                          {qrImageUrl && (

                            _dead ? (

                              <img

                                src="/QR_Voided.svg"

                                alt="VIP Parking Pass QR"

                                style={{ width: 220, height: 220, borderRadius: 10, border: '1px solid #a7f3d0', background: '#fff', opacity: 0.5 }}

                              />

                            ) : (

                              <RotatingQrImg

                                ticket={ticket}

                                size={220}

                                alt="VIP Parking Pass QR"

                                style={{ width: 220, height: 220, borderRadius: 10, border: '1px solid #a7f3d0', background: '#fff' }}

                              />

                            )

                          )}



                          {_dead ? (

                            <div style={{

                              padding: '0.5rem 1rem',

                              backgroundColor: '#fef2f2',

                              color: '#991b1b',

                              borderRadius: '6px',

                              fontSize: '0.8rem',

                              fontWeight: 600,

                              textAlign: 'center',

                              border: '1px solid #fecaca',

                            }}>

                              {getVoidedTicketNotice(ticket)}

                            </div>

                          ) : (

                            <>

                              <div style={{ width: '86%', maxWidth: '240px' }}>

                                <img loading="lazy"

                                  src={getCmsImagePath("appleBadge", "/apple.webp")}

                                  alt="Add to Apple Wallet"

                                  style={{

                                    width: '100%',

                                    height: 'auto',

                                    display: 'block',

                                    cursor: 'pointer',

                                    borderRadius: '8px',

                                    border: '1.5px solid #1a1a1a',

                                  }}

                                  onClick={() => handleAppleWallet(ticket.id)}

                                />

                              </div>



                              {googleWalletEnabled && (

                                <div style={{ width: '86%', maxWidth: '240px' }}>

                                  <img loading="lazy"

                                    src={getCmsImagePath("googleWalletBadge", "/enUS_add_to_google_wallet_add-wallet-badge.svg")}

                                    alt="Add to Google Wallet"

                                    style={{ width: '100%', height: 'auto', display: 'block', cursor: 'pointer', borderRadius: '8px' }}

                                    onClick={() => handleGoogleWallet(ticket.id)}

                                  />

                                </div>

                              )}



                              <a

                                href={api.getTicketPDFUrl(ticket.id)}

                                download

                                style={{

                                  marginTop: '0.5rem',

                                  padding: '10px 24px',

                                  backgroundColor: '#ffffff',

                                  color: '#1d1d1d',

                                  textDecoration: 'none',

                                  borderRadius: '50px',

                                  fontSize: '14px',

                                  fontWeight: '600',

                                  textAlign: 'center',

                                  display: 'flex',

                                  alignItems: 'center',

                                  justifyContent: 'center',

                                  border: '2px solid #ffffff',

                                }}

                              >

                                Download PDF ticket

                              </a>

                            </>

                          )}

                        </div>

                      </div>

                    );

                  })}



                  {renderDashboardPagination(currentParkingPage, parkingTicketsTotalPages, parkingPassTickets.length, setParkingTicketsPage)}

                </>

              )}

            </div>

          </div>

        );

      }



      case 'vendor-tickets':



        return (



          <div className="content-section">



            <h2 className="section-title">Vendor Tickets</h2>



            <div className="static-content">



              {(() => {

                // Filter: actual vendor booth ticket rows (legacy + current shapes),

                // while excluding voided rows and vendor comp festival tickets.

                const boothOnly = (tickets.vendor_tickets || []).filter((ticket) =>
                  !isVoidedTicket(ticket) && isVendorBoothTicket(ticket)
                );

                return boothOnly.length === 0 ? (



                  <div style={{ textAlign: 'center', padding: '2rem' }}>



                    <div style={{ fontSize: '48px', marginBottom: '1rem' }}>🏪</div>



                    <p style={{ marginBottom: '1rem' }}>No vendor tickets yet.</p>



                    <p style={{ color: '#666', fontSize: '14px', marginBottom: '1.5rem' }}>



                      Reserve your booth space at the OC MENA Festival!



                    </p>



                    <a href="/vendor-booths" className="browse-cta-btn" style={{



                      display: 'inline-block',



                      backgroundColor: '#9333ea',



                      color: 'white',



                      padding: '12px 24px',



                      borderRadius: '25px',



                      textDecoration: 'none',



                      fontWeight: '600',



                      transition: 'all 0.3s ease'



                    }}>



                      Browse Vendor Booths



                    </a>



                  </div>



                ) : (



                  boothOnly.map(ticket => {

                    const _dead = isVoidedTicket(ticket);

                    return (



                      <div key={ticket.id} style={{



                        border: _dead ? '2px solid #d1d5db' : '2px solid #9333ea',



                        borderRadius: '12px',



                        padding: '1.5rem',



                        marginBottom: '1rem',



                        backgroundColor: _dead ? '#f9fafb' : '#faf5ff',



                        opacity: _dead ? 0.85 : 1



                      }}>



                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>



                          <div style={{ flex: 1, minWidth: '200px' }}>



                            <h3 style={{



                              margin: '0 0 0.5rem 0',



                              color: _dead ? '#6b7280' : '#6b21a8',



                              display: 'flex',



                              alignItems: 'center',



                              gap: '0.5rem'



                            }}>



                              🏪 {ticket.ticket_type_name}



                            </h3>



                            {vendorIsPending ? (

                              <p style={{ margin: '0.5rem 0', padding: '0.5rem', backgroundColor: '#fef9c3', borderRadius: '6px', fontSize: '0.9rem', color: '#854d0e' }}>

                                Your vendor application is pending approval. Booth code and QR will be available once approved.

                              </p>

                            ) : !_dead ? (

                              <p style={{ margin: '0.5rem 0', padding: '0.5rem', backgroundColor: '#fef3c7', borderRadius: '6px', fontSize: '0.9rem', color: '#92400e' }}>

                                Use this to check in for setup day and receive your vendor wristbands

                              </p>

                            ) : null}



                            {!vendorIsPending && (

                              <p style={{ margin: '0.25rem 0', color: _dead ? '#9ca3af' : '#666' }}>

                                <strong>Booth Code:</strong> {ticket.ticket_code}

                              </p>

                            )}



                            <p style={{ margin: '0.25rem 0' }}>



                              <strong>Status:</strong>{' '}



                              <span style={{



                                padding: '2px 8px',



                                borderRadius: '4px',



                                fontSize: '0.85rem',



                                fontWeight: 'bold',



                                backgroundColor: vendorIsPending ? '#fef3c7' :

                                  isVoidedTicket(ticket) ? '#e5e7eb' :



                                    ticket.status === 'ISSUED' ? '#dcfce7' :



                                      ticket.status === 'USED' ? '#fee2e2' : '#fef3c7',



                                color: vendorIsPending ? '#92400e' :

                                  isVoidedTicket(ticket) ? '#6b7280' :



                                    ticket.status === 'ISSUED' ? '#166534' :



                                      ticket.status === 'USED' ? '#991b1b' : '#92400e'



                              }}>



                                {vendorIsPending ? 'Pending Approval' : (ticket.display_status || ticket.status)}



                              </span>



                            </p>



                          </div>



                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>



                            {/* Show QR code and wallet buttons when vendor is NOT pending */}

                            {!vendorIsPending && ticket.qr_code && !isWristbandTicket(ticket) && (



                              <>



                                {isVoidedTicket(ticket) ? (
                                  <img loading="lazy"
                                    src="/QR_Voided.svg"
                                    alt={`QR Code for ${ticket.ticket_code}`}
                                    style={{
                                      width: '200px',
                                      height: '200px',
                                      border: '2px solid #9ca3af',
                                      padding: '8px',
                                      backgroundColor: 'white',
                                      borderRadius: '8px',
                                      opacity: 0.5
                                    }}
                                  />
                                ) : (
                                  <RotatingQrImg
                                    ticket={ticket}
                                    size={200}
                                    alt={`QR Code for ${ticket.ticket_code}`}
                                    style={{
                                      width: '200px',
                                      height: '200px',
                                      border: '2px solid #9333ea',
                                      padding: '8px',
                                      backgroundColor: 'white',
                                      borderRadius: '8px'
                                    }}
                                  />
                                )}



                                {/* Refunded ticket notice */}



                                {isVoidedTicket(ticket) && (



                                  <div style={{



                                    padding: '0.5rem 1rem',



                                    backgroundColor: '#fef2f2',



                                    color: '#991b1b',



                                    borderRadius: '6px',



                                    fontSize: '0.8rem',



                                    fontWeight: 600,



                                    textAlign: 'center',



                                    border: '1px solid #fecaca'



                                  }}>



                                    {getVoidedTicketNotice(ticket)}



                                  </div>



                                )}



                                {/* Download buttons - hide for refunded/cancelled */}



                                {!isVoidedTicket(ticket) && (



                                  <>



                                    <div style={{ width: '86%', maxWidth: '240px', margin: '0.5rem auto 0' }}>

                                      <img loading="lazy"

                                        src={getCmsImagePath("appleBadge", "/apple.webp")}

                                        alt="Add to Apple Wallet"

                                        style={{

                                          width: '100%',

                                          height: 'auto',

                                          display: 'block',

                                          cursor: 'pointer',

                                          borderRadius: '8px',



                                        }}

                                        onClick={() => handleAppleWallet(ticket.id)}

                                      />

                                    </div>



                                    {googleWalletEnabled && (

                                      <div style={{ width: '86%', maxWidth: '240px', margin: '0.5rem auto 0' }}>

                                        <img loading="lazy"

                                          src={getCmsImagePath("googleWalletBadge", "/enUS_add_to_google_wallet_add-wallet-badge.svg")}

                                          alt="Add to Google Wallet"

                                          style={{

                                            width: '100%',

                                            height: 'auto',

                                            display: 'block',

                                            cursor: 'pointer',

                                            borderRadius: '8px',



                                          }}

                                          onClick={() => handleGoogleWallet(ticket.id)}

                                        />

                                      </div>

                                    )}



                                    <a



                                      href={api.getTicketPDFUrl(ticket.id)}



                                      download



                                      style={{



                                        display: 'inline-block',



                                        backgroundColor: '#ffffff',



                                        color: '#1d1d1d',



                                        padding: '12px 28px',



                                        textDecoration: 'none',



                                        borderRadius: '50px',



                                        fontSize: '14px',



                                        fontWeight: '600',



                                        transition: 'all 0.3s ease',



                                        marginTop: '0.5rem',



                                        width: '100%',



                                        textAlign: 'center',



                                        border: '2px solid #ffffff'



                                      }}



                                      onMouseEnter={(e) => {

                                        e.target.style.backgroundColor = '#dc2626';

                                        e.target.style.color = '#ffffff';

                                        e.target.style.borderColor = '#dc2626';



                                      }}



                                      onMouseLeave={(e) => {

                                        e.target.style.backgroundColor = '#ffffff';

                                        e.target.style.color = '#1d1d1d';

                                        e.target.style.borderColor = '#ffffff';



                                      }}



                                    >



                                      Download PDF ticket



                                    </a>



                                  </>



                                )}



                              </>



                            )}



                          </div>



                        </div>



                      </div>



                    );
                  })



                );

              })()}







              {/* Vendor Documents Link - show when user has vendor tickets */}



              {activeVendorTickets.length > 0 && (



                <div style={{



                  marginTop: '2rem',



                  padding: '1.5rem',



                  backgroundColor: '#f0fdf4',



                  border: '2px solid #22c55e',



                  borderRadius: '12px',



                  textAlign: 'center'



                }}>



                  <h3 style={{ margin: '0 0 0.5rem 0', color: '#166534' }}>📋 Vendor Documents Required</h3>



                  <p style={{ color: '#166534', marginBottom: '1rem', fontSize: '0.9rem' }}>



                    Don't forget to upload your permits and sign your vendor contract!



                  </p>



                  <button



                    onClick={() => setActiveSection('vendor-documents')}



                    style={{



                      backgroundColor: '#22c55e',



                      color: 'white',



                      padding: '10px 24px',



                      borderRadius: '8px',



                      border: 'none',



                      fontWeight: '600',



                      fontSize: '1rem',



                      cursor: 'pointer',



                      transition: 'all 0.3s ease'



                    }}



                  >



                    Go to Vendor Documents →



                  </button>



                </div>



              )}



            </div>



          </div>



        );



      case 'orders':



        return (



          <div className="content-section">



            <h2 className="section-title">Orders</h2>







            <div className="static-content">



              {(() => {



                const visibleOrders = orders.filter(order => !isManualAffiliateComplimentaryOrder(order));



                return visibleOrders.length === 0 ? (



                  <p>No orders yet.</p>



                ) : (



                  visibleOrders.map(order => {



                    const isDisputed = order.status === 'DISPUTED';

                    const isRefunded = order.status === 'REFUNDED' || order.status === 'PARTIALLY_REFUNDED';

                    const isPartialRefund = order.status === 'PARTIALLY_REFUNDED';

                    const orderRefundedDollars = (order.refunded_cents || 0) / 100;

                    const orderNetAfterRefund = Number(order.total) - orderRefundedDollars;

                    const refundDateStr = order.metadata?.refund_date

                      ? new Date(order.metadata.refund_date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })

                      : null;



                    return (

                      <React.Fragment key={order.id}>



                        {/* Original Order — plain design */}

                        <div style={{ borderBottom: '1px solid #eee', padding: '1rem 0' }}>



                          <p><strong>Order:</strong> {order.order_number}</p>



                          <p><strong>Status:</strong> {order.status}</p>



                          {order.tax > 0 && <p><strong>Tax (7.75%):</strong> ${Number(order.tax).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>}



                          <p><strong>Total:</strong> ${Number(order.total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>



                          <p><strong>Payment Method:</strong> {order.payment_method === 'cash' ? 'COD' : order.payment_method === 'card' ? `Credit Card ****${order.card_last4 || ''}` : 'Credit Card'}</p>



                          <p><strong>Date:</strong> {new Date(order.created_at).toLocaleDateString()}</p>



                          {isDisputed && (



                            <p style={{ color: '#b91c1c', marginTop: '0.5rem' }}>



                              <strong>This order has been disputed and all tickets were voided</strong>



                            </p>



                          )}



                          {isRefunded && (



                            <p style={{ color: '#dc2626', marginTop: '0.5rem' }}>



                              <strong>This order has been {isPartialRefund ? 'partially ' : ''}refunded</strong>



                            </p>



                          )}



                          {/* No refunds messaging removed */}



                          {/* Invoice download button */}

                          <button

                            onClick={() => generateInvoice(order)}

                            style={{

                              marginTop: '0.75rem',

                              padding: '0.5rem 1rem',

                              backgroundColor: '#0ea5e9',

                              color: 'white',

                              textDecoration: 'none',

                              borderRadius: '6px',

                              fontSize: '0.9rem',

                              fontWeight: '600',

                              display: 'flex',

                              alignItems: 'center',

                              width: 'fit-content',

                              gap: '0.5rem',

                              border: 'none',

                              cursor: 'pointer'

                            }}

                          >

                            Download Invoice

                          </button>



                        </div>



                        {/* Separate Refund Card — only shown for refunded orders */}

                        {isRefunded && orderRefundedDollars > 0 && (

                          <div style={{

                            borderBottom: '1px solid #eee',

                            padding: '1rem 0',

                            backgroundColor: isPartialRefund ? '#fffbeb' : '#fef2f2',

                            margin: '0 -1rem',

                            paddingLeft: '1rem',

                            paddingRight: '1rem'

                          }}>

                            <p style={{ margin: 0, fontWeight: 700, color: isPartialRefund ? '#9a3412' : '#991b1b' }}>

                              {isPartialRefund ? 'Partial Refund' : 'Refund'} - {order.order_number}

                            </p>

                            <p style={{ margin: '0.25rem 0', fontSize: '0.9em', color: '#666' }}>

                              <strong>Date:</strong> {refundDateStr || 'Refund processed'}

                            </p>

                            <p><strong>Original Total:</strong> ${Number(order.total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>

                            <p style={{ color: '#dc2626', fontWeight: 600 }}><strong>Refund:</strong> -${orderRefundedDollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>

                            <p style={{ fontWeight: 700, color: isPartialRefund ? '#9a3412' : '#dc2626' }}>

                              <strong>{isPartialRefund ? 'Amount After Refund:' : 'Balance:'}</strong> ${orderNetAfterRefund.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}

                            </p>

                            <p style={{ fontSize: '0.9em', color: '#666' }}>

                              <strong>Refund Method:</strong> Returned to original payment method{order.card_last4 ? ` (****${order.card_last4})` : ''}

                            </p>



                            {/* Refund Invoice download button */}

                            <button

                              onClick={() => generateRefundInvoice(order)}

                              style={{

                                marginTop: '0.75rem',

                                padding: '0.5rem 1rem',

                                backgroundColor: isPartialRefund ? '#ea580c' : '#dc2626',

                                color: 'white',

                                textDecoration: 'none',

                                borderRadius: '6px',

                                fontSize: '0.9rem',

                                fontWeight: '600',

                                display: 'flex',

                                alignItems: 'center',

                                width: 'fit-content',

                                gap: '0.5rem',

                                border: 'none',

                                cursor: 'pointer'

                              }}

                            >

                              Download Refund Invoice

                            </button>

                          </div>

                        )}



                      </React.Fragment>



                    );



                  })



                );



              })()}



            </div>



          </div>



        );



      case 'social-media':

        {

          const comingSoonPlaceholder = (

            <div style={{ width: '100%', aspectRatio: '4 / 5', backgroundColor: '#f1f5f9', borderRadius: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>

              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">

                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />

                <circle cx="8.5" cy="8.5" r="1.5" />

                <polyline points="21 15 16 10 5 21" />

              </svg>

              <span style={{ fontSize: '0.75rem', fontWeight: '700', color: '#94a3b8', letterSpacing: '0.5px' }}>COMING SOON</span>

            </div>

          );



          // Icon: pencil / personalize (Pencil.svg from public)

          const settingsBtn = (assetKey) => (

            <button

              onClick={() => handleOpenCropModal(assetKey)}

              title="Personalize"

              style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}

            >

              <img loading="lazy" src={getCmsImagePath('pencilIcon', '/Pencil.svg')} alt="Personalize" width="16" height="16" style={{ display: 'block' }} />

            </button>

          );



          // Icon: download / page (same as reference image)

          const downloadCircleBtn = (fileSrc, fileName, isVideo, disabled) => (

            <button

              disabled={disabled}

              onClick={async () => {

                if (disabled) return;

                const personalized = personalizedAssets[fileName];

                const src = personalized || fileSrc;

                if (!src) return;



                // Track download (fire-and-forget)

                try { api.trackToolkitDownload(fileName || 'unknown'); } catch (_) { }



                // Server URLs and Canvas JPEGs are both JPEG; only PNGs start with data:image/png

                const isPng = typeof src === 'string' && src.startsWith('data:image/png');

                const ext = isVideo ? 'mp4' : (isPng ? 'png' : 'jpg');

                const mimeType = isVideo ? 'video/mp4' : (isPng ? 'image/png' : 'image/jpeg');

                const cleanName = (fileName || 'oc-mena').replace(/\s+/g, '_');



                try {

                  // Fetch as blob and use Web Share API (opens "Save to Photos" on mobile)

                  const response = await fetch(src);

                  const blob = await response.blob();

                  const file = new File([blob], `${cleanName}.${ext}`, { type: mimeType });



                  if (navigator.canShare && navigator.canShare({ files: [file] })) {

                    await navigator.share({ files: [file] });

                    return;

                  }



                  // Fallback: create object URL from blob for reliable cross-origin download

                  const blobUrl = URL.createObjectURL(blob);

                  const link = document.createElement('a');

                  link.href = blobUrl;

                  link.download = `${cleanName}.${ext}`;

                  link.click();

                  setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);

                  return;

                } catch (e) {

                  // User dismissed the share sheet — don't trigger fallback download

                  if (e.name === 'AbortError') return;

                  // Only fall through for actual errors (e.g. fetch failure)

                }



                // Last resort fallback: direct link (may not trigger download for cross-origin)

                const link = document.createElement('a');

                link.href = src;

                link.download = `${cleanName}.${ext}`;

                link.click();

              }}

              title="Download"

              style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1px solid #d1d5db', background: disabled ? '#f3f4f6' : '#fff', cursor: disabled ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: disabled ? 0.4 : 1 }}

            >

              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">

                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="12" y1="18" x2="12" y2="12" /><polyline points="9 15 12 18 15 15" />

              </svg>

            </button>

          );



          // Icon: share (curved arrow matching reference image)

          const shareCircleBtn = (fileSrc, fileName, isVideo, disabled) => (

            <button

              disabled={disabled}

              onClick={async () => {

                if (disabled) return;

                const shareText = 'Check out the OC MENA Festival!';

                const shareUrl = 'https://ocmenafestival.com';

                // Try to share the personalized asset (server image) or fall back to template

                const personalized = personalizedAssets[fileName];

                const shareSrc = personalized || fileSrc;

                if (shareSrc && navigator.canShare) {

                  try {

                    const response = await fetch(shareSrc);

                    const blob = await response.blob();

                    const isPng = typeof shareSrc === 'string' && shareSrc.startsWith('data:image/png');

                    const ext = isVideo ? 'mp4' : (isPng ? 'png' : 'jpg');

                    const mimeType = isVideo ? 'video/mp4' : (isPng ? 'image/png' : 'image/jpeg');

                    const file = new File([blob], `${(fileName || 'oc-mena').replace(/\s+/g, '_')}.${ext}`, { type: mimeType });

                    if (navigator.canShare({ files: [file] })) {

                      await navigator.share({ title: 'OC MENA Festival', text: shareText, files: [file] });

                      return;

                    }

                  } catch (e) { /* fallback below */ }

                }

                // Fallback: share URL

                if (navigator.share) {

                  navigator.share({ title: 'OC MENA Festival', text: shareText, url: shareUrl }).catch(() => { });

                } else {

                  const encodedText = encodeURIComponent(shareText + ' ' + shareUrl);

                  const shareOptions = [

                    { name: 'X (Twitter)', url: `https://twitter.com/intent/tweet?text=${encodedText}` },

                    { name: 'Facebook', url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}` },

                    { name: 'Email', url: `mailto:?subject=${encodeURIComponent('OC MENA Festival')}&body=${encodedText}` },

                  ];

                  const choice = window.prompt(

                    'Share via:\n1. X (Twitter)\n2. Facebook\n3. Email\n\nEnter number (1-3):',

                    '1'

                  );

                  if (choice === '1') window.open(shareOptions[0].url, '_blank');

                  else if (choice === '2') window.open(shareOptions[1].url, '_blank');

                  else if (choice === '3') window.location.href = shareOptions[2].url;

                }

              }}

              title="Share"

              style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1px solid #d1d5db', background: disabled ? '#f3f4f6' : '#fff', cursor: disabled ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: disabled ? 0.4 : 1 }}

            >

              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">

                <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />

              </svg>

            </button>

          );



          const toolkitAssetCard = (options = {}) => {

            const { assetKey, label, imgSrc, isVideo, hasSettings, isComingSoon, settingsOverride, canReset, aspectRatio = '4 / 5', disableActionsOverride = false } = options;

            const personalized = personalizedAssets[assetKey];

            const resolvedImgSrc = personalized || imgSrc;

            const isEditableAsset = assetKey === 'personalized-flag' || assetKey === 'personalized-flag-dark' || assetKey === 'personalized-flag-light' || assetKey === 'vendor-post';

            const hasBeenEdited = !!personalized;

            const disableActions = disableActionsOverride || (isEditableAsset && !hasBeenEdited);

            return (

              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>

                {isComingSoon ? (

                  comingSoonPlaceholder

                ) : personalized ? (

                  <div style={{ width: '100%', aspectRatio, borderRadius: '10px', overflow: 'hidden', position: 'relative' }}>

                    <img loading="lazy" src={personalized} alt={label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { if (imgSrc && e.target.src !== imgSrc) e.target.src = imgSrc; }} />

                  </div>

                ) : imgSrc ? (

                  isVideo ? (

                    <div style={{ width: '100%', aspectRatio, borderRadius: '10px', overflow: 'hidden', position: 'relative', backgroundColor: '#000' }}>

                      {activeVideoKey === assetKey ? (

                        <video

                          src={imgSrc}

                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}

                          autoPlay

                          playsInline

                          controls

                          onEnded={() => setActiveVideoKey(null)}

                          onError={() => setActiveVideoKey(null)}

                        />

                      ) : (

                        <button

                          type="button"

                          aria-label={`Play ${label}`}

                          onClick={() => setActiveVideoKey(assetKey)}

                          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', padding: 0, margin: 0, border: 'none', background: 'none', cursor: 'pointer', zIndex: 1, WebkitTapHighlightColor: 'transparent', WebkitAppearance: 'none', display: 'block' }}

                        >

                          <img

                            loading="lazy"

                            src={getCmsImagePath('officialFestivalPost', '/Official Festival Posts/OCMENA-Festival.webp')}

                            alt={label}

                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}

                          />

                          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>

                            <div style={{ width: '54px', height: '54px', borderRadius: '50%', backgroundColor: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                              <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff"><polygon points="5 3 19 12 5 21 5 3" /></svg>

                            </div>

                          </div>

                        </button>

                      )}

                    </div>

                  ) : (

                    <div style={{ width: '100%', aspectRatio, borderRadius: '10px', overflow: 'hidden', position: 'relative' }}>

                      <img loading="lazy" src={imgSrc} alt={label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />

                    </div>

                  )

                ) : comingSoonPlaceholder}

                <p style={{ margin: 0, fontSize: '0.82rem', fontWeight: '600', color: '#1f2937', textAlign: 'center' }}>{label}</p>

                <div style={{ display: 'flex', gap: '0.4rem', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' }}>

                  {hasSettings && (settingsOverride ? (

                    <button

                      onClick={settingsOverride}

                      title="Personalize"

                      style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}

                    >

                      <img loading="lazy" src={getCmsImagePath('pencilIcon', '/Pencil.svg')} alt="Personalize" width="16" height="16" style={{ display: 'block' }} />

                    </button>

                  ) : settingsBtn(assetKey))}

                  {canReset && personalized && (

                    <button

                      onClick={async () => {

                        setPersonalizedAssets(prev => {

                          const next = { ...prev };

                          delete next[assetKey];

                          return next;

                        });

                        try {

                          if (assetKey === 'personalized-flag' && flagPostStorageKey) {

                            localStorage.removeItem(flagPostStorageKey);

                          }

                          if (assetKey === 'personalized-flag-dark' && flagPostDarkStorageKey) {

                            localStorage.removeItem(flagPostDarkStorageKey);

                          }

                          if (assetKey === 'personalized-flag-light' && flagPostLightStorageKey) {

                            localStorage.removeItem(flagPostLightStorageKey);

                          }

                          if (assetKey === 'vendor-post' && vendorPostStorageKey) {

                            localStorage.removeItem(vendorPostStorageKey);

                          }

                        } catch (_) { }

                        try {

                          await api.deleteToolkitImage(assetKey);

                        } catch (_) { }

                      }}

                      title="Reset to default"

                      style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}

                    >

                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">

                        <polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 105.64-11.36L1 10" />

                      </svg>

                    </button>

                  )}

                  {downloadCircleBtn(disableActions ? null : resolvedImgSrc, assetKey || label, isVideo, disableActions)}

                  {shareCircleBtn(disableActions ? null : resolvedImgSrc, assetKey || label, isVideo, disableActions)}

                </div>

              </div>

            );

          };



          return (

            <div className="content-section">

              <h2 className="section-title">Social Media Toolkit</h2>

              <p className="section-subtitle">Add your social media accounts and download shareable assets below. Your handles will remain private and will not be displayed publicly. If you post online, make sure to tag @ocmenafestival! </p>



              {/* Social media link inputs */}

              <div className="static-content" style={{ padding: '1.5rem', backgroundColor: '#f9fafb', borderRadius: '12px', marginBottom: '2rem' }}>

                <div style={{ marginBottom: '1.25rem' }}>

                  <label style={{ display: 'flex', alignItems: 'center', fontSize: '0.85rem', fontWeight: '600', color: '#333', marginBottom: '6px', gap: '8px' }}>

                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><defs><linearGradient id="ig" x1="0" y1="24" x2="24" y2="0"><stop offset="0%" stopColor="#FFDC80" /><stop offset="25%" stopColor="#F77737" /><stop offset="50%" stopColor="#F56040" /><stop offset="75%" stopColor="#C13584" /><stop offset="100%" stopColor="#833AB4" /></linearGradient></defs><rect x="2" y="2" width="20" height="20" rx="5" stroke="url(#ig)" strokeWidth="2" fill="none" /><circle cx="12" cy="12" r="5" stroke="url(#ig)" strokeWidth="2" fill="none" /><circle cx="17.5" cy="6.5" r="1.5" fill="url(#ig)" /></svg>

                    Instagram

                  </label>

                  <input type="text" placeholder="@username or URL" value={socialMedia.instagram} onChange={(e) => setSocialMedia(prev => ({ ...prev, instagram: e.target.value }))} style={{ width: '100%', padding: '10px 14px', fontSize: '0.95rem', border: '1px solid #d1d5db', borderRadius: '8px', backgroundColor: '#fff', color: '#1a1a1a', boxSizing: 'border-box' }} />

                </div>

                <div style={{ marginBottom: '1.25rem' }}>

                  <label style={{ display: 'flex', alignItems: 'center', fontSize: '0.85rem', fontWeight: '600', color: '#333', marginBottom: '6px', gap: '8px' }}>

                    <svg width="18" height="18" viewBox="0 0 24 24" fill="#000000"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.75a8.18 8.18 0 004.76 1.52V6.84a4.84 4.84 0 01-1-.15z" /></svg>

                    TikTok

                  </label>

                  <input type="text" placeholder="@username or URL" value={socialMedia.tiktok} onChange={(e) => setSocialMedia(prev => ({ ...prev, tiktok: e.target.value }))} style={{ width: '100%', padding: '10px 14px', fontSize: '0.95rem', border: '1px solid #d1d5db', borderRadius: '8px', backgroundColor: '#fff', color: '#1a1a1a', boxSizing: 'border-box' }} />

                </div>

                <div style={{ marginBottom: '1.25rem' }}>

                  <label style={{ display: 'flex', alignItems: 'center', fontSize: '0.85rem', fontWeight: '600', color: '#333', marginBottom: '6px', gap: '8px' }}>

                    <svg width="18" height="18" viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>

                    Facebook

                  </label>

                  <input type="text" placeholder="@username or URL" value={socialMedia.facebook} onChange={(e) => setSocialMedia(prev => ({ ...prev, facebook: e.target.value }))} style={{ width: '100%', padding: '10px 14px', fontSize: '0.95rem', border: '1px solid #d1d5db', borderRadius: '8px', backgroundColor: '#fff', color: '#1a1a1a', boxSizing: 'border-box' }} />

                </div>

                {socialMediaMsg.text && (

                  <div style={{ padding: '10px', backgroundColor: socialMediaMsg.type === 'success' ? '#dcfce7' : '#fee2e2', color: socialMediaMsg.type === 'success' ? '#166534' : '#991b1b', borderRadius: '8px', marginBottom: '12px', fontSize: '0.9rem', fontWeight: '600' }}>

                    {socialMediaMsg.text}

                  </div>

                )}

                <div className="save-social-media-wrap">

                  <button onClick={handleSaveSocialMedia} disabled={socialMediaSaving} style={{ padding: '0.6rem 1.5rem', backgroundColor: socialMediaSaving ? '#9ca3af' : '#D42533', color: '#fff', border: 'none', borderRadius: '8px', cursor: socialMediaSaving ? 'not-allowed' : 'pointer', fontSize: '0.95rem', fontWeight: '600' }}>

                    {socialMediaSaving ? 'Saving...' : 'Save Social Media'}

                  </button>

                </div>

              </div>



              {/* ═══ Social Media Customization Instructions ═══ */}

              <h2 className="section-title" style={{ textAlign: 'center', margin: '1.5rem 0 1.75rem' }}>Social Media Customization Instructions</h2>

              <div className="toolkit-grid" style={{ display: 'grid', gap: '1.25rem', marginBottom: '2.5rem' }}>

                {[

                  { file: 'Step 1.webp', title: 'Step 1', desc: 'Click the pencil icon' },

                  { file: 'Step 2.webp', title: 'Step 2', desc: 'Upload and crop image' },

                  { file: 'Step 3.webp', title: 'Step 3', desc: 'Click the download icon' }

                ].map((step) => (

                  <div key={step.file}>

                    <p style={{ fontSize: '1.4rem', fontWeight: '700', color: 'rgb(31, 41, 55)', marginBottom: '0.5rem', textAlign: 'center' }}>{step.title}</p>

                    <p style={{ fontSize: '1.2rem', color: 'rgb(31, 41, 55)', marginBottom: '0.75rem', textAlign: 'center' }}>{step.desc}</p>

                    <div style={{ borderRadius: '12px', overflow: 'hidden' }}>

                      <img loading="lazy" src={`/${step.file}`} alt={step.title} style={{ width: '100%', display: 'block' }} />

                    </div>

                  </div>

                ))}

              </div>



              {/* ═══ Social Media Assets ═══ */}

              <h2 className="section-title" style={{ textAlign: 'center', margin: '1.5rem 0 1.75rem' }}>Social Media Toolkit</h2>



              {/* Section 1: Personalized Social Posts */}

              <h3 style={{ fontSize: '1.05rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem', borderBottom: '1px solid #e5e7eb', paddingBottom: '0.5rem' }}>Personalized Social Posts</h3>

              <div className="toolkit-grid" style={{ display: 'grid', gap: '1.25rem', marginBottom: '2.5rem' }}>

                {toolkitAssetCard({ assetKey: 'personalized-flag-dark', label: 'MENA Roots Frame (Dark)', imgSrc: FLAG_POST_THEMES.dark.exampleSrc, hasSettings: true, settingsOverride: () => handleOpenFlagModal('dark'), canReset: true })}

                {toolkitAssetCard({ assetKey: 'personalized-flag-light', label: 'MENA Roots Frame (Light)', imgSrc: FLAG_POST_THEMES.light.exampleSrc, hasSettings: true, settingsOverride: () => handleOpenFlagModal('light'), canReset: true })}

                {isVendor && vendorIsApproved && toolkitAssetCard({ assetKey: 'vendor-post', label: 'Vendor Post', imgSrc: personalizedAssets['vendor-base'] || getCmsImagePath('vendorInitialLoad', '/ocmena-vendor-inital-load.webp'), hasSettings: true, canReset: true })}

                {toolkitAssetCard({ assetKey: 'im-attending', label: "I'm Attending Post", imgSrc: personalizedAssets['im-attending'] || getCmsImagePath('attendingPost', '/OCMENA-Attending-Post.webp') })}

              </div>



              {/* Section 2: Personalized Social Posts (Story Versions) */}

              <h3 style={{ fontSize: '1.05rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem', borderBottom: '1px solid #e5e7eb', paddingBottom: '0.5rem' }}>Personalized Social Posts (Story Versions)</h3>

              <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '2.5rem' }}>

                <div style={{ width: '100%', maxWidth: 280 }}>

                  {toolkitAssetCard({ assetKey: MENA_ROOTS_HELPER_STORY_ASSET_KEY, label: 'MENA Roots Helper Story Post (1080x1920)', imgSrc: MENA_ROOTS_HELPER_STORY_INSTRUCTIONS_SRC, aspectRatio: '9 / 16', disableActionsOverride: !personalizedAssets[MENA_ROOTS_HELPER_STORY_ASSET_KEY] })}

                </div>

              </div>



              {/* Section 3: Coupon & Promotion Posts */}

              <h3 style={{ fontSize: '1.05rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem', borderBottom: '1px solid #e5e7eb', paddingBottom: '0.5rem' }}>Coupon & Promotion Posts</h3>

              <div className="toolkit-grid" style={{ display: 'grid', gap: '1.25rem', marginBottom: '2.5rem' }}>

                {toolkitAssetCard({ assetKey: 'coupon-a', label: 'Coupon Post A', imgSrc: getCmsImagePath('couponPostA', '/Coupon & Promotion Posts/OCMENA-Coupon-A.webp') })}

                {toolkitAssetCard({ assetKey: 'coupon-b', label: 'Coupon Post B', imgSrc: getCmsImagePath('couponPostB', '/Coupon & Promotion Posts/OCMENA-Coupon-B.webp') })}

              </div>

              {/* Section 3: Official Festival Posts */}

              <h3 style={{ fontSize: '1.05rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem', borderBottom: '1px solid #e5e7eb', paddingBottom: '0.5rem' }}>Official Festival Posts</h3>

              <div className="toolkit-grid" style={{ display: 'grid', gap: '1.25rem', marginBottom: '2rem' }}>

                {toolkitAssetCard({ assetKey: 'flyer-post', label: 'OC MENA Flyer Post', imgSrc: getCmsImagePath('officialFestivalPost', '/Official Festival Posts/OCMENA-Festival.webp') })}

                {toolkitAssetCard({ assetKey: 'dystinct-post', label: 'OC MENA: Dystinct Post', imgSrc: getCmsImagePath('officialDystinctPost', '/Official Festival Posts/OCMENA-Dystinct.webp') })}

                {toolkitAssetCard({ assetKey: 'oc-video', label: 'OC MENA Video Post', imgSrc: getCmsImagePath('officialVideoPost', '/Official Festival Posts/OCMENA-Video.mp4'), isVideo: true })}

              </div>



              {/* ═══ Personalize Modal with ReactCrop ═══ */}

              {cropModal.open && typeof document !== 'undefined' && createPortal(

                <div

                  style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem', overflowY: 'auto' }}

                  onClick={() => { setCropModal({ open: false, assetKey: null }); setCropImgSrc(null); setCropSelection(null); setCropRef(null); setCroppedResult(null); setCroppedResultAspect(1); }}

                >

                  <div

                    style={{ background: '#fff', borderRadius: '16px', padding: '1.5rem', maxWidth: '600px', width: '100%', position: 'relative', marginTop: '1rem', marginBottom: '2rem', zIndex: 999999 }}

                    onClick={(e) => e.stopPropagation()}

                  >

                    <button

                      onClick={() => { setCropModal({ open: false, assetKey: null }); setCropImgSrc(null); setCropSelection(null); setCropRef(null); setCroppedResult(null); setCroppedResultAspect(1); }}

                      style={{ position: 'absolute', top: '0.75rem', right: '0.75rem', background: '#f1f5f9', border: 'none', cursor: 'pointer', width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', color: '#475569', lineHeight: 1, zIndex: 1 }}

                    >{'\u00D7'}</button>

                    <h3 style={{ margin: '0 0 0.35rem', fontSize: '1.1rem', fontWeight: '700', color: '#1f2937', paddingRight: '2rem' }}>Personalize Your Post</h3>

                    <p style={{ margin: '0 0 1.25rem', fontSize: '0.85rem', color: '#6b7280' }}>Upload your logo, adjust the crop if needed, then click "Crop" to preview it on the poster.</p>



                    {!cropImgSrc ? (

                      <div style={{ border: '2px dashed #d1d5db', borderRadius: '12px', padding: '2rem', textAlign: 'center' }}>

                        <label style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem' }}>

                          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>

                          <span style={{ fontSize: '0.9rem', fontWeight: '600', color: '#374151' }}>Click to upload your logo</span>

                          <span style={{ fontSize: '0.78rem', color: '#9ca3af' }}>PNG, JPG, or WEBP</span>

                          <input type="file" accept="image/*" onChange={handleCropFileSelect} style={{ display: 'none' }} />

                        </label>

                      </div>

                    ) : !croppedResult ? (

                      <div>

                        {/* Step 1: Crop area - selection pre-selected like MS Paint */}

                        <p style={{ margin: '0 0 0.5rem', fontSize: '0.82rem', fontWeight: '600', color: '#374151' }}>Drag the handles to crop your logo:</p>

                        <div style={{ marginBottom: '1rem', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>

                          <ReactCrop crop={cropSelection} onChange={(_, percentCrop) => setCropSelection(percentCrop)}>

                            <img loading="lazy" src={cropImgSrc} alt="Crop preview" onLoad={(e) => setCropRef(e.currentTarget)} style={{ maxWidth: '100%', display: 'block' }} />

                          </ReactCrop>

                        </div>



                        <div style={{ display: 'flex', gap: '0.75rem' }}>

                          <label style={{ flex: 1, padding: '0.6rem', border: '1px solid #d1d5db', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '600', color: '#374151', textAlign: 'center' }}>

                            Change Image

                            <input type="file" accept="image/*" onChange={handleCropFileSelect} style={{ display: 'none' }} />

                          </label>

                          <button onClick={handleCropApply} style={{ flex: 1, padding: '0.6rem', background: '#2563eb', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '700' }}>

                            Crop

                          </button>

                        </div>

                      </div>

                    ) : (

                      <div>

                        {/* Step 2: Preview cropped logo on poster */}

                        <p style={{ margin: '0 0 0.5rem', fontSize: '0.82rem', fontWeight: '600', color: '#374151' }}>Preview on poster:</p>

                        <div style={{ position: 'relative', width: '100%', aspectRatio: '4/5', borderRadius: '10px', overflow: 'hidden', marginBottom: '1rem', border: '1px solid #e2e8f0' }}>

                          <img loading="lazy" src={personalizedAssets['vendor-output-base'] || getCmsImagePath('vendorOutputPost', '/Personalized Social Posts/ocmena-vendor-output.webp')} alt="Base poster" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />

                          <div style={{ position: 'absolute', top: `${(vendorLogoLayout.centerYPct - (vendorLogoLayout.heightPct / 2)) * 100}%`, left: `${vendorLogoLayout.centerXPct * 100}%`, transform: 'translateX(-50%)', height: `${vendorLogoLayout.heightPct * 100}%`, aspectRatio: `${croppedResultAspect || 1}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                            <img loading="lazy" src={croppedResult} alt="Your logo" style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />

                          </div>

                        </div>







                        <div style={{ display: 'flex', gap: '0.75rem' }}>

                          <button onClick={() => { setCroppedResult(null); setCroppedResultAspect(1); setVendorLogoLayout({ ...SOCIAL_TOOLKIT_VENDOR_LOGO_LAYOUT }); }} style={{ flex: 1, padding: '0.6rem', border: '1px solid #d1d5db', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '600', color: '#374151', textAlign: 'center' }}>

                            Back to Crop

                          </button>

                          <button onClick={handleCropSave} style={{ flex: 1, padding: '0.6rem', background: '#16a34a', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '700' }}>

                            Save & Apply

                          </button>

                        </div>

                      </div>

                    )}

                  </div>

                </div>

                , document.body)}



              {/* ═══ Flag Post Personalize Modal (v2 themes) ═══ */}

              {flagModal && typeof document !== 'undefined' && createPortal(

                <div

                  style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem', overflowY: 'auto' }}

                  onClick={() => setFlagModal(false)}

                >

                  <div

                    style={{ background: '#fff', borderRadius: '16px', padding: '1.5rem', maxWidth: '600px', width: '100%', position: 'relative', marginTop: '1rem', marginBottom: '2rem', zIndex: 999999, maxHeight: '90vh', overflowY: 'auto' }}

                    onClick={(e) => e.stopPropagation()}

                  >

                    <button

                      onClick={() => setFlagModal(false)}

                      style={{ position: 'absolute', top: '0.75rem', right: '0.75rem', background: '#f1f5f9', border: 'none', cursor: 'pointer', width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', color: '#475569', lineHeight: 1, zIndex: 1 }}

                    >{'\u00D7'}</button>

                    <h3 style={{ margin: '0 0 0.35rem', fontSize: '1.1rem', fontWeight: '700', color: '#1f2937', paddingRight: '2rem' }}>Personalize Flag Post ({(FLAG_POST_THEMES[flagPostTheme] || FLAG_POST_THEMES.dark).label})</h3>

                    <p style={{ margin: '0 0 1rem', fontSize: '0.85rem', color: '#6b7280' }}>Select your country, upload your photo, crop it (square), then save.</p>



                    {/* Country dropdown */}

                    <div style={{ marginBottom: '1rem' }}>

                      <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>Select Country</label>

                      <select

                        value={flagCountry}

                        onChange={(e) => setFlagCountry(e.target.value)}

                        style={{ width: '100%', padding: '10px 14px', fontSize: '0.95rem', border: '1px solid #d1d5db', borderRadius: '8px', backgroundColor: '#fff', color: '#1a1a1a', boxSizing: 'border-box' }}

                      >

                        {[...FLAG_POST_COUNTRIES['North Africa'], ...FLAG_POST_COUNTRIES['Middle East']].sort().map(c => <option key={c} value={c}>{c}</option>)}

                      </select>

                    </div>



                    {!flagPhotoSrc ? (

                      <div style={{ border: '2px dashed #d1d5db', borderRadius: '12px', padding: '2rem', textAlign: 'center' }}>

                        <label style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem' }}>

                          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>

                          <span style={{ fontSize: '0.9rem', fontWeight: '600', color: '#374151' }}>Click to upload your photo</span>

                          <span style={{ fontSize: '0.78rem', color: '#9ca3af' }}>PNG, JPG, or WEBP (square crop)</span>

                          <input type="file" accept="image/*" onChange={handleFlagPhotoSelect} style={{ display: 'none' }} />

                        </label>

                      </div>

                    ) : !flagCroppedPhoto ? (

                      <div>

                        <p style={{ margin: '0 0 0.5rem', fontSize: '0.82rem', fontWeight: '600', color: '#374151' }}>Drag the handles to crop your photo (square):</p>

                        <div style={{ marginBottom: '1rem', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>

                          <ReactCrop crop={flagCropSelection} onChange={(_, percentCrop) => setFlagCropSelection(percentCrop)} aspect={1}>

                            <img loading="lazy" src={flagPhotoSrc} alt="Crop preview" onLoad={handleFlagImgLoad} style={{ maxWidth: '100%', display: 'block' }} />

                          </ReactCrop>

                        </div>

                        <div style={{ display: 'flex', gap: '0.75rem' }}>

                          <label style={{ flex: 1, padding: '0.6rem', border: '1px solid #d1d5db', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '600', color: '#374151', textAlign: 'center' }}>

                            Change Image

                            <input type="file" accept="image/*" onChange={handleFlagPhotoSelect} style={{ display: 'none' }} />

                          </label>

                          <button onClick={handleFlagCropApply} style={{ flex: 1, padding: '0.6rem', background: '#2563eb', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '700' }}>

                            Crop

                          </button>

                        </div>

                      </div>

                    ) : (

                      <div>

                        <p style={{ margin: '0 0 0.5rem', fontSize: '0.82rem', fontWeight: '600', color: '#374151' }}>Preview ({flagCountry} - {(FLAG_POST_THEMES[flagPostTheme] || FLAG_POST_THEMES.dark).label}):</p>

                        <div style={{ position: 'relative', width: '100%', aspectRatio: '4/5', borderRadius: '10px', overflow: 'hidden', marginBottom: '1rem', border: '1px solid #e2e8f0', backgroundColor: flagPostTheme === 'light' ? '#fff' : '#000' }}>

                          {flagPreviewUrl ? (

                            <img loading="lazy" src={flagPreviewUrl} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />

                          ) : (

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#9ca3af', fontSize: '0.9rem' }}>Generating preview...</div>

                          )}

                        </div>



                        <div style={{ display: 'flex', gap: '0.75rem' }}>

                          <button onClick={() => { setFlagCroppedPhoto(null); setFlagPreviewUrl(null); }} style={{ flex: 1, padding: '0.6rem', border: '1px solid #d1d5db', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '600', color: '#374151', textAlign: 'center' }}>

                            Back to Crop

                          </button>

                          <button onClick={handleFlagPostSave} style={{ flex: 1, padding: '0.6rem', background: '#16a34a', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '700' }}>

                            Save & Apply

                          </button>

                        </div>

                      </div>

                    )}

                  </div>

                </div>

                , document.body)}



            </div>

          );

        }



      case 'downloads':



        return (



          <div className="content-section">



            <h2 className="section-title">Downloads</h2>



            <div className="static-content">



              <p>Festival Guide - Coming Soon</p>



              <p>Vendor Handbook - Coming Soon</p>



              <p>Map & Schedule - Coming Soon</p>



            </div>



          </div>



        );



      case 'addresses':



        return (



          <div className="content-section">



            <h2 className="section-title">Addresses</h2>



            <div className="static-content">



              <p>Address management coming soon.</p>



            </div>



          </div>



        );



      case 'payment-methods':

        return (

          <div className="content-section">

            <h2 className="section-title">Payment Methods</h2>

            <div className="static-content" style={{ padding: '1.5rem', backgroundColor: '#f9fafb', borderRadius: '12px' }}>

              {savedCardLoading ? (

                <div style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>Loading card info...</div>

              ) : savedCard ? (

                <div>

                  {/* Card display */}

                  <div style={{

                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',

                    padding: '1.25rem', backgroundColor: '#fff', borderRadius: '12px',

                    border: savedCard.is_expired ? '2px solid #fca5a5' : '1px solid #e5e7eb',

                  }}>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>

                      <div style={{

                        width: '48px', height: '32px', borderRadius: '6px',

                        backgroundColor: '#f3f4f6', display: 'flex', alignItems: 'center',

                        justifyContent: 'center', fontSize: '0.7rem', fontWeight: 700,

                        color: '#374151', textTransform: 'uppercase',

                      }}>

                        {savedCard.brand || 'CARD'}

                      </div>

                      <div>

                        <div style={{ fontSize: '1rem', fontWeight: 600, color: '#111' }}>

                          {(savedCard.brand || 'Card').charAt(0).toUpperCase() + (savedCard.brand || 'Card').slice(1)} ending in {savedCard.last4}

                        </div>

                        <div style={{ fontSize: '0.85rem', color: savedCard.is_expired ? '#dc2626' : '#6b7280', marginTop: '2px' }}>

                          {savedCard.is_expired

                            ? `Expired ${String(savedCard.exp_month).padStart(2, '0')}/${savedCard.exp_year}`

                            : `Expires ${String(savedCard.exp_month).padStart(2, '0')}/${savedCard.exp_year}`}

                        </div>

                      </div>

                    </div>

                    {savedCard.is_expired && (

                      <span style={{

                        padding: '0.25rem 0.75rem', borderRadius: '12px', fontSize: '0.75rem',

                        fontWeight: 600, backgroundColor: '#fef2f2', color: '#dc2626',

                      }}>Expired</span>

                    )}

                  </div>



                  {savedCard.is_expired && (

                    <div style={{

                      marginTop: '0.75rem', padding: '0.75rem 1rem', borderRadius: '8px',

                      backgroundColor: '#fef2f2', border: '1px solid #fecaca', fontSize: '0.85rem', color: '#991b1b',

                    }}>

                      Your card has expired. Remove it and your next purchase through Stripe will save your new card automatically.

                    </div>

                  )}



                  {/* Action buttons */}

                  <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.25rem' }}>

                    <button

                      onClick={handleRemoveCard}

                      disabled={savedCardAction === 'removing'}

                      style={{

                        padding: '0.6rem 1.5rem', borderRadius: '8px', border: '1px solid #dc2626',

                        backgroundColor: '#fff', color: '#dc2626', fontSize: '0.9rem', fontWeight: 600,

                        cursor: savedCardAction === 'removing' ? 'not-allowed' : 'pointer', opacity: savedCardAction === 'removing' ? 0.6 : 1,

                      }}

                    >

                      {savedCardAction === 'removing' ? 'Removing...' : 'Remove Card'}

                    </button>

                  </div>

                </div>

              ) : (

                <div>

                  <div style={{ textAlign: 'center', padding: '2rem' }}>

                    <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>

                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ margin: '0 auto' }}>

                        <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />

                      </svg>

                    </div>

                    <p style={{ fontSize: '1rem', fontWeight: 600, color: '#374151', marginBottom: '0.5rem' }}>No card on file</p>

                    <p style={{ fontSize: '0.85rem', color: '#6b7280', marginBottom: '0' }}>

                      Your card will be saved automatically during your next checkout through Stripe.

                    </p>

                  </div>

                </div>

              )}



              <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: '#f0f9ff', borderRadius: '8px', border: '1px solid #bae6fd', textAlign: 'center' }}>

                <p style={{ fontSize: '0.8rem', color: '#0c4a6e', margin: 0 }}>

                  Your credit card details are securely stored with our payment provider (Stripe, Inc.) and not on our servers. Stripe is a PCI-compliant company that uses secure encryption.

                  {savedCard && ' Your saved card can be used for faster checkout on future purchases.'}

                </p>

              </div>

            </div>

          </div>

        );



      case 'account-details':



        return (



          <div className="content-section">



            <h2 className="section-title">Account details</h2>



            <div className="static-content" style={{ padding: '1.5rem', backgroundColor: '#f9fafb', borderRadius: '12px' }}>



              <div style={{ marginBottom: '1rem' }}>



                <div style={{ fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase', marginBottom: '0.25rem' }}>Full Name</div>



                <div style={{ fontSize: '1rem', fontWeight: '600', color: '#111' }}>{userProfile?.full_name || user?.full_name || 'Not set'}</div>



              </div>



              <div style={{ marginBottom: '1rem' }}>



                <div style={{ fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase', marginBottom: '0.25rem' }}>Email</div>



                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>

                  <input

                    type="email"

                    value={emailDraft}

                    onChange={(e) => {

                      setEmailDraft(e.target.value);

                      if (emailMessage.text) {

                        setEmailMessage({ type: '', text: '' });

                      }

                    }}

                    placeholder="Enter new email"

                    style={{

                      flex: '1 1 260px',

                      minWidth: '220px',

                      padding: '0.55rem 0.7rem',

                      border: '1px solid #d1d5db',

                      borderRadius: '8px',

                      fontSize: '0.95rem',

                      color: '#111',

                      backgroundColor: '#fff'

                    }}

                  />

                  <button

                    onClick={handleEmailUpdate}

                    disabled={emailSaving}

                    style={{

                      padding: '0.55rem 0.9rem',

                      border: 'none',

                      borderRadius: '8px',

                      backgroundColor: emailSaving ? '#9ca3af' : '#2563eb',

                      color: '#fff',

                      cursor: emailSaving ? 'not-allowed' : 'pointer',

                      fontSize: '0.85rem',

                      fontWeight: '600'

                    }}

                  >

                    {emailSaving ? 'Saving...' : 'Update Email'}

                  </button>

                </div>

                {emailMessage.text && (

                  <div style={{

                    marginTop: '0.5rem',

                    fontSize: '0.85rem',

                    color: emailMessage.type === 'success' ? '#166534' : '#b91c1c'

                  }}>

                    {emailMessage.text}

                  </div>

                )}



              </div>



              <div style={{ marginBottom: '1rem' }}>



                <div style={{ fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase', marginBottom: '0.25rem' }}>Phone</div>



                <div style={{ fontSize: '1rem', fontWeight: '600', color: '#111' }}>{userProfile?.phone || user?.phone || 'Not set'}</div>



              </div>



              <div style={{ marginBottom: '1rem' }}>



                <div style={{ fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase', marginBottom: '0.25rem' }}>Role</div>



                <div style={{ fontSize: '1rem', fontWeight: '600', color: '#111', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>



                  {(() => {

                    const baseRole = userProfile?.role || user?.role || 'ATTENDEE';

                    const hasVendorOrder = isNewFlowVendor || isVendor;

                    const hasRegularTickets = (tickets.amphitheater_tickets?.length > 0) || (tickets.festival_tickets?.length > 0);

                    const roles = [];

                    if (baseRole === 'ADMIN') {

                      roles.push({ label: 'ADMIN', bg: '#fef2f2', color: '#dc2626' });

                    } else {

                      if (hasRegularTickets || !hasVendorOrder) {

                        roles.push({ label: 'ATTENDEE', bg: '#e0f2fe', color: '#0369a1' });

                      }

                      if (hasVendorOrder) {

                        roles.push({ label: 'VENDOR', bg: '#fef3c7', color: '#d97706' });

                      }

                    }

                    if (roles.length === 0) roles.push({ label: 'ATTENDEE', bg: '#e0f2fe', color: '#0369a1' });

                    return roles.map((r, i) => (

                      <span key={i} style={{ padding: '0.25rem 0.75rem', borderRadius: '12px', fontSize: '0.85rem', backgroundColor: r.bg, color: r.color }}>{r.label}</span>

                    ));

                  })()}



                </div>



              </div>



              <div style={{ marginBottom: '1rem' }}>



                <div style={{ fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase', marginBottom: '0.25rem' }}>Account Status</div>



                <div style={{ fontSize: '1rem', fontWeight: '600' }}>



                  <span style={{



                    padding: '0.25rem 0.75rem',



                    borderRadius: '12px',



                    fontSize: '0.85rem',



                    backgroundColor: userProfile?.is_active !== false ? '#dcfce7' : '#fee2e2',



                    color: userProfile?.is_active !== false ? '#166534' : '#991b1b'



                  }}>



                    {userProfile?.is_active !== false ? 'Active' : 'Inactive'}



                  </span>



                </div>



              </div>



              <div>



                <div style={{ fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase', marginBottom: '0.25rem' }}>Member Since</div>



                <div style={{ fontSize: '1rem', fontWeight: '600', color: '#111' }}>



                  {userProfile?.created_at ? new Date(userProfile.created_at).toLocaleDateString('en-US', {



                    year: 'numeric', month: 'long', day: 'numeric'



                  }) : 'N/A'}



                </div>



              </div>



              <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}>

                <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer', userSelect: 'none' }}>

                  <input

                    type="checkbox"

                    checked={userProfile?.sms_consent || false}

                    onChange={async (e) => {

                      const newVal = e.target.checked;

                      try {

                        const response = await api.updateProfile({ sms_consent: newVal });

                        if (response?.success) {

                          setUserProfile(prev => ({ ...prev, sms_consent: newVal }));

                          toast.success(newVal ? 'SMS notifications enabled' : 'SMS notifications disabled');

                        } else {

                          toast.error(response?.error?.message || 'Failed to update SMS preference');

                        }

                      } catch (err) {

                        toast.error('Failed to update SMS preference');

                      }

                    }}

                    style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#2563eb' }}

                  />

                  <div>

                    <div style={{ fontSize: '0.95rem', fontWeight: '600', color: '#111' }}>SMS opt-in</div>

                    <div style={{ fontSize: '0.8rem', color: '#6b7280', marginTop: '2px' }}>

                      {userProfile?.sms_consent ? 'You are currently opted in to SMS notifications.' : 'You are currently opted out of SMS notifications.'}

                    </div>

                  </div>

                </label>

              </div>



              <button



                onClick={loadUserProfile}



                style={{



                  marginTop: '1.5rem',



                  padding: '0.5rem 1rem',



                  backgroundColor: '#3b82f6',



                  color: '#fff',



                  border: 'none',



                  borderRadius: '6px',



                  cursor: 'pointer',



                  fontSize: '0.9rem'



                }}



              >



                🔄 Refresh Profile



              </button>



            </div>



            <div style={{ marginTop: '2rem', padding: '1.5rem', backgroundColor: '#f9fafb', borderRadius: '12px' }}>

              <h3 style={{ fontSize: '1.1rem', fontWeight: '700', marginBottom: '1rem', color: '#111' }}>Change Password</h3>

              {passwordMessage.text && (

                <div style={{

                  padding: '0.75rem 1rem', marginBottom: '1rem', borderRadius: '8px',

                  backgroundColor: passwordMessage.type === 'success' ? '#dcfce7' : '#fee2e2',

                  color: passwordMessage.type === 'success' ? '#166534' : '#991b1b',

                  fontSize: '0.9rem'

                }}>

                  {passwordMessage.text}

                </div>

              )}

              <form onSubmit={async (e) => {

                e.preventDefault();

                setPasswordMessage({ type: '', text: '' });

                if (newPassword !== confirmNewPassword) {

                  setPasswordMessage({ type: 'error', text: 'New passwords do not match' });

                  return;

                }

                setPasswordLoading(true);

                try {

                  const response = await api.changePassword(currentPassword, newPassword);

                  if (response?.success) {

                    setPasswordMessage({ type: 'success', text: 'Password changed successfully!' });

                    setCurrentPassword('');

                    setNewPassword('');

                    setConfirmNewPassword('');

                  } else {

                    setPasswordMessage({ type: 'error', text: response?.error?.message || 'Failed to change password' });

                  }

                } catch (err) {

                  setPasswordMessage({ type: 'error', text: err?.message || 'Failed to change password' });

                }

                setPasswordLoading(false);

              }}>

                <div style={{ marginBottom: '1rem' }}>

                  <label style={{ display: 'block', fontSize: '0.8rem', color: '#374151', marginBottom: '0.35rem', fontWeight: '600' }}>Current Password</label>

                  <input

                    type="password"

                    value={currentPassword}

                    onChange={(e) => setCurrentPassword(e.target.value)}

                    required

                    style={{ width: '100%', padding: '0.6rem 0.75rem', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '0.9rem', boxSizing: 'border-box' }}

                  />

                </div>

                <div style={{ marginBottom: '1rem' }}>

                  <label style={{ display: 'block', fontSize: '0.8rem', color: '#374151', marginBottom: '0.35rem', fontWeight: '600' }}>New Password</label>

                  <input

                    type="password"

                    value={newPassword}

                    onChange={(e) => setNewPassword(e.target.value)}

                    required

                    style={{ width: '100%', padding: '0.6rem 0.75rem', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '0.9rem', boxSizing: 'border-box' }}

                  />

                </div>

                <div style={{ marginBottom: '1.25rem' }}>

                  <label style={{ display: 'block', fontSize: '0.8rem', color: '#374151', marginBottom: '0.35rem', fontWeight: '600' }}>Confirm New Password</label>

                  <input

                    type="password"

                    value={confirmNewPassword}

                    onChange={(e) => setConfirmNewPassword(e.target.value)}

                    required

                    style={{ width: '100%', padding: '0.6rem 0.75rem', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '0.9rem', boxSizing: 'border-box' }}

                  />

                </div>

                <button

                  type="submit"

                  disabled={passwordLoading}

                  style={{

                    padding: '0.6rem 1.5rem', backgroundColor: '#7c3aed', color: '#fff',

                    border: 'none', borderRadius: '8px', cursor: 'pointer',

                    fontWeight: '600', fontSize: '0.9rem', opacity: passwordLoading ? 0.7 : 1

                  }}

                >

                  {passwordLoading ? 'Changing...' : 'Change Password'}

                </button>

              </form>

            </div>



          </div>



        );



      case 'affiliate-program':

        return (

          <div className="content-section">

            <h2 className="section-title">Affiliate Program</h2>

            {affiliateInfo ? (

              <div>

                {/* Affiliate Program Card */}

                <div style={{

                  marginBottom: '1.5rem',

                  padding: '1.25rem',

                  backgroundColor: '#f0fdf4',

                  border: '2px solid #16a34a',

                  borderRadius: '12px'

                }}>

                  <h3 style={{ margin: '0 0 0.75rem', fontSize: '1rem', color: '#166534' }}>🤝 Affiliate Program</h3>

                  <div style={{

                    padding: '0.75rem 1rem',

                    backgroundColor: '#fff',

                    borderRadius: '8px',

                    border: '1px solid #bbf7d0'

                  }}>

                    <p style={{ margin: 0, fontWeight: 600, color: '#1f2937', display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>

                      Your Promo Code: <span style={{ color: '#16a34a', fontSize: '1.1rem' }}>{affiliateInfo.coupon_code}</span>

                      <button

                        title="Copy coupon code"

                        onClick={() => { navigator.clipboard.writeText(affiliateInfo.coupon_code); }}

                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px', display: 'flex', alignItems: 'center' }}

                      >

                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>

                      </button>

                    </p>

                    <p style={{ margin: '0.25rem 0 0', fontSize: '0.85rem', color: '#6b7280' }}>

                      {affiliateInfo.commission_percent}% commission · {(affiliateInfo.discount_percent ?? 10)}% off for customers (any ticket) · {(affiliateInfo.total_orders || 0).toLocaleString()} order(s) · ${Number(affiliateInfo.total_commission || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} earned

                    </p>

                  </div>

                </div>



                {/* Share Your Referral Link */}

                <div style={{

                  marginBottom: '1.5rem', padding: '1.25rem',

                  background: 'linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)',

                  border: '2px solid #16a34a', borderRadius: '12px'

                }}>

                  <h4 style={{ margin: '0 0 0.5rem', fontSize: '0.95rem', color: '#166534' }}>Share Your Referral Link</h4>

                  <p style={{ margin: '0 0 0.75rem', fontSize: '0.82rem', color: '#6b7280' }}>

                    When someone visits this link, your coupon code is automatically applied at checkout.

                  </p>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>

                    <input

                      type="text"

                      readOnly

                      value={getReferralLink()}

                      style={{

                        flex: 1, minWidth: '200px', padding: '0.6rem 0.75rem',

                        border: '1px solid #bbf7d0', borderRadius: '8px',

                        fontSize: '0.85rem', color: '#166534', background: '#fff',

                        outline: 'none', cursor: 'text'

                      }}

                      onClick={(e) => e.target.select()}

                    />

                    <button

                      onClick={copyReferralLink}

                      style={{

                        padding: '0.6rem 1.5rem', fontSize: '0.85rem', fontWeight: 600,

                        background: referralLinkCopied ? '#16a34a' : '#fff',

                        color: referralLinkCopied ? '#fff' : '#16a34a',

                        border: '2px solid #16a34a', borderRadius: '8px',

                        cursor: 'pointer', transition: 'all 0.15s', whiteSpace: 'nowrap',

                        display: 'flex', alignItems: 'center', gap: '0.4rem'

                      }}

                    >

                      {referralLinkCopied ? (

                        <>

                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>

                          Copied!

                        </>

                      ) : (

                        <>

                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>

                          Copy Link

                        </>

                      )}

                    </button>

                  </div>

                </div>



                {/* Status, Coupon, Payout Row */}

                <div className="affiliate-top-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>

                  <div style={{ background: '#f0fdf4', borderRadius: '10px', padding: '1rem', border: '1px solid #bbf7d0' }}>

                    <p style={{ margin: 0, fontSize: '0.8rem', color: '#6b7280' }}>Status</p>

                    <p style={{ margin: '0.25rem 0 0', fontSize: '1.1rem', fontWeight: '700', color: affiliateInfo.is_active ? '#16a34a' : '#991b1b' }}>

                      {affiliateInfo.is_active ? 'ACTIVE' : 'INACTIVE'}

                    </p>

                  </div>

                  <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '1rem', border: '1px solid #e2e8f0' }}>

                    <p style={{ margin: 0, fontSize: '0.8rem', color: '#6b7280' }}>Coupon</p>

                    <p style={{ margin: '0.25rem 0 0', fontSize: '1.1rem', fontWeight: '700', color: '#1f2937', letterSpacing: '1px', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>

                      {affiliateInfo.coupon_code}

                      <button

                        onClick={() => { navigator.clipboard.writeText(affiliateInfo.coupon_code); }}

                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px', display: 'flex', alignItems: 'center' }}

                        title="Copy coupon code"

                      >

                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">

                          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>

                          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>

                        </svg>

                      </button>

                    </p>

                  </div>

                  <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '1rem', border: '1px solid #e2e8f0' }}>

                    <p style={{ margin: 0, fontSize: '0.8rem', color: '#6b7280' }}>Payout</p>

                    <p style={{ margin: '0.25rem 0 0', fontSize: '1.1rem', fontWeight: '700', color: '#1f2937' }}>

                      {(() => {

                        const now = new Date();

                        let nextDate;

                        if (now.getDate() <= 15) {

                          nextDate = new Date(now.getFullYear(), now.getMonth(), 15);

                        } else {

                          nextDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);

                        }

                        if (nextDate <= now) {

                          if (now.getDate() <= 15) {

                            nextDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);

                          } else {

                            nextDate = new Date(now.getFullYear(), now.getMonth() + 1, 15);

                          }

                        }

                        return nextDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

                      })()}

                    </p>

                  </div>

                </div>



                {/* Stats Row */}

                <div className="affiliate-stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>

                  {[

                    { label: 'Orders', value: (affiliateInfo.total_orders || 0).toLocaleString(), green: false },

                    { label: 'Festival Tickets', value: (affiliateInfo.festival_tickets || 0).toLocaleString(), green: false },

                    { label: 'Concert Tickets', value: (affiliateInfo.concert_tickets || 0).toLocaleString(), green: false },

                    { label: 'Commission Earned', value: `$${Number(affiliateInfo.total_commission || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, green: true },

                  ].map((stat, i) => (

                    <div key={i} style={{

                      background: '#fff', borderRadius: '12px', padding: '1.25rem 1rem', textAlign: 'center',

                      boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)',

                      border: '1px solid #f0f0f0'

                    }}>

                      <div style={{

                        backgroundColor: stat.green ? '#f0fdf4' : '#F8F9FA',

                        borderRadius: '8px', padding: '0.75rem 0.5rem', marginBottom: '0.6rem'

                      }}>

                        <p style={{

                          margin: 0, fontSize: '1.8rem', fontWeight: '700',

                          color: stat.green ? '#16a34a' : '#1f2937'

                        }}>{stat.value}</p>

                      </div>

                      <p style={{ margin: 0, fontSize: '0.85rem', fontWeight: '600', color: '#374151' }}>{stat.label}</p>

                    </div>

                  ))}

                </div>



                {/* Commission by Period */}

                {(() => {

                  const orders = affiliateInfo.orders || [];

                  if (orders.length === 0) return null;

                  // Group by payout_date

                  const periodMap = {};

                  orders.forEach(o => {

                    const pd = o.payout_date || 'Unknown';

                    if (!periodMap[pd]) periodMap[pd] = { commission: 0, count: 0, paid: null };

                    periodMap[pd].commission += (o.commission_cents || 0);

                    periodMap[pd].count += 1;

                    // If any order in the period has date_paid, mark period as paid

                    if (o.date_paid && !periodMap[pd].paid) periodMap[pd].paid = o.date_paid;

                  });

                  const periods = Object.entries(periodMap).sort((a, b) => a[0].localeCompare(b[0]));

                  if (periods.length <= 1) return null;

                  return (

                    <div style={{ marginBottom: '1.5rem' }}>

                      <h4 style={{ margin: '0 0 0.75rem', fontSize: '0.95rem', color: '#1f2937' }}>Commission by Period</h4>

                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '0.75rem' }}>

                        {periods.map(([pd, data]) => {

                          const label = pd !== 'Unknown' ? new Date(pd + 'T00:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : 'Unknown';

                          const isPaid = !!data.paid;

                          return (

                            <div key={pd} style={{

                              background: '#fff', borderRadius: '12px', padding: '1rem',

                              border: `1px solid ${isPaid ? '#bbf7d0' : '#fde68a'}`,

                              borderLeft: `4px solid ${isPaid ? '#16a34a' : '#f59e0b'}`,

                            }}>

                              <p style={{ margin: 0, fontSize: '0.75rem', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Payout {label}</p>

                              <p style={{ margin: '6px 0 4px', fontSize: '1.4rem', fontWeight: '800', color: '#16a34a' }}>

                                ${(data.commission / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}

                              </p>

                              <p style={{ margin: 0, fontSize: '0.78rem', color: '#6b7280' }}>

                                {data.count} order{data.count !== 1 ? 's' : ''} &middot;{' '}

                                <span style={{ fontWeight: '600', color: isPaid ? '#16a34a' : '#f59e0b' }}>

                                  {isPaid ? 'Paid' : 'Pending'}

                                </span>

                              </p>

                            </div>

                          );

                        })}

                      </div>

                    </div>

                  );

                })()}



                {/* Download Social Media Assets Banner */}

                <div style={{

                  width: '593px', maxWidth: '100%', height: '119px',

                  backgroundColor: '#EDFCF2', borderRadius: '12px',

                  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',

                  margin: '0 auto 1.5rem', gap: '0.5rem'

                }}>

                  <p style={{ margin: 0, fontSize: '0.95rem', fontWeight: '600', color: '#1f2937' }}>

                    We've made sharing easy for you

                  </p>

                  <button

                    onClick={() => setActiveSection('social-media')}

                    style={{

                      padding: '0.55rem 1.75rem', backgroundColor: '#fff', color: '#1f2937',

                      border: '2px solid #1f2937', borderRadius: '999px', cursor: 'pointer',

                      fontSize: '0.9rem', fontWeight: '600', transition: 'all 0.15s'

                    }}

                  >

                    Download Social Media Assets

                  </button>

                </div>



                {/* Zelle payout details */}

                <div style={{

                  background: '#fff', borderRadius: '12px', padding: '1.25rem',

                  border: '1px solid #e2e8f0', marginBottom: '1.5rem',

                  boxShadow: '0 1px 3px rgba(0,0,0,0.06)'

                }}>

                  <h4 style={{ margin: '0 0 0.5rem', fontSize: '0.95rem', color: '#1f2937' }}>Provide your Zelle Email or Phone Number.</h4>

                  <p style={{ margin: '0 0 0.75rem', fontSize: '0.82rem', color: '#6b7280' }}>

                    Enter the email address or phone number associated with your Zelle account for timely payouts.

                  </p>

                  <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>

                    <input

                      type="email"

                      value={zelleEmail}

                      onChange={e => { setZelleEmail(e.target.value); setZelleEmailMsg({ type: '', text: '' }); }}

                      placeholder="your-zelle@email.com"

                      style={{

                        flex: 1, padding: '0.6rem 0.75rem', border: '1px solid #d1d5db',

                        borderRadius: '8px', fontSize: '0.9rem', outline: 'none'

                      }}

                    />

                    <input

                      type="tel"

                      value={zellePhone}

                      onChange={e => { setZellePhone(formatZellePhoneInput(e.target.value)); setZelleEmailMsg({ type: '', text: '' }); }}

                      placeholder="(xxx) xxx-xxxx"

                      style={{

                        flex: 1, padding: '0.6rem 0.75rem', border: '1px solid #d1d5db',

                        borderRadius: '8px', fontSize: '0.9rem', outline: 'none', minWidth: '220px'

                      }}

                    />

                    <button

                      onClick={async () => {

                        setZelleEmailSaving(true);

                        setZelleEmailMsg({ type: '', text: '' });

                        const phoneDigits = zellePhone.replace(/\D/g, '');

                        if (zellePhone && phoneDigits.length !== 10) {

                          setZelleEmailMsg({ type: 'error', text: 'Please enter a valid 10-digit phone number.' });

                          setZelleEmailSaving(false);

                          return;

                        }

                        try {

                          const res = await api.updateMyAffiliateInfo({ zelle_email: zelleEmail, zelle_phone: zellePhone });

                          if (res?.success) {

                            setZelleEmailMsg({ type: 'success', text: 'Zelle details saved!' });

                            setAffiliateInfo(prev => ({ ...prev, zelle_email: zelleEmail, zelle_phone: zellePhone }));

                          } else {

                            setZelleEmailMsg({ type: 'error', text: res?.error?.message || 'Failed to save' });

                          }

                        } catch (err) {

                          setZelleEmailMsg({ type: 'error', text: 'Failed to save Zelle details' });

                        } finally {

                          setZelleEmailSaving(false);

                        }

                      }}

                      disabled={zelleEmailSaving}

                      style={{

                        padding: '0.6rem 1.25rem', background: '#16a34a', color: '#fff',

                        border: 'none', borderRadius: '8px', fontWeight: '600',

                        cursor: zelleEmailSaving ? 'not-allowed' : 'pointer', fontSize: '0.85rem',

                        whiteSpace: 'nowrap'

                      }}

                    >

                      {zelleEmailSaving ? 'Saving...' : 'Save'}

                    </button>

                  </div>

                  {zelleEmailMsg.text && (

                    <p style={{

                      margin: '0.5rem 0 0', fontSize: '0.82rem',

                      color: zelleEmailMsg.type === 'success' ? '#16a34a' : '#dc2626'

                    }}>

                      {zelleEmailMsg.text}

                    </p>

                  )}

                </div>



                {(() => {

                  const allOrders = affiliateInfo.orders || [];

                  const totalOrders = allOrders.length;

                  const totalPages = Math.ceil(totalOrders / AFFILIATE_ORDERS_PER_PAGE);

                  const startIdx = (affiliateOrdersPage - 1) * AFFILIATE_ORDERS_PER_PAGE;

                  const pageOrders = allOrders.slice(startIdx, startIdx + AFFILIATE_ORDERS_PER_PAGE);

                  const showingEnd = Math.min(startIdx + AFFILIATE_ORDERS_PER_PAGE, totalOrders);



                  return (

                    <div style={{

                      background: '#fff', borderRadius: '12px', padding: '1.25rem',

                      border: '1px solid #e2e8f0', marginBottom: '1.5rem',

                      boxShadow: '0 1px 3px rgba(0,0,0,0.06)'

                    }}>

                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '0.75rem', marginBottom: '0.85rem', flexWrap: 'wrap' }}>

                        <div>

                          <h4 style={{ margin: 0, fontSize: '0.98rem', color: '#1f2937' }}>Orders Table</h4>

                          <p style={{ margin: '0.3rem 0 0', fontSize: '0.82rem', color: '#6b7280' }}>Track the customers and commission generated by your promo code.</p>

                        </div>

                        {totalOrders > AFFILIATE_ORDERS_PER_PAGE && (

                          <span style={{ fontSize: '0.78rem', color: '#9ca3af', fontWeight: '500' }}>

                            {startIdx + 1}–{showingEnd} of {totalOrders} orders

                          </span>

                        )}

                      </div>



                      {totalOrders > 0 ? (

                        <>

                          <div style={{ overflowX: 'auto', border: '1px solid #eef2f7', borderRadius: '10px' }}>

                            <table style={{ width: '100%', fontSize: '0.78rem', borderCollapse: 'collapse', minWidth: '960px' }}>

                              <thead>

                                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e5e7eb' }}>

                                  <th style={{ padding: '0.5rem 0.55rem', textAlign: 'left', color: '#64748b', fontWeight: '700', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Date</th>

                                  <th style={{ padding: '0.5rem 0.55rem', textAlign: 'left', color: '#64748b', fontWeight: '700', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Customer Name</th>

                                  <th style={{ padding: '0.5rem 0.55rem', textAlign: 'left', color: '#64748b', fontWeight: '700', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Order #</th>

                                  <th style={{ padding: '0.5rem 0.55rem', textAlign: 'left', color: '#64748b', fontWeight: '700', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Status</th>

                                  <th style={{ padding: '0.5rem 0.55rem', textAlign: 'right', color: '#64748b', fontWeight: '700', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Order Total</th>

                                  <th style={{ padding: '0.5rem 0.55rem', textAlign: 'right', color: '#64748b', fontWeight: '700', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Subtotal Revenue</th>

                                  <th style={{ padding: '0.5rem 0.55rem', textAlign: 'right', color: '#64748b', fontWeight: '700', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Commission</th>

                                  <th style={{ padding: '0.5rem 0.55rem', textAlign: 'right', color: '#64748b', fontWeight: '700', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Payout Date</th>

                                  <th style={{ padding: '0.5rem 0.55rem', textAlign: 'right', color: '#64748b', fontWeight: '700', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Date Paid</th>

                                </tr>

                              </thead>

                              <tbody>

                                {pageOrders.map((order, idx) => (

                                  <tr key={order.id} style={{ borderBottom: idx === pageOrders.length - 1 ? 'none' : '1px solid #f1f5f9' }}>

                                    <td style={{ padding: '0.5rem 0.55rem', whiteSpace: 'nowrap', color: '#1f2937' }}>

                                      {order.created_at ? new Date(order.created_at).toLocaleDateString() : '—'}

                                    </td>

                                    <td style={{ padding: '0.5rem 0.55rem', color: '#1f2937', maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={order.buyer_email || order.buyer_name || ''}>

                                      {order.buyer_name || '—'}

                                    </td>

                                    <td style={{ padding: '0.5rem 0.55rem' }}>

                                      <span style={{ display: 'inline-block', fontFamily: 'monospace', fontSize: '0.72rem', color: '#047857', background: '#ecfdf5', border: '1px solid #bbf7d0', borderRadius: '6px', padding: '0.18rem 0.4rem' }}>

                                        {order.order_number || '—'}

                                      </span>

                                    </td>

                                    <td style={{ padding: '0.5rem 0.55rem', whiteSpace: 'nowrap' }}>

                                      <span style={{

                                        display: 'inline-flex',

                                        alignItems: 'center',

                                        justifyContent: 'center',

                                        padding: '0.22rem 0.5rem',

                                        borderRadius: '999px',

                                        fontSize: '0.68rem',

                                        fontWeight: '700',

                                        whiteSpace: 'nowrap',

                                        background: order.status === 'REFUNDED'

                                          ? '#fee2e2'

                                          : order.status === 'PARTIALLY_REFUNDED'

                                            ? '#ffedd5'

                                            : '#dcfce7',

                                        color: order.status === 'REFUNDED'

                                          ? '#991b1b'

                                          : order.status === 'PARTIALLY_REFUNDED'

                                            ? '#9a3412'

                                            : '#166534'

                                      }}>

                                        {order.status === 'REFUNDED'

                                          ? 'Refunded'

                                          : order.status === 'PARTIALLY_REFUNDED'

                                            ? 'Partially Refunded'

                                            : 'Paid'}

                                      </span>

                                    </td>

                                    <td style={{ padding: '0.5rem 0.55rem', textAlign: 'right', color: '#1f2937', fontWeight: '600', whiteSpace: 'nowrap' }}>

                                      ${((order.order_total_cents || order.total_cents || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}

                                    </td>

                                    <td style={{ padding: '0.5rem 0.55rem', textAlign: 'right', color: '#1f2937', fontWeight: '600', whiteSpace: 'nowrap' }}>

                                      ${((order.revenue_cents || order.total_cents || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}

                                    </td>

                                    <td style={{ padding: '0.5rem 0.55rem', textAlign: 'right', color: order.status === 'REFUNDED' || order.status === 'PARTIALLY_REFUNDED' ? '#6b7280' : '#16a34a', fontWeight: '700', whiteSpace: 'nowrap' }}>

                                      ${((order.commission_cents || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}

                                    </td>

                                    <td style={{ padding: '0.5rem 0.55rem', textAlign: 'right', color: '#1f2937', whiteSpace: 'nowrap', fontSize: '0.76rem' }}>

                                      {order.payout_date ? new Date(order.payout_date + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—'}

                                    </td>

                                    <td style={{ padding: '0.5rem 0.55rem', textAlign: 'right', whiteSpace: 'nowrap', fontSize: '0.76rem', color: order.date_paid ? '#16a34a' : '#9ca3af', fontWeight: order.date_paid ? '600' : '400' }}>

                                      {order.date_paid ? new Date(order.date_paid).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Pending'}

                                    </td>

                                  </tr>

                                ))}

                              </tbody>

                            </table>

                          </div>

                          {totalPages > 1 && (

                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.4rem', marginTop: '0.9rem', flexWrap: 'wrap' }}>

                              <button

                                onClick={() => setAffiliateOrdersPage(p => Math.max(1, p - 1))}

                                disabled={affiliateOrdersPage === 1}

                                style={{ padding: '0.38rem 0.75rem', fontSize: '0.78rem', border: '1px solid #d1d5db', borderRadius: '8px', background: '#fff', cursor: affiliateOrdersPage === 1 ? 'not-allowed' : 'pointer', color: affiliateOrdersPage === 1 ? '#cbd5e1' : '#374151', fontWeight: '600' }}

                              >Prev</button>

                              {Array.from({ length: totalPages }, (_, i) => i + 1).map(pg => (

                                <button

                                  key={pg}

                                  onClick={() => setAffiliateOrdersPage(pg)}

                                  style={{ padding: '0.38rem 0.68rem', minWidth: '34px', fontSize: '0.78rem', border: '1px solid', borderColor: pg === affiliateOrdersPage ? '#16a34a' : '#d1d5db', borderRadius: '8px', background: pg === affiliateOrdersPage ? '#16a34a' : '#fff', color: pg === affiliateOrdersPage ? '#fff' : '#374151', cursor: 'pointer', fontWeight: '700' }}

                                >{pg}</button>

                              ))}

                              <button

                                onClick={() => setAffiliateOrdersPage(p => Math.min(totalPages, p + 1))}

                                disabled={affiliateOrdersPage === totalPages}

                                style={{ padding: '0.38rem 0.75rem', fontSize: '0.78rem', border: '1px solid #d1d5db', borderRadius: '8px', background: '#fff', cursor: affiliateOrdersPage === totalPages ? 'not-allowed' : 'pointer', color: affiliateOrdersPage === totalPages ? '#cbd5e1' : '#374151', fontWeight: '600' }}

                              >Next</button>

                            </div>

                          )}

                        </>

                      ) : (

                        <div style={{ border: '1px dashed #d1d5db', borderRadius: '10px', padding: '1.2rem', textAlign: 'center', color: '#9ca3af', fontSize: '0.88rem' }}>

                          No coupon orders yet.

                        </div>

                      )}

                    </div>

                  );

                })()}



                {/* Payout Note */}

                <p style={{ fontSize: '0.82rem', color: '#9ca3af', fontStyle: 'italic', marginBottom: '1.5rem', textAlign: 'center' }}>

                  *Payout is immediate, but it may take 5-10 business days to arrive in your bank account

                </p>



                {/* Payout Structure Table */}

                <div style={{

                  background: '#fff', borderRadius: '12px', padding: '1.25rem',

                  border: '1px solid #e2e8f0', marginBottom: '2rem',

                  boxShadow: '0 1px 3px rgba(0,0,0,0.06)'

                }}>

                  <h4 style={{ margin: '0 0 0.75rem', fontSize: '0.95rem', color: '#1f2937' }}>Payout Structure</h4>

                  <p style={{ margin: '0 0 0.75rem', fontSize: '0.82rem', color: '#6b7280' }}>

                    Payouts are processed bi-weekly — 2 payout periods per month.

                  </p>

                  <div style={{ overflowX: 'auto' }}>

                    <table style={{ width: '100%', fontSize: '0.85rem', borderCollapse: 'collapse' }}>

                      <thead>

                        <tr style={{ borderBottom: '2px solid #e5e7eb' }}>

                          <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', color: '#6b7280', fontWeight: '600', fontSize: '0.8rem' }}>Period</th>

                          <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', color: '#6b7280', fontWeight: '600', fontSize: '0.8rem' }}>Covers Orders From</th>

                          <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', color: '#6b7280', fontWeight: '600', fontSize: '0.8rem' }}>Payout Date</th>

                        </tr>

                      </thead>

                      <tbody>

                        <tr style={{ borderBottom: '1px solid #f0f0f0' }}>

                          <td style={{ padding: '0.6rem 0.75rem', fontWeight: '600', color: '#1f2937' }}>1st Period</td>

                          <td style={{ padding: '0.6rem 0.75rem', color: '#1f2937' }}>1st – 15th of the month</td>

                          <td style={{ padding: '0.6rem 0.75rem', color: '#1f2937' }}>On or around the 15th</td>

                        </tr>

                        <tr style={{ borderBottom: '1px solid #f0f0f0' }}>

                          <td style={{ padding: '0.6rem 0.75rem', fontWeight: '600', color: '#1f2937' }}>2nd Period</td>

                          <td style={{ padding: '0.6rem 0.75rem', color: '#1f2937' }}>16th – Last day of the month</td>

                          <td style={{ padding: '0.6rem 0.75rem', color: '#1f2937' }}>On or around the last day</td>

                        </tr>

                      </tbody>

                    </table>

                  </div>

                </div>



                {/* Payout History Table */}

                <div style={{

                  background: '#fff', borderRadius: '12px', padding: '1.25rem',

                  border: '1px solid #e2e8f0', marginBottom: '2rem',

                  boxShadow: '0 1px 3px rgba(0,0,0,0.06)'

                }}>

                  <h4 style={{ margin: '0 0 0.75rem', fontSize: '0.95rem', color: '#1f2937' }}>Payout History</h4>

                  {affiliatePayouts.length > 0 ? (

                    <div style={{ overflowX: 'auto' }}>

                      <table style={{ width: '100%', fontSize: '0.85rem', borderCollapse: 'collapse' }}>

                        <thead>

                          <tr style={{ borderBottom: '2px solid #e5e7eb' }}>

                            <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', whiteSpace: 'nowrap', color: '#6b7280', fontWeight: '600', fontSize: '0.8rem' }}>Payout Period</th>

                            <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', whiteSpace: 'nowrap', color: '#6b7280', fontWeight: '600', fontSize: '0.8rem' }}>Payout Date</th>

                            <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', whiteSpace: 'nowrap', color: '#6b7280', fontWeight: '600', fontSize: '0.8rem' }}>Date Paid</th>

                            <th style={{ padding: '0.5rem 0.75rem', textAlign: 'right', whiteSpace: 'nowrap', color: '#6b7280', fontWeight: '600', fontSize: '0.8rem' }}>Total Payout This Period</th>

                          </tr>

                        </thead>

                        <tbody>

                          {affiliatePayouts.map(p => (

                            <tr key={p.id} style={{ borderBottom: '1px solid #f0f0f0' }}>

                              <td style={{ padding: '0.6rem 0.75rem', whiteSpace: 'nowrap', fontSize: '0.83rem', color: '#1f2937', fontWeight: '600' }}>

                                {new Date(p.period_start + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} – {new Date(p.period_end + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}

                              </td>

                              <td style={{ padding: '0.6rem 0.75rem', fontSize: '0.83rem', whiteSpace: 'nowrap', color: '#1f2937' }}>

                                {new Date(p.period_end + 'T00:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}

                              </td>

                              <td style={{ padding: '0.6rem 0.75rem', fontSize: '0.83rem', whiteSpace: 'nowrap', color: '#16a34a', fontWeight: '600' }}>

                                {p.paid_at ? new Date(p.paid_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : '—'}

                              </td>

                              <td style={{ padding: '0.6rem 0.75rem', textAlign: 'right', fontWeight: '700', color: '#16a34a', fontSize: '0.9rem' }}>

                                ${Number(p.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}

                              </td>

                            </tr>

                          ))}

                        </tbody>

                      </table>

                    </div>

                  ) : (

                    <div style={{ border: '1px dashed #d1d5db', borderRadius: '10px', padding: '1.2rem', textAlign: 'center', color: '#9ca3af', fontSize: '0.88rem' }}>

                      No payouts yet. Payouts are processed bi-weekly on the 15th and last day of each month.

                    </div>

                  )}

                </div>



                {/* Terms & Conditions */}

                <div style={{

                  backgroundColor: '#F8F9FA', borderRadius: '12px', padding: '1.5rem',

                  boxShadow: '0 1px 3px rgba(0,0,0,0.06)'

                }}>

                  <h3 style={{ textAlign: 'center', fontSize: '1.25rem', fontWeight: '700', color: '#1f2937', marginBottom: '1.5rem' }}>Terms & Conditions</h3>



                  <div style={{ fontSize: '0.88rem', color: '#374151', lineHeight: '1.7' }}>

                    <p style={{ margin: '0 0 0.25rem' }}><strong>1. Eligibility & Approval</strong></p>

                    <p style={{ margin: '0 0 1rem' }}>Participation is by approval only. OC MENA Festival may accept or decline any application at its sole discretion.</p>



                    <p style={{ margin: '0 0 0.25rem' }}><strong>2. Promo Codes & Attribution</strong></p>

                    <p style={{ margin: '0 0 1rem' }}>Affiliates receive a unique promo code (&ldquo;Code&rdquo;). Commission is earned only on orders where the Code is successfully applied at checkout. Codes may not be combined with other promotions unless explicitly authorized.</p>



                    <p style={{ margin: '0 0 0.25rem' }}><strong>3. Commission & Payment</strong></p>

                    <p style={{ margin: '0 0 1rem' }}>Commission rates are assigned by OC MENA Festival and may vary by affiliate. Commissions are calculated on qualifying ticket revenue (excluding taxes, fees, chargebacks, and refunded orders). Payments are issued after the event or on a schedule determined by OC MENA Festival, subject to a minimum payout threshold (e.g., $100).</p>



                    <p style={{ margin: '0 0 0.25rem' }}><strong>4. Refunds, Chargebacks & Cancellations</strong></p>

                    <p style={{ margin: '0 0 1rem' }}>Orders that are refunded, canceled, disputed, or charged back are not commissionable. Any commissions previously credited for such orders may be reversed.</p>



                    <p style={{ margin: '0 0 0.25rem' }}><strong>5. Prohibited Conduct</strong></p>

                    <p style={{ margin: '0 0 0.5rem' }}>Affiliates may not:</p>

                    <p style={{ margin: '0 0 0.35rem', paddingLeft: '0.5rem' }}>Use misleading claims, false scarcity, or impersonation</p>

                    <p style={{ margin: '0 0 0.35rem', paddingLeft: '0.5rem' }}>Buy ads bidding on OC MENA trademarks or brand terms without written approval</p>

                    <p style={{ margin: '0 0 0.35rem', paddingLeft: '0.5rem' }}>Use spam, purchased lists, or automated messaging in violation of platform policies</p>

                    <p style={{ margin: '0 0 0.35rem', paddingLeft: '0.5rem' }}>Use their own Code for personal purchases (optional rule, but recommended)</p>

                    <p style={{ margin: '0 0 1rem', paddingLeft: '0.5rem' }}>Offer unauthorized discounts or promises</p>



                    <p style={{ margin: '0 0 0.25rem' }}><strong>6. Brand Guidelines</strong></p>

                    <p style={{ margin: '0 0 1rem' }}>Affiliates agree to represent OC MENA Festival in a professional manner consistent with festival branding and community values.</p>



                    <p style={{ margin: '0 0 0.25rem' }}><strong>7. Termination</strong></p>

                    <p style={{ margin: '0 0 1rem' }}>OC MENA Festival may suspend or terminate participation at any time, with or without notice, including for suspected fraud or policy violations. Upon termination, unused Codes may be disabled and unpaid commissions may be withheld in cases of fraud or abuse.</p>



                    <p style={{ margin: '0 0 0.25rem' }}><strong>8. Changes to Program</strong></p>

                    <p style={{ margin: 0 }}>OC MENA Festival may modify commission rates, policies, or program structure at any time.</p>

                  </div>

                </div>

              </div>

            ) : (

              <div style={{ textAlign: 'center', padding: '3rem 1rem' }}>

                <p style={{ fontSize: '1.1rem', color: '#374151', fontWeight: '600', marginBottom: '0.5rem' }}>Affiliate Program</p>

                <p style={{ fontSize: '0.9rem', color: '#6b7280', marginBottom: '0.75rem', maxWidth: '520px', margin: '0 auto 1rem', lineHeight: '1.6' }}>

                  Join the OC MENA Festival Affiliate Program and earn commission by sharing your custom promo code with your audience. We partner with creators, community leaders, and cultural ambassadors who align with our mission.

                </p>

                <a href="/partners" style={{

                  display: 'inline-block', padding: '0.75rem 2rem', backgroundColor: '#16a34a', color: '#fff',

                  borderRadius: '8px', textDecoration: 'none', fontWeight: '600', fontSize: '1rem'

                }}>

                  Apply Now

                </a>

              </div>

            )}

          </div>

        );



      case 'logout':



        handleLogout();



        return (



          <div className="content-section">



            <h2 className="section-title">Logging out...</h2>



          </div>



        );



      default:



        return null;



    }



  };







  return (



    <div className="page-wrapper">



      <AnnouncementBar />







      <section className="hero-section">



        <div className="hero-background-wrapper">



          <video src={"/hero-final.mp4"} alt="OC MENA Festival" className="hero-background-video" autoPlay muted loop playsInline />



          <div className="hero-gradient-overlay"></div>



        </div>







        <TornPaperWrapper>



          <div className="dashboard-page-header">



            <h1 className="dashboard-title">My Account</h1>



            <button



              className="mobile-menu-toggle"



              onClick={() => setIsSidebarOpen(!isSidebarOpen)}



            >



              <img loading="lazy" src={getCmsImagePath('angleDownIcon', '/angle-down-regular.svg')} alt="Menu" style={{ width: '14px', height: '14px', transform: isSidebarOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }} />



            </button>



          </div>







          {loading ? (

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '60px 0', width: '100%' }}>

              <div style={{ textAlign: 'center', color: '#555' }}>

                <div style={{ width: '36px', height: '36px', border: '3px solid #e5e7eb', borderTopColor: '#dc2626', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 12px' }} />

                <p style={{ fontSize: '14px', fontWeight: '500' }}>Loading your dashboard...</p>

              </div>

              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

            </div>

          ) : (

            <div className={`dashboard-wrapper ${isSidebarOpen ? 'sidebar-open' : ''}`}>



              <aside className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>



                <nav className="sidebar-nav">



                  {menuItems.map(item => (



                    <button



                      key={item.id}



                      className={`nav-item ${activeSection === item.id ? 'active' : ''}`}



                      onClick={() => {



                        setActiveSection(item.id);



                        setIsSidebarOpen(false);



                      }}



                    >



                      {item.label}



                    </button>



                  ))}



                </nav>



              </aside>







              <main className="dashboard-content">



                {renderContent()}



              </main>



            </div>

          )}



        </TornPaperWrapper>







        <div className="lanterns-container">



          <img loading="lazy" src={getCmsImagePath("lanterns", "/lanterns.webp")} alt="Festival Lanterns" className="lanterns-image" />



        </div>



      </section>







      <Footer />



      <ScrollToTop />







      {/* Transfer Modal */}



      {transferModal.open && (



        <div



          style={{



            position: 'fixed',



            top: 0,



            left: 0,



            right: 0,



            bottom: 0,



            backgroundColor: 'rgba(0,0,0,0.5)',



            display: 'flex',



            alignItems: 'center',



            justifyContent: 'center',



            zIndex: 1000



          }}



          onClick={(e) => {



            if (e.target === e.currentTarget) {



              setTransferModal({ open: false, ticket: null, tickets: [] });



            }



          }}



        >



          <div



            style={{



              backgroundColor: 'white',



              borderRadius: '12px',



              padding: '2rem',



              maxWidth: '500px',



              width: '90%',



              boxShadow: '0 20px 40px rgba(0,0,0,0.3)'



            }}



            onClick={(e) => e.stopPropagation()}



          >



            <h2 style={{ margin: '0 0 0.5rem 0', fontSize: '24px', fontWeight: '700', color: '#1a1a1a' }}>

              {(transferModal.tickets?.length || 1) > 1 ? `Transfer ${transferModal.tickets.length} Tickets` : 'Transfer Ticket'}

            </h2>



            <p style={{ color: '#666', marginBottom: '0.5rem' }}>



              {(transferModal.tickets?.length || 1) > 1

                ? <>Transfer all <strong>{transferModal.tickets.length} tickets</strong> in your <strong>{transferModal.ticket?.ticket_type_name}</strong> to another person</>

                : <>Transfer <strong>{transferModal.ticket?.ticket_type_name}</strong> to another person</>}



            </p>



            <div style={{
              display: 'inline-block', padding: '0.25rem 0.75rem', borderRadius: '20px', fontSize: '0.75rem', fontWeight: '600', marginBottom: '1rem',

              backgroundColor: transferModal.ticket?.ticket_type_name?.toLowerCase().includes('amphitheater') || transferModal.ticket?.ticket_type_name?.toLowerCase().includes('pacific') ? '#ede9fe' : '#dbeafe',

              color: transferModal.ticket?.ticket_type_name?.toLowerCase().includes('amphitheater') || transferModal.ticket?.ticket_type_name?.toLowerCase().includes('pacific') ? '#6b21a8' : '#1e40af'

            }}>

              {transferModal.ticket?.ticket_type_name?.toLowerCase().includes('amphitheater') || transferModal.ticket?.ticket_type_name?.toLowerCase().includes('pacific') ? '🎭 Amphitheater Ticket' : '🎪 Festival Ticket'}

            </div>







            {transferSuccess ? (



              <>



                <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>



                  <div style={{ fontSize: '18px', fontWeight: '600', color: '#166534', marginBottom: '1rem' }}>Transfer successful!</div>



                  <p style={{ fontSize: '14px', color: '#666', marginBottom: '1.5rem' }}>Please review the details below. Once transferred, this ticket will no longer be accessible from your account.</p>



                </div>







                <div style={{ backgroundColor: '#f9fafb', padding: '1rem', borderRadius: '8px', marginBottom: '1.5rem' }}>



                  {/* Removed recipient name display */}



                  <div>



                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '0.25rem' }}>Recipient Email:</div>



                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>{transferEmail}</div>



                  </div>



                </div>







                <button



                  onClick={() => {



                    setTransferModal({ open: false, ticket: null, tickets: [] });



                    setTransferSuccess(false);



                    setTransferEmail('');



                    setTransferLabel('');



                    setTransferError('');



                  }}



                  style={{



                    width: '100%',



                    padding: '0.75rem',



                    border: 'none',



                    borderRadius: '8px',



                    backgroundColor: '#3b82f6',



                    color: 'white',



                    cursor: 'pointer',



                    fontWeight: '600',



                    fontSize: '14px',



                    transition: 'all 0.2s'



                  }}



                >



                  Close



                </button>



              </>



            ) : (



              <div>



                <div style={{ marginBottom: '15px' }}>



                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>Recipient's Email</label>



                  <input



                    type="email"



                    value={transferEmail}



                    onChange={(e) => setTransferEmail(e.target.value)}



                    placeholder="Enter recipient's email"



                    disabled={transferLoading}



                    style={{



                      width: '100%',



                      padding: '10px',



                      border: '1px solid #ddd',



                      borderRadius: '4px',



                      fontSize: '14px'



                    }}



                  />



                </div>



                <div style={{ marginBottom: '15px' }}>

                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>Gift Label <span style={{ color: '#999', fontWeight: '400' }}>(optional)</span></label>

                  <input

                    type="text"

                    value={transferLabel}

                    onChange={(e) => setTransferLabel(e.target.value)}

                    placeholder="e.g. Happy Birthday! From Sarah"

                    maxLength={60}

                    disabled={transferLoading}

                    style={{

                      width: '100%',

                      padding: '10px',

                      border: '1px solid #ddd',

                      borderRadius: '4px',

                      fontSize: '14px'

                    }}

                  />

                </div>



                {transferError && (



                  <div style={{ padding: '0.75rem', backgroundColor: '#fee2e2', borderRadius: '6px', color: '#991b1b', marginBottom: '1rem' }}>



                    {transferError}



                  </div>



                )}







                <div style={{ display: 'flex', gap: '1rem' }}>



                  <button



                    onClick={(e) => {



                      e.preventDefault();



                      e.stopPropagation();



                      setTransferModal({ open: false, ticket: null, tickets: [] });



                    }}



                    style={{



                      flex: 1,



                      padding: '0.75rem',



                      border: '2px solid #e5e7eb',



                      borderRadius: '8px',



                      backgroundColor: 'white',



                      color: '#374151',



                      cursor: 'pointer',



                      fontWeight: '600',



                      fontSize: '14px',



                      transition: 'all 0.2s'



                    }}



                  >



                    Cancel



                  </button>



                  <button



                    onClick={(e) => {



                      e.preventDefault();



                      e.stopPropagation();



                      handleTransfer();



                    }}



                    disabled={transferLoading || !transferEmail}



                    style={{



                      flex: 1,



                      padding: '0.75rem',



                      border: 'none',



                      borderRadius: '8px',



                      backgroundColor: transferLoading || !transferEmail ? '#9ca3af' : '#3b82f6',



                      color: 'white',



                      cursor: transferLoading || !transferEmail ? 'not-allowed' : 'pointer',



                      fontWeight: '600',



                      fontSize: '14px',



                      transition: 'all 0.2s'



                    }}



                  >



                    {transferLoading ? 'Transferring...' : 'Transfer'}



                  </button>



                </div>



              </div>



            )}



          </div>



        </div>



      )}



    </div>



  );



};







export default Dashboard;



